function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import * as preact from 'preact';
import { Component, createElement, isValidElement, Fragment } from 'preact';
import { createPortal } from 'preact/compat';
var styleTexts = [];
var styleEls = new Map();

function injectStyles(styleText) {
  styleTexts.push(styleText);
  styleEls.forEach(function (styleEl) {
    appendStylesTo(styleEl, styleText);
  });
}

function ensureElHasStyles(el) {
  if (el.isConnected) {
    registerStylesRoot(el.getRootNode());
  }
}

function registerStylesRoot(rootNode) {
  var styleEl = styleEls.get(rootNode);

  if (!styleEl || !styleEl.isConnected) {
    styleEl = rootNode.querySelector('style[data-fullcalendar]');

    if (!styleEl) {
      styleEl = document.createElement('style');
      styleEl.setAttribute('data-fullcalendar', '');
      var nonce = getNonceValue();

      if (nonce) {
        styleEl.nonce = nonce;
      }

      var parentEl = rootNode === document ? document.head : rootNode;
      var insertBefore = rootNode === document ? parentEl.querySelector('script,link[rel=stylesheet],link[as=style],style') : parentEl.firstChild;
      parentEl.insertBefore(styleEl, insertBefore);
    }

    styleEls.set(rootNode, styleEl);
    hydrateStylesRoot(styleEl);
  }
}

function hydrateStylesRoot(styleEl) {
  var _iterator = _createForOfIteratorHelper(styleTexts),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var styleText = _step.value;
      appendStylesTo(styleEl, styleText);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
}

function appendStylesTo(styleEl, styleText) {
  var sheet = styleEl.sheet;
  var ruleCnt = sheet.cssRules.length;
  styleText.split('}').forEach(function (styleStr, i) {
    styleStr = styleStr.trim();

    if (styleStr) {
      sheet.insertRule(styleStr + '}', ruleCnt + i);
    }
  });
} // nonce
// -------------------------------------------------------------------------------------------------


var queriedNonceValue;

function getNonceValue() {
  if (queriedNonceValue === undefined) {
    queriedNonceValue = queryNonceValue();
  }

  return queriedNonceValue;
}
/*
TODO: discourage meta tag and instead put nonce attribute on placeholder <style> tag
*/


function queryNonceValue() {
  var metaWithNonce = document.querySelector('meta[name="csp-nonce"]');

  if (metaWithNonce && metaWithNonce.hasAttribute('content')) {
    return metaWithNonce.getAttribute('content');
  }

  var elWithNonce = document.querySelector('script[nonce]');

  if (elWithNonce) {
    return elWithNonce.nonce || '';
  }

  return '';
} // main
// -------------------------------------------------------------------------------------------------


if (typeof document !== 'undefined') {
  registerStylesRoot(document);
}

var css_248z = ":root{--fc-small-font-size:.85em;--fc-page-bg-color:#fff;--fc-neutral-bg-color:hsla(0,0%,82%,.3);--fc-neutral-text-color:grey;--fc-border-color:#ddd;--fc-button-text-color:#fff;--fc-button-bg-color:#2c3e50;--fc-button-border-color:#2c3e50;--fc-button-hover-bg-color:#1e2b37;--fc-button-hover-border-color:#1a252f;--fc-button-active-bg-color:#1a252f;--fc-button-active-border-color:#151e27;--fc-event-bg-color:#3788d8;--fc-event-border-color:#3788d8;--fc-event-text-color:#fff;--fc-event-selected-overlay-color:rgba(0,0,0,.25);--fc-more-link-bg-color:#d0d0d0;--fc-more-link-text-color:inherit;--fc-event-resizer-thickness:8px;--fc-event-resizer-dot-total-width:8px;--fc-event-resizer-dot-border-width:1px;--fc-non-business-color:hsla(0,0%,84%,.3);--fc-bg-event-color:#8fdf82;--fc-bg-event-opacity:0.3;--fc-highlight-color:rgba(188,232,241,.3);--fc-today-bg-color:rgba(255,220,40,.15);--fc-now-indicator-color:red}.fc-not-allowed,.fc-not-allowed .fc-event{cursor:not-allowed}.fc{display:flex;flex-direction:column;font-size:1em}.fc,.fc *,.fc :after,.fc :before{box-sizing:border-box}.fc table{border-collapse:collapse;border-spacing:0;font-size:1em}.fc th{text-align:center}.fc td,.fc th{padding:0;vertical-align:top}.fc a[data-navlink]{cursor:pointer}.fc a[data-navlink]:hover{text-decoration:underline}.fc-direction-ltr{direction:ltr;text-align:left}.fc-direction-rtl{direction:rtl;text-align:right}.fc-theme-standard td,.fc-theme-standard th{border:1px solid var(--fc-border-color)}.fc-liquid-hack td,.fc-liquid-hack th{position:relative}@font-face{font-family:fcicons;font-style:normal;font-weight:400;src:url(\"data:application/x-font-ttf;charset=utf-8;base64,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\") format(\"truetype\")}.fc-icon{speak:none;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;display:inline-block;font-family:fcicons!important;font-style:normal;font-variant:normal;font-weight:400;height:1em;line-height:1;text-align:center;text-transform:none;-webkit-user-select:none;-moz-user-select:none;user-select:none;width:1em}.fc-icon-chevron-left:before{content:\"\\e900\"}.fc-icon-chevron-right:before{content:\"\\e901\"}.fc-icon-chevrons-left:before{content:\"\\e902\"}.fc-icon-chevrons-right:before{content:\"\\e903\"}.fc-icon-minus-square:before{content:\"\\e904\"}.fc-icon-plus-square:before{content:\"\\e905\"}.fc-icon-x:before{content:\"\\e906\"}.fc .fc-button{border-radius:0;font-family:inherit;font-size:inherit;line-height:inherit;margin:0;overflow:visible;text-transform:none}.fc .fc-button:focus{outline:1px dotted;outline:5px auto -webkit-focus-ring-color}.fc .fc-button{-webkit-appearance:button}.fc .fc-button:not(:disabled){cursor:pointer}.fc .fc-button{background-color:transparent;border:1px solid transparent;border-radius:.25em;display:inline-block;font-size:1em;font-weight:400;line-height:1.5;padding:.4em .65em;text-align:center;-webkit-user-select:none;-moz-user-select:none;user-select:none;vertical-align:middle}.fc .fc-button:hover{text-decoration:none}.fc .fc-button:focus{box-shadow:0 0 0 .2rem rgba(44,62,80,.25);outline:0}.fc .fc-button:disabled{opacity:.65}.fc .fc-button-primary{background-color:var(--fc-button-bg-color);border-color:var(--fc-button-border-color);color:var(--fc-button-text-color)}.fc .fc-button-primary:hover{background-color:var(--fc-button-hover-bg-color);border-color:var(--fc-button-hover-border-color);color:var(--fc-button-text-color)}.fc .fc-button-primary:disabled{background-color:var(--fc-button-bg-color);border-color:var(--fc-button-border-color);color:var(--fc-button-text-color)}.fc .fc-button-primary:focus{box-shadow:0 0 0 .2rem rgba(76,91,106,.5)}.fc .fc-button-primary:not(:disabled).fc-button-active,.fc .fc-button-primary:not(:disabled):active{background-color:var(--fc-button-active-bg-color);border-color:var(--fc-button-active-border-color);color:var(--fc-button-text-color)}.fc .fc-button-primary:not(:disabled).fc-button-active:focus,.fc .fc-button-primary:not(:disabled):active:focus{box-shadow:0 0 0 .2rem rgba(76,91,106,.5)}.fc .fc-button .fc-icon{font-size:1.5em;vertical-align:middle}.fc .fc-button-group{display:inline-flex;position:relative;vertical-align:middle}.fc .fc-button-group>.fc-button{flex:1 1 auto;position:relative}.fc .fc-button-group>.fc-button.fc-button-active,.fc .fc-button-group>.fc-button:active,.fc .fc-button-group>.fc-button:focus,.fc .fc-button-group>.fc-button:hover{z-index:1}.fc-direction-ltr .fc-button-group>.fc-button:not(:first-child){border-bottom-left-radius:0;border-top-left-radius:0;margin-left:-1px}.fc-direction-ltr .fc-button-group>.fc-button:not(:last-child){border-bottom-right-radius:0;border-top-right-radius:0}.fc-direction-rtl .fc-button-group>.fc-button:not(:first-child){border-bottom-right-radius:0;border-top-right-radius:0;margin-right:-1px}.fc-direction-rtl .fc-button-group>.fc-button:not(:last-child){border-bottom-left-radius:0;border-top-left-radius:0}.fc .fc-toolbar{align-items:center;display:flex;justify-content:space-between}.fc .fc-toolbar.fc-header-toolbar{margin-bottom:1.5em}.fc .fc-toolbar.fc-footer-toolbar{margin-top:1.5em}.fc .fc-toolbar-title{font-size:1.75em;margin:0}.fc-direction-ltr .fc-toolbar>*>:not(:first-child){margin-left:.75em}.fc-direction-rtl .fc-toolbar>*>:not(:first-child){margin-right:.75em}.fc-direction-rtl .fc-toolbar-ltr{flex-direction:row-reverse}.fc .fc-scroller{-webkit-overflow-scrolling:touch;position:relative}.fc .fc-scroller-liquid{height:100%}.fc .fc-scroller-liquid-absolute{bottom:0;left:0;position:absolute;right:0;top:0}.fc .fc-scroller-harness{direction:ltr;overflow:hidden;position:relative}.fc .fc-scroller-harness-liquid{height:100%}.fc-direction-rtl .fc-scroller-harness>.fc-scroller{direction:rtl}.fc-theme-standard .fc-scrollgrid{border:1px solid var(--fc-border-color)}.fc .fc-scrollgrid,.fc .fc-scrollgrid table{table-layout:fixed;width:100%}.fc .fc-scrollgrid table{border-left-style:hidden;border-right-style:hidden;border-top-style:hidden}.fc .fc-scrollgrid{border-bottom-width:0;border-collapse:separate;border-right-width:0}.fc .fc-scrollgrid-liquid{height:100%}.fc .fc-scrollgrid-section,.fc .fc-scrollgrid-section table,.fc .fc-scrollgrid-section>td{height:1px}.fc .fc-scrollgrid-section-liquid>td{height:100%}.fc .fc-scrollgrid-section>*{border-left-width:0;border-top-width:0}.fc .fc-scrollgrid-section-footer>*,.fc .fc-scrollgrid-section-header>*{border-bottom-width:0}.fc .fc-scrollgrid-section-body table,.fc .fc-scrollgrid-section-footer table{border-bottom-style:hidden}.fc .fc-scrollgrid-section-sticky>*{background:var(--fc-page-bg-color);position:sticky;z-index:3}.fc .fc-scrollgrid-section-header.fc-scrollgrid-section-sticky>*{top:0}.fc .fc-scrollgrid-section-footer.fc-scrollgrid-section-sticky>*{bottom:0}.fc .fc-scrollgrid-sticky-shim{height:1px;margin-bottom:-1px}.fc-sticky{position:sticky}.fc .fc-view-harness{flex-grow:1;position:relative}.fc .fc-view-harness-active>.fc-view{bottom:0;left:0;position:absolute;right:0;top:0}.fc .fc-col-header-cell-cushion{display:inline-block;padding:2px 4px}.fc .fc-bg-event,.fc .fc-highlight,.fc .fc-non-business{bottom:0;left:0;position:absolute;right:0;top:0}.fc .fc-non-business{background:var(--fc-non-business-color)}.fc .fc-bg-event{background:var(--fc-bg-event-color);opacity:var(--fc-bg-event-opacity)}.fc .fc-bg-event .fc-event-title{font-size:var(--fc-small-font-size);font-style:italic;margin:.5em}.fc .fc-highlight{background:var(--fc-highlight-color)}.fc .fc-cell-shaded,.fc .fc-day-disabled{background:var(--fc-neutral-bg-color)}a.fc-event,a.fc-event:hover{text-decoration:none}.fc-event.fc-event-draggable,.fc-event[href]{cursor:pointer}.fc-event .fc-event-main{position:relative;z-index:2}.fc-event-dragging:not(.fc-event-selected){opacity:.75}.fc-event-dragging.fc-event-selected{box-shadow:0 2px 7px rgba(0,0,0,.3)}.fc-event .fc-event-resizer{display:none;position:absolute;z-index:4}.fc-event-selected .fc-event-resizer,.fc-event:hover .fc-event-resizer{display:block}.fc-event-selected .fc-event-resizer{background:var(--fc-page-bg-color);border-color:inherit;border-radius:calc(var(--fc-event-resizer-dot-total-width)/2);border-style:solid;border-width:var(--fc-event-resizer-dot-border-width);height:var(--fc-event-resizer-dot-total-width);width:var(--fc-event-resizer-dot-total-width)}.fc-event-selected .fc-event-resizer:before{bottom:-20px;content:\"\";left:-20px;position:absolute;right:-20px;top:-20px}.fc-event-selected,.fc-event:focus{box-shadow:0 2px 5px rgba(0,0,0,.2)}.fc-event-selected:before,.fc-event:focus:before{bottom:0;content:\"\";left:0;position:absolute;right:0;top:0;z-index:3}.fc-event-selected:after,.fc-event:focus:after{background:var(--fc-event-selected-overlay-color);bottom:-1px;content:\"\";left:-1px;position:absolute;right:-1px;top:-1px;z-index:1}.fc-h-event{background-color:var(--fc-event-bg-color);border:1px solid var(--fc-event-border-color);display:block}.fc-h-event .fc-event-main{color:var(--fc-event-text-color)}.fc-h-event .fc-event-main-frame{display:flex}.fc-h-event .fc-event-time{max-width:100%;overflow:hidden}.fc-h-event .fc-event-title-container{flex-grow:1;flex-shrink:1;min-width:0}.fc-h-event .fc-event-title{display:inline-block;left:0;max-width:100%;overflow:hidden;right:0;vertical-align:top}.fc-h-event.fc-event-selected:before{bottom:-10px;top:-10px}.fc-direction-ltr .fc-daygrid-block-event:not(.fc-event-start),.fc-direction-rtl .fc-daygrid-block-event:not(.fc-event-end){border-bottom-left-radius:0;border-left-width:0;border-top-left-radius:0}.fc-direction-ltr .fc-daygrid-block-event:not(.fc-event-end),.fc-direction-rtl .fc-daygrid-block-event:not(.fc-event-start){border-bottom-right-radius:0;border-right-width:0;border-top-right-radius:0}.fc-h-event:not(.fc-event-selected) .fc-event-resizer{bottom:0;top:0;width:var(--fc-event-resizer-thickness)}.fc-direction-ltr .fc-h-event:not(.fc-event-selected) .fc-event-resizer-start,.fc-direction-rtl .fc-h-event:not(.fc-event-selected) .fc-event-resizer-end{cursor:w-resize;left:calc(var(--fc-event-resizer-thickness)*-.5)}.fc-direction-ltr .fc-h-event:not(.fc-event-selected) .fc-event-resizer-end,.fc-direction-rtl .fc-h-event:not(.fc-event-selected) .fc-event-resizer-start{cursor:e-resize;right:calc(var(--fc-event-resizer-thickness)*-.5)}.fc-h-event.fc-event-selected .fc-event-resizer{margin-top:calc(var(--fc-event-resizer-dot-total-width)*-.5);top:50%}.fc-direction-ltr .fc-h-event.fc-event-selected .fc-event-resizer-start,.fc-direction-rtl .fc-h-event.fc-event-selected .fc-event-resizer-end{left:calc(var(--fc-event-resizer-dot-total-width)*-.5)}.fc-direction-ltr .fc-h-event.fc-event-selected .fc-event-resizer-end,.fc-direction-rtl .fc-h-event.fc-event-selected .fc-event-resizer-start{right:calc(var(--fc-event-resizer-dot-total-width)*-.5)}.fc .fc-popover{box-shadow:0 2px 6px rgba(0,0,0,.15);position:absolute;z-index:9999}.fc .fc-popover-header{align-items:center;display:flex;flex-direction:row;justify-content:space-between;padding:3px 4px}.fc .fc-popover-title{margin:0 2px}.fc .fc-popover-close{cursor:pointer;font-size:1.1em;opacity:.65}.fc-theme-standard .fc-popover{background:var(--fc-page-bg-color);border:1px solid var(--fc-border-color)}.fc-theme-standard .fc-popover-header{background:var(--fc-neutral-bg-color)}";
injectStyles(css_248z);

var DelayedRunner = /*#__PURE__*/function () {
  function DelayedRunner(drainedOption) {
    _classCallCheck(this, DelayedRunner);

    this.drainedOption = drainedOption;
    this.isRunning = false;
    this.isDirty = false;
    this.pauseDepths = {};
    this.timeoutId = 0;
  }

  _createClass(DelayedRunner, [{
    key: "request",
    value: function request(delay) {
      this.isDirty = true;

      if (!this.isPaused()) {
        this.clearTimeout();

        if (delay == null) {
          this.tryDrain();
        } else {
          this.timeoutId = setTimeout( // NOT OPTIMAL! TODO: look at debounce
          this.tryDrain.bind(this), delay);
        }
      }
    }
  }, {
    key: "pause",
    value: function pause() {
      var scope = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var pauseDepths = this.pauseDepths;
      pauseDepths[scope] = (pauseDepths[scope] || 0) + 1;
      this.clearTimeout();
    }
  }, {
    key: "resume",
    value: function resume() {
      var scope = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var force = arguments.length > 1 ? arguments[1] : undefined;
      var pauseDepths = this.pauseDepths;

      if (scope in pauseDepths) {
        if (force) {
          delete pauseDepths[scope];
        } else {
          pauseDepths[scope] -= 1;
          var depth = pauseDepths[scope];

          if (depth <= 0) {
            delete pauseDepths[scope];
          }
        }

        this.tryDrain();
      }
    }
  }, {
    key: "isPaused",
    value: function isPaused() {
      return Object.keys(this.pauseDepths).length;
    }
  }, {
    key: "tryDrain",
    value: function tryDrain() {
      if (!this.isRunning && !this.isPaused()) {
        this.isRunning = true;

        while (this.isDirty) {
          this.isDirty = false;
          this.drained(); // might set isDirty to true again
        }

        this.isRunning = false;
      }
    }
  }, {
    key: "clear",
    value: function clear() {
      this.clearTimeout();
      this.isDirty = false;
      this.pauseDepths = {};
    }
  }, {
    key: "clearTimeout",
    value: function (_clearTimeout) {
      function clearTimeout() {
        return _clearTimeout.apply(this, arguments);
      }

      clearTimeout.toString = function () {
        return _clearTimeout.toString();
      };

      return clearTimeout;
    }(function () {
      if (this.timeoutId) {
        clearTimeout(this.timeoutId);
        this.timeoutId = 0;
      }
    })
  }, {
    key: "drained",
    value: function drained() {
      if (this.drainedOption) {
        this.drainedOption();
      }
    }
  }]);

  return DelayedRunner;
}();

function removeElement(el) {
  if (el.parentNode) {
    el.parentNode.removeChild(el);
  }
} // Querying
// ----------------------------------------------------------------------------------------------------------------


function elementClosest(el, selector) {
  if (el.closest) {
    return el.closest(selector); // really bad fallback for IE
    // from https://developer.mozilla.org/en-US/docs/Web/API/Element/closest
  }

  if (!document.documentElement.contains(el)) {
    return null;
  }

  do {
    if (elementMatches(el, selector)) {
      return el;
    }

    el = el.parentElement || el.parentNode;
  } while (el !== null && el.nodeType === 1);

  return null;
}

function elementMatches(el, selector) {
  var method = el.matches || el.matchesSelector || el.msMatchesSelector;
  return method.call(el, selector);
} // accepts multiple subject els
// returns a real array. good for methods like forEach
// TODO: accept the document


function findElements(container, selector) {
  var containers = container instanceof HTMLElement ? [container] : container;
  var allMatches = [];

  for (var i = 0; i < containers.length; i += 1) {
    var matches = containers[i].querySelectorAll(selector);

    for (var j = 0; j < matches.length; j += 1) {
      allMatches.push(matches[j]);
    }
  }

  return allMatches;
} // accepts multiple subject els
// only queries direct child elements // TODO: rename to findDirectChildren!


function findDirectChildren(parent, selector) {
  var parents = parent instanceof HTMLElement ? [parent] : parent;
  var allMatches = [];

  for (var i = 0; i < parents.length; i += 1) {
    var childNodes = parents[i].children; // only ever elements

    for (var j = 0; j < childNodes.length; j += 1) {
      var childNode = childNodes[j];

      if (!selector || elementMatches(childNode, selector)) {
        allMatches.push(childNode);
      }
    }
  }

  return allMatches;
} // Style
// ----------------------------------------------------------------------------------------------------------------


var PIXEL_PROP_RE = /(top|left|right|bottom|width|height)$/i;

function applyStyle(el, props) {
  for (var propName in props) {
    applyStyleProp(el, propName, props[propName]);
  }
}

function applyStyleProp(el, name, val) {
  if (val == null) {
    el.style[name] = '';
  } else if (typeof val === 'number' && PIXEL_PROP_RE.test(name)) {
    el.style[name] = "".concat(val, "px");
  } else {
    el.style[name] = val;
  }
} // Event Handling
// ----------------------------------------------------------------------------------------------------------------
// if intercepting bubbled events at the document/window/body level,
// and want to see originating element (the 'target'), use this util instead
// of `ev.target` because it goes within web-component boundaries.


function getEventTargetViaRoot(ev) {
  var _a, _b;

  return (_b = (_a = ev.composedPath) === null || _a === void 0 ? void 0 : _a.call(ev)[0]) !== null && _b !== void 0 ? _b : ev.target;
} // Unique ID for DOM attribute


var guid$1 = 0;

function getUniqueDomId() {
  guid$1 += 1;
  return 'fc-dom-' + guid$1;
} // Stops a mouse/touch event from doing it's native browser action


function preventDefault(ev) {
  ev.preventDefault();
} // Event Delegation
// ----------------------------------------------------------------------------------------------------------------


function buildDelegationHandler(selector, handler) {
  return function (ev) {
    var matchedChild = elementClosest(ev.target, selector);

    if (matchedChild) {
      handler.call(matchedChild, ev, matchedChild);
    }
  };
}

function listenBySelector(container, eventType, selector, handler) {
  var attachedHandler = buildDelegationHandler(selector, handler);
  container.addEventListener(eventType, attachedHandler);
  return function () {
    container.removeEventListener(eventType, attachedHandler);
  };
}

function listenToHoverBySelector(container, selector, onMouseEnter, onMouseLeave) {
  var currentMatchedChild;
  return listenBySelector(container, 'mouseover', selector, function (mouseOverEv, matchedChild) {
    if (matchedChild !== currentMatchedChild) {
      currentMatchedChild = matchedChild;
      onMouseEnter(mouseOverEv, matchedChild);

      var realOnMouseLeave = function realOnMouseLeave(mouseLeaveEv) {
        currentMatchedChild = null;
        onMouseLeave(mouseLeaveEv, matchedChild);
        matchedChild.removeEventListener('mouseleave', realOnMouseLeave);
      }; // listen to the next mouseleave, and then unattach


      matchedChild.addEventListener('mouseleave', realOnMouseLeave);
    }
  });
} // Animation
// ----------------------------------------------------------------------------------------------------------------


var transitionEventNames = ['webkitTransitionEnd', 'otransitionend', 'oTransitionEnd', 'msTransitionEnd', 'transitionend']; // triggered only when the next single subsequent transition finishes

function whenTransitionDone(el, callback) {
  var realCallback = function realCallback(ev) {
    callback(ev);
    transitionEventNames.forEach(function (eventName) {
      el.removeEventListener(eventName, realCallback);
    });
  };

  transitionEventNames.forEach(function (eventName) {
    el.addEventListener(eventName, realCallback); // cross-browser way to determine when the transition finishes
  });
} // ARIA workarounds
// ----------------------------------------------------------------------------------------------------------------


function createAriaClickAttrs(handler) {
  return Object.assign({
    onClick: handler
  }, createAriaKeyboardAttrs(handler));
}

function createAriaKeyboardAttrs(handler) {
  return {
    tabIndex: 0,
    onKeyDown: function onKeyDown(ev) {
      if (ev.key === 'Enter' || ev.key === ' ') {
        handler(ev);
        ev.preventDefault(); // if space, don't scroll down page
      }
    }
  };
}

var guidNumber = 0;

function guid() {
  guidNumber += 1;
  return String(guidNumber);
}
/* FullCalendar-specific DOM Utilities
----------------------------------------------------------------------------------------------------------------------*/
// Make the mouse cursor express that an event is not allowed in the current area


function disableCursor() {
  document.body.classList.add('fc-not-allowed');
} // Returns the mouse cursor to its original look


function enableCursor() {
  document.body.classList.remove('fc-not-allowed');
}
/* Selection
----------------------------------------------------------------------------------------------------------------------*/


function preventSelection(el) {
  el.style.userSelect = 'none';
  el.style.webkitUserSelect = 'none';
  el.addEventListener('selectstart', preventDefault);
}

function allowSelection(el) {
  el.style.userSelect = '';
  el.style.webkitUserSelect = '';
  el.removeEventListener('selectstart', preventDefault);
}
/* Context Menu
----------------------------------------------------------------------------------------------------------------------*/


function preventContextMenu(el) {
  el.addEventListener('contextmenu', preventDefault);
}

function allowContextMenu(el) {
  el.removeEventListener('contextmenu', preventDefault);
}

function parseFieldSpecs(input) {
  var specs = [];
  var tokens = [];
  var i;
  var token;

  if (typeof input === 'string') {
    tokens = input.split(/\s*,\s*/);
  } else if (typeof input === 'function') {
    tokens = [input];
  } else if (Array.isArray(input)) {
    tokens = input;
  }

  for (i = 0; i < tokens.length; i += 1) {
    token = tokens[i];

    if (typeof token === 'string') {
      specs.push(token.charAt(0) === '-' ? {
        field: token.substring(1),
        order: -1
      } : {
        field: token,
        order: 1
      });
    } else if (typeof token === 'function') {
      specs.push({
        func: token
      });
    }
  }

  return specs;
}

function compareByFieldSpecs(obj0, obj1, fieldSpecs) {
  var i;
  var cmp;

  for (i = 0; i < fieldSpecs.length; i += 1) {
    cmp = compareByFieldSpec(obj0, obj1, fieldSpecs[i]);

    if (cmp) {
      return cmp;
    }
  }

  return 0;
}

function compareByFieldSpec(obj0, obj1, fieldSpec) {
  if (fieldSpec.func) {
    return fieldSpec.func(obj0, obj1);
  }

  return flexibleCompare(obj0[fieldSpec.field], obj1[fieldSpec.field]) * (fieldSpec.order || 1);
}

function flexibleCompare(a, b) {
  if (!a && !b) {
    return 0;
  }

  if (b == null) {
    return -1;
  }

  if (a == null) {
    return 1;
  }

  if (typeof a === 'string' || typeof b === 'string') {
    return String(a).localeCompare(String(b));
  }

  return a - b;
}
/* String Utilities
----------------------------------------------------------------------------------------------------------------------*/


function padStart(val, len) {
  var s = String(val);
  return '000'.substr(0, len - s.length) + s;
}

function formatWithOrdinals(formatter, args, fallbackText) {
  if (typeof formatter === 'function') {
    return formatter.apply(void 0, _toConsumableArray(args));
  }

  if (typeof formatter === 'string') {
    // non-blank string
    return args.reduce(function (str, arg, index) {
      return str.replace('$' + index, arg || '');
    }, formatter);
  }

  return fallbackText;
}
/* Number Utilities
----------------------------------------------------------------------------------------------------------------------*/


function compareNumbers(a, b) {
  return a - b;
}

function isInt(n) {
  return n % 1 === 0;
}
/* FC-specific DOM dimension stuff
----------------------------------------------------------------------------------------------------------------------*/


function computeSmallestCellWidth(cellEl) {
  var allWidthEl = cellEl.querySelector('.fc-scrollgrid-shrink-frame');
  var contentWidthEl = cellEl.querySelector('.fc-scrollgrid-shrink-cushion');

  if (!allWidthEl) {
    throw new Error('needs fc-scrollgrid-shrink-frame className'); // TODO: use const
  }

  if (!contentWidthEl) {
    throw new Error('needs fc-scrollgrid-shrink-cushion className');
  }

  return cellEl.getBoundingClientRect().width - allWidthEl.getBoundingClientRect().width + // the cell padding+border
  contentWidthEl.getBoundingClientRect().width;
}

var INTERNAL_UNITS = ['years', 'months', 'days', 'milliseconds'];
var PARSE_RE = /^(-?)(?:(\d+)\.)?(\d+):(\d\d)(?::(\d\d)(?:\.(\d\d\d))?)?/; // Parsing and Creation

function createDuration(input, unit) {
  if (typeof input === 'string') {
    return parseString(input);
  }

  if (_typeof(input) === 'object' && input) {
    // non-null object
    return parseObject(input);
  }

  if (typeof input === 'number') {
    return parseObject(_defineProperty({}, unit || 'milliseconds', input));
  }

  return null;
}

function parseString(s) {
  var m = PARSE_RE.exec(s);

  if (m) {
    var sign = m[1] ? -1 : 1;
    return {
      years: 0,
      months: 0,
      days: sign * (m[2] ? parseInt(m[2], 10) : 0),
      milliseconds: sign * ((m[3] ? parseInt(m[3], 10) : 0) * 60 * 60 * 1000 + // hours
      (m[4] ? parseInt(m[4], 10) : 0) * 60 * 1000 + // minutes
      (m[5] ? parseInt(m[5], 10) : 0) * 1000 + ( // seconds
      m[6] ? parseInt(m[6], 10) : 0) // ms
      )
    };
  }

  return null;
}

function parseObject(obj) {
  var duration = {
    years: obj.years || obj.year || 0,
    months: obj.months || obj.month || 0,
    days: obj.days || obj.day || 0,
    milliseconds: (obj.hours || obj.hour || 0) * 60 * 60 * 1000 + // hours
    (obj.minutes || obj.minute || 0) * 60 * 1000 + // minutes
    (obj.seconds || obj.second || 0) * 1000 + ( // seconds
    obj.milliseconds || obj.millisecond || obj.ms || 0) // ms

  };
  var weeks = obj.weeks || obj.week;

  if (weeks) {
    duration.days += weeks * 7;
    duration.specifiedWeeks = true;
  }

  return duration;
} // Equality


function durationsEqual(d0, d1) {
  return d0.years === d1.years && d0.months === d1.months && d0.days === d1.days && d0.milliseconds === d1.milliseconds;
}

function asCleanDays(dur) {
  if (!dur.years && !dur.months && !dur.milliseconds) {
    return dur.days;
  }

  return 0;
} // Simple Math


function addDurations(d0, d1) {
  return {
    years: d0.years + d1.years,
    months: d0.months + d1.months,
    days: d0.days + d1.days,
    milliseconds: d0.milliseconds + d1.milliseconds
  };
}

function subtractDurations(d1, d0) {
  return {
    years: d1.years - d0.years,
    months: d1.months - d0.months,
    days: d1.days - d0.days,
    milliseconds: d1.milliseconds - d0.milliseconds
  };
}

function multiplyDuration(d, n) {
  return {
    years: d.years * n,
    months: d.months * n,
    days: d.days * n,
    milliseconds: d.milliseconds * n
  };
} // Conversions
// "Rough" because they are based on average-case Gregorian months/years


function asRoughYears(dur) {
  return asRoughDays(dur) / 365;
}

function asRoughMonths(dur) {
  return asRoughDays(dur) / 30;
}

function asRoughDays(dur) {
  return asRoughMs(dur) / 864e5;
}

function asRoughMinutes(dur) {
  return asRoughMs(dur) / (1000 * 60);
}

function asRoughSeconds(dur) {
  return asRoughMs(dur) / 1000;
}

function asRoughMs(dur) {
  return dur.years * (365 * 864e5) + dur.months * (30 * 864e5) + dur.days * 864e5 + dur.milliseconds;
} // Advanced Math


function wholeDivideDurations(numerator, denominator) {
  var res = null;

  for (var i = 0; i < INTERNAL_UNITS.length; i += 1) {
    var unit = INTERNAL_UNITS[i];

    if (denominator[unit]) {
      var localRes = numerator[unit] / denominator[unit];

      if (!isInt(localRes) || res !== null && res !== localRes) {
        return null;
      }

      res = localRes;
    } else if (numerator[unit]) {
      // needs to divide by something but can't!
      return null;
    }
  }

  return res;
}

function greatestDurationDenominator(dur) {
  var ms = dur.milliseconds;

  if (ms) {
    if (ms % 1000 !== 0) {
      return {
        unit: 'millisecond',
        value: ms
      };
    }

    if (ms % (1000 * 60) !== 0) {
      return {
        unit: 'second',
        value: ms / 1000
      };
    }

    if (ms % (1000 * 60 * 60) !== 0) {
      return {
        unit: 'minute',
        value: ms / (1000 * 60)
      };
    }

    if (ms) {
      return {
        unit: 'hour',
        value: ms / (1000 * 60 * 60)
      };
    }
  }

  if (dur.days) {
    if (dur.specifiedWeeks && dur.days % 7 === 0) {
      return {
        unit: 'week',
        value: dur.days / 7
      };
    }

    return {
      unit: 'day',
      value: dur.days
    };
  }

  if (dur.months) {
    return {
      unit: 'month',
      value: dur.months
    };
  }

  if (dur.years) {
    return {
      unit: 'year',
      value: dur.years
    };
  }

  return {
    unit: 'millisecond',
    value: 0
  };
} // TODO: new util arrayify?


function removeExact(array, exactVal) {
  var removeCnt = 0;
  var i = 0;

  while (i < array.length) {
    if (array[i] === exactVal) {
      array.splice(i, 1);
      removeCnt += 1;
    } else {
      i += 1;
    }
  }

  return removeCnt;
}

function isArraysEqual(a0, a1, equalityFunc) {
  if (a0 === a1) {
    return true;
  }

  var len = a0.length;
  var i;

  if (len !== a1.length) {
    // not array? or not same length?
    return false;
  }

  for (i = 0; i < len; i += 1) {
    if (!(equalityFunc ? equalityFunc(a0[i], a1[i]) : a0[i] === a1[i])) {
      return false;
    }
  }

  return true;
}

var DAY_IDS = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat']; // Adding

function addWeeks(m, n) {
  var a = dateToUtcArray(m);
  a[2] += n * 7;
  return arrayToUtcDate(a);
}

function addDays(m, n) {
  var a = dateToUtcArray(m);
  a[2] += n;
  return arrayToUtcDate(a);
}

function addMs(m, n) {
  var a = dateToUtcArray(m);
  a[6] += n;
  return arrayToUtcDate(a);
} // Diffing (all return floats)
// TODO: why not use ranges?


function diffWeeks(m0, m1) {
  return diffDays(m0, m1) / 7;
}

function diffDays(m0, m1) {
  return (m1.valueOf() - m0.valueOf()) / (1000 * 60 * 60 * 24);
}

function diffHours(m0, m1) {
  return (m1.valueOf() - m0.valueOf()) / (1000 * 60 * 60);
}

function diffMinutes(m0, m1) {
  return (m1.valueOf() - m0.valueOf()) / (1000 * 60);
}

function diffSeconds(m0, m1) {
  return (m1.valueOf() - m0.valueOf()) / 1000;
}

function diffDayAndTime(m0, m1) {
  var m0day = startOfDay(m0);
  var m1day = startOfDay(m1);
  return {
    years: 0,
    months: 0,
    days: Math.round(diffDays(m0day, m1day)),
    milliseconds: m1.valueOf() - m1day.valueOf() - (m0.valueOf() - m0day.valueOf())
  };
} // Diffing Whole Units


function diffWholeWeeks(m0, m1) {
  var d = diffWholeDays(m0, m1);

  if (d !== null && d % 7 === 0) {
    return d / 7;
  }

  return null;
}

function diffWholeDays(m0, m1) {
  if (timeAsMs(m0) === timeAsMs(m1)) {
    return Math.round(diffDays(m0, m1));
  }

  return null;
} // Start-Of


function startOfDay(m) {
  return arrayToUtcDate([m.getUTCFullYear(), m.getUTCMonth(), m.getUTCDate()]);
}

function startOfHour(m) {
  return arrayToUtcDate([m.getUTCFullYear(), m.getUTCMonth(), m.getUTCDate(), m.getUTCHours()]);
}

function startOfMinute(m) {
  return arrayToUtcDate([m.getUTCFullYear(), m.getUTCMonth(), m.getUTCDate(), m.getUTCHours(), m.getUTCMinutes()]);
}

function startOfSecond(m) {
  return arrayToUtcDate([m.getUTCFullYear(), m.getUTCMonth(), m.getUTCDate(), m.getUTCHours(), m.getUTCMinutes(), m.getUTCSeconds()]);
} // Week Computation


function weekOfYear(marker, dow, doy) {
  var y = marker.getUTCFullYear();
  var w = weekOfGivenYear(marker, y, dow, doy);

  if (w < 1) {
    return weekOfGivenYear(marker, y - 1, dow, doy);
  }

  var nextW = weekOfGivenYear(marker, y + 1, dow, doy);

  if (nextW >= 1) {
    return Math.min(w, nextW);
  }

  return w;
}

function weekOfGivenYear(marker, year, dow, doy) {
  var firstWeekStart = arrayToUtcDate([year, 0, 1 + firstWeekOffset(year, dow, doy)]);
  var dayStart = startOfDay(marker);
  var days = Math.round(diffDays(firstWeekStart, dayStart));
  return Math.floor(days / 7) + 1; // zero-indexed
} // start-of-first-week - start-of-year


function firstWeekOffset(year, dow, doy) {
  // first-week day -- which january is always in the first week (4 for iso, 1 for other)
  var fwd = 7 + dow - doy; // first-week day local weekday -- which local weekday is fwd

  var fwdlw = (7 + arrayToUtcDate([year, 0, fwd]).getUTCDay() - dow) % 7;
  return -fwdlw + fwd - 1;
} // Array Conversion


function dateToLocalArray(date) {
  return [date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()];
}

function arrayToLocalDate(a) {
  return new Date(a[0], a[1] || 0, a[2] == null ? 1 : a[2], // day of month
  a[3] || 0, a[4] || 0, a[5] || 0);
}

function dateToUtcArray(date) {
  return [date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds(), date.getUTCMilliseconds()];
}

function arrayToUtcDate(a) {
  // according to web standards (and Safari), a month index is required.
  // massage if only given a year.
  if (a.length === 1) {
    a = a.concat([0]);
  }

  return new Date(Date.UTC.apply(Date, _toConsumableArray(a)));
} // Other Utils


function isValidDate(m) {
  return !isNaN(m.valueOf());
}

function timeAsMs(m) {
  return m.getUTCHours() * 1000 * 60 * 60 + m.getUTCMinutes() * 1000 * 60 + m.getUTCSeconds() * 1000 + m.getUTCMilliseconds();
} // timeZoneOffset is in minutes


function buildIsoString(marker, timeZoneOffset) {
  var stripZeroTime = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var s = marker.toISOString();
  s = s.replace('.000', '');

  if (stripZeroTime) {
    s = s.replace('T00:00:00Z', '');
  }

  if (s.length > 10) {
    // time part wasn't stripped, can add timezone info
    if (timeZoneOffset == null) {
      s = s.replace('Z', '');
    } else if (timeZoneOffset !== 0) {
      s = s.replace('Z', formatTimeZoneOffset(timeZoneOffset, true));
    } // otherwise, its UTC-0 and we want to keep the Z

  }

  return s;
} // formats the date, but with no time part
// TODO: somehow merge with buildIsoString and stripZeroTime
// TODO: rename. omit "string"


function formatDayString(marker) {
  return marker.toISOString().replace(/T.*$/, '');
}

function formatIsoMonthStr(marker) {
  return marker.toISOString().match(/^\d{4}-\d{2}/)[0];
} // TODO: use Date::toISOString and use everything after the T?


function formatIsoTimeString(marker) {
  return padStart(marker.getUTCHours(), 2) + ':' + padStart(marker.getUTCMinutes(), 2) + ':' + padStart(marker.getUTCSeconds(), 2);
}

function formatTimeZoneOffset(minutes) {
  var doIso = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var sign = minutes < 0 ? '-' : '+';
  var abs = Math.abs(minutes);
  var hours = Math.floor(abs / 60);
  var mins = Math.round(abs % 60);

  if (doIso) {
    return "".concat(sign + padStart(hours, 2), ":").concat(padStart(mins, 2));
  }

  return "GMT".concat(sign).concat(hours).concat(mins ? ":".concat(padStart(mins, 2)) : '');
}

function memoize(workerFunc, resEquality, teardownFunc) {
  var currentArgs;
  var currentRes;
  return function () {
    for (var _len = arguments.length, newArgs = new Array(_len), _key = 0; _key < _len; _key++) {
      newArgs[_key] = arguments[_key];
    }

    if (!currentArgs) {
      currentRes = workerFunc.apply(this, newArgs);
    } else if (!isArraysEqual(currentArgs, newArgs)) {
      if (teardownFunc) {
        teardownFunc(currentRes);
      }

      var res = workerFunc.apply(this, newArgs);

      if (!resEquality || !resEquality(res, currentRes)) {
        currentRes = res;
      }
    }

    currentArgs = newArgs;
    return currentRes;
  };
}

function memoizeObjArg(workerFunc, resEquality, teardownFunc) {
  var _this = this;

  var currentArg;
  var currentRes;
  return function (newArg) {
    if (!currentArg) {
      currentRes = workerFunc.call(_this, newArg);
    } else if (!isPropsEqual(currentArg, newArg)) {
      if (teardownFunc) {
        teardownFunc(currentRes);
      }

      var res = workerFunc.call(_this, newArg);

      if (!resEquality || !resEquality(res, currentRes)) {
        currentRes = res;
      }
    }

    currentArg = newArg;
    return currentRes;
  };
}

function memoizeArraylike( // used at all?
workerFunc, resEquality, teardownFunc) {
  var _this2 = this;

  var currentArgSets = [];
  var currentResults = [];
  return function (newArgSets) {
    var currentLen = currentArgSets.length;
    var newLen = newArgSets.length;
    var i = 0;

    for (; i < currentLen; i += 1) {
      if (!newArgSets[i]) {
        // one of the old sets no longer exists
        if (teardownFunc) {
          teardownFunc(currentResults[i]);
        }
      } else if (!isArraysEqual(currentArgSets[i], newArgSets[i])) {
        if (teardownFunc) {
          teardownFunc(currentResults[i]);
        }

        var res = workerFunc.apply(_this2, newArgSets[i]);

        if (!resEquality || !resEquality(res, currentResults[i])) {
          currentResults[i] = res;
        }
      }
    }

    for (; i < newLen; i += 1) {
      currentResults[i] = workerFunc.apply(_this2, newArgSets[i]);
    }

    currentArgSets = newArgSets;
    currentResults.splice(newLen); // remove excess

    return currentResults;
  };
}

function memoizeHashlike(workerFunc, resEquality, teardownFunc) {
  var _this3 = this;

  var currentArgHash = {};
  var currentResHash = {};
  return function (newArgHash) {
    var newResHash = {};

    for (var key in newArgHash) {
      if (!currentResHash[key]) {
        newResHash[key] = workerFunc.apply(_this3, newArgHash[key]);
      } else if (!isArraysEqual(currentArgHash[key], newArgHash[key])) {
        if (teardownFunc) {
          teardownFunc(currentResHash[key]);
        }

        var res = workerFunc.apply(_this3, newArgHash[key]);
        newResHash[key] = resEquality && resEquality(res, currentResHash[key]) ? currentResHash[key] : res;
      } else {
        newResHash[key] = currentResHash[key];
      }
    }

    currentArgHash = newArgHash;
    currentResHash = newResHash;
    return newResHash;
  };
}

var EXTENDED_SETTINGS_AND_SEVERITIES = {
  week: 3,
  separator: 0,
  omitZeroMinute: 0,
  meridiem: 0,
  omitCommas: 0
};
var STANDARD_DATE_PROP_SEVERITIES = {
  timeZoneName: 7,
  era: 6,
  year: 5,
  month: 4,
  day: 2,
  weekday: 2,
  hour: 1,
  minute: 1,
  second: 1
};
var MERIDIEM_RE = /\s*([ap])\.?m\.?/i; // eats up leading spaces too

var COMMA_RE = /,/g; // we need re for globalness

var MULTI_SPACE_RE = /\s+/g;
var LTR_RE = /\u200e/g; // control character

var UTC_RE = /UTC|GMT/;

var NativeFormatter = /*#__PURE__*/function () {
  function NativeFormatter(formatSettings) {
    _classCallCheck(this, NativeFormatter);

    var standardDateProps = {};
    var extendedSettings = {};
    var severity = 0;

    for (var name in formatSettings) {
      if (name in EXTENDED_SETTINGS_AND_SEVERITIES) {
        extendedSettings[name] = formatSettings[name];
        severity = Math.max(EXTENDED_SETTINGS_AND_SEVERITIES[name], severity);
      } else {
        standardDateProps[name] = formatSettings[name];

        if (name in STANDARD_DATE_PROP_SEVERITIES) {
          // TODO: what about hour12? no severity
          severity = Math.max(STANDARD_DATE_PROP_SEVERITIES[name], severity);
        }
      }
    }

    this.standardDateProps = standardDateProps;
    this.extendedSettings = extendedSettings;
    this.severity = severity;
    this.buildFormattingFunc = memoize(buildFormattingFunc);
  }

  _createClass(NativeFormatter, [{
    key: "format",
    value: function format(date, context) {
      return this.buildFormattingFunc(this.standardDateProps, this.extendedSettings, context)(date);
    }
  }, {
    key: "formatRange",
    value: function formatRange(start, end, context, betterDefaultSeparator) {
      var standardDateProps = this.standardDateProps,
          extendedSettings = this.extendedSettings;
      var diffSeverity = computeMarkerDiffSeverity(start.marker, end.marker, context.calendarSystem);

      if (!diffSeverity) {
        return this.format(start, context);
      }

      var biggestUnitForPartial = diffSeverity;

      if (biggestUnitForPartial > 1 && ( // the two dates are different in a way that's larger scale than time
      standardDateProps.year === 'numeric' || standardDateProps.year === '2-digit') && (standardDateProps.month === 'numeric' || standardDateProps.month === '2-digit') && (standardDateProps.day === 'numeric' || standardDateProps.day === '2-digit')) {
        biggestUnitForPartial = 1; // make it look like the dates are only different in terms of time
      }

      var full0 = this.format(start, context);
      var full1 = this.format(end, context);

      if (full0 === full1) {
        return full0;
      }

      var partialDateProps = computePartialFormattingOptions(standardDateProps, biggestUnitForPartial);
      var partialFormattingFunc = buildFormattingFunc(partialDateProps, extendedSettings, context);
      var partial0 = partialFormattingFunc(start);
      var partial1 = partialFormattingFunc(end);
      var insertion = findCommonInsertion(full0, partial0, full1, partial1);
      var separator = extendedSettings.separator || betterDefaultSeparator || context.defaultSeparator || '';

      if (insertion) {
        return insertion.before + partial0 + separator + partial1 + insertion.after;
      }

      return full0 + separator + full1;
    }
  }, {
    key: "getLargestUnit",
    value: function getLargestUnit() {
      switch (this.severity) {
        case 7:
        case 6:
        case 5:
          return 'year';

        case 4:
          return 'month';

        case 3:
          return 'week';

        case 2:
          return 'day';

        default:
          return 'time';
        // really?
      }
    }
  }]);

  return NativeFormatter;
}();

function buildFormattingFunc(standardDateProps, extendedSettings, context) {
  var standardDatePropCnt = Object.keys(standardDateProps).length;

  if (standardDatePropCnt === 1 && standardDateProps.timeZoneName === 'short') {
    return function (date) {
      return formatTimeZoneOffset(date.timeZoneOffset);
    };
  }

  if (standardDatePropCnt === 0 && extendedSettings.week) {
    return function (date) {
      return formatWeekNumber(context.computeWeekNumber(date.marker), context.weekText, context.weekTextLong, context.locale, extendedSettings.week);
    };
  }

  return buildNativeFormattingFunc(standardDateProps, extendedSettings, context);
}

function buildNativeFormattingFunc(standardDateProps, extendedSettings, context) {
  standardDateProps = Object.assign({}, standardDateProps); // copy

  extendedSettings = Object.assign({}, extendedSettings); // copy

  sanitizeSettings(standardDateProps, extendedSettings);
  standardDateProps.timeZone = 'UTC'; // we leverage the only guaranteed timeZone for our UTC markers

  var normalFormat = new Intl.DateTimeFormat(context.locale.codes, standardDateProps);
  var zeroFormat; // needed?

  if (extendedSettings.omitZeroMinute) {
    var zeroProps = Object.assign({}, standardDateProps);
    delete zeroProps.minute; // seconds and ms were already considered in sanitizeSettings

    zeroFormat = new Intl.DateTimeFormat(context.locale.codes, zeroProps);
  }

  return function (date) {
    var marker = date.marker;
    var format;

    if (zeroFormat && !marker.getUTCMinutes()) {
      format = zeroFormat;
    } else {
      format = normalFormat;
    }

    var s = format.format(marker);
    return postProcess(s, date, standardDateProps, extendedSettings, context);
  };
}

function sanitizeSettings(standardDateProps, extendedSettings) {
  // deal with a browser inconsistency where formatting the timezone
  // requires that the hour/minute be present.
  if (standardDateProps.timeZoneName) {
    if (!standardDateProps.hour) {
      standardDateProps.hour = '2-digit';
    }

    if (!standardDateProps.minute) {
      standardDateProps.minute = '2-digit';
    }
  } // only support short timezone names


  if (standardDateProps.timeZoneName === 'long') {
    standardDateProps.timeZoneName = 'short';
  } // if requesting to display seconds, MUST display minutes


  if (extendedSettings.omitZeroMinute && (standardDateProps.second || standardDateProps.millisecond)) {
    delete extendedSettings.omitZeroMinute;
  }
}

function postProcess(s, date, standardDateProps, extendedSettings, context) {
  s = s.replace(LTR_RE, ''); // remove left-to-right control chars. do first. good for other regexes

  if (standardDateProps.timeZoneName === 'short') {
    s = injectTzoStr(s, context.timeZone === 'UTC' || date.timeZoneOffset == null ? 'UTC' : // important to normalize for IE, which does "GMT"
    formatTimeZoneOffset(date.timeZoneOffset));
  }

  if (extendedSettings.omitCommas) {
    s = s.replace(COMMA_RE, '').trim();
  }

  if (extendedSettings.omitZeroMinute) {
    s = s.replace(':00', ''); // zeroFormat doesn't always achieve this
  } // ^ do anything that might create adjacent spaces before this point,
  // because MERIDIEM_RE likes to eat up loading spaces


  if (extendedSettings.meridiem === false) {
    s = s.replace(MERIDIEM_RE, '').trim();
  } else if (extendedSettings.meridiem === 'narrow') {
    // a/p
    s = s.replace(MERIDIEM_RE, function (m0, m1) {
      return m1.toLocaleLowerCase();
    });
  } else if (extendedSettings.meridiem === 'short') {
    // am/pm
    s = s.replace(MERIDIEM_RE, function (m0, m1) {
      return "".concat(m1.toLocaleLowerCase(), "m");
    });
  } else if (extendedSettings.meridiem === 'lowercase') {
    // other meridiem transformers already converted to lowercase
    s = s.replace(MERIDIEM_RE, function (m0) {
      return m0.toLocaleLowerCase();
    });
  }

  s = s.replace(MULTI_SPACE_RE, ' ');
  s = s.trim();
  return s;
}

function injectTzoStr(s, tzoStr) {
  var replaced = false;
  s = s.replace(UTC_RE, function () {
    replaced = true;
    return tzoStr;
  }); // IE11 doesn't include UTC/GMT in the original string, so append to end

  if (!replaced) {
    s += " ".concat(tzoStr);
  }

  return s;
}

function formatWeekNumber(num, weekText, weekTextLong, locale, display) {
  var parts = [];

  if (display === 'long') {
    parts.push(weekTextLong);
  } else if (display === 'short' || display === 'narrow') {
    parts.push(weekText);
  }

  if (display === 'long' || display === 'short') {
    parts.push(' ');
  }

  parts.push(locale.simpleNumberFormat.format(num));

  if (locale.options.direction === 'rtl') {
    // TODO: use control characters instead?
    parts.reverse();
  }

  return parts.join('');
} // Range Formatting Utils
// 0 = exactly the same
// 1 = different by time
// and bigger


function computeMarkerDiffSeverity(d0, d1, ca) {
  if (ca.getMarkerYear(d0) !== ca.getMarkerYear(d1)) {
    return 5;
  }

  if (ca.getMarkerMonth(d0) !== ca.getMarkerMonth(d1)) {
    return 4;
  }

  if (ca.getMarkerDay(d0) !== ca.getMarkerDay(d1)) {
    return 2;
  }

  if (timeAsMs(d0) !== timeAsMs(d1)) {
    return 1;
  }

  return 0;
}

function computePartialFormattingOptions(options, biggestUnit) {
  var partialOptions = {};

  for (var name in options) {
    if (!(name in STANDARD_DATE_PROP_SEVERITIES) || // not a date part prop (like timeZone)
    STANDARD_DATE_PROP_SEVERITIES[name] <= biggestUnit) {
      partialOptions[name] = options[name];
    }
  }

  return partialOptions;
}

function findCommonInsertion(full0, partial0, full1, partial1) {
  var i0 = 0;

  while (i0 < full0.length) {
    var found0 = full0.indexOf(partial0, i0);

    if (found0 === -1) {
      break;
    }

    var before0 = full0.substr(0, found0);
    i0 = found0 + partial0.length;
    var after0 = full0.substr(i0);
    var i1 = 0;

    while (i1 < full1.length) {
      var found1 = full1.indexOf(partial1, i1);

      if (found1 === -1) {
        break;
      }

      var before1 = full1.substr(0, found1);
      i1 = found1 + partial1.length;
      var after1 = full1.substr(i1);

      if (before0 === before1 && after0 === after1) {
        return {
          before: before0,
          after: after0
        };
      }
    }
  }

  return null;
}

function expandZonedMarker(dateInfo, calendarSystem) {
  var a = calendarSystem.markerToArray(dateInfo.marker);
  return {
    marker: dateInfo.marker,
    timeZoneOffset: dateInfo.timeZoneOffset,
    array: a,
    year: a[0],
    month: a[1],
    day: a[2],
    hour: a[3],
    minute: a[4],
    second: a[5],
    millisecond: a[6]
  };
}

function createVerboseFormattingArg(start, end, context, betterDefaultSeparator) {
  var startInfo = expandZonedMarker(start, context.calendarSystem);
  var endInfo = end ? expandZonedMarker(end, context.calendarSystem) : null;
  return {
    date: startInfo,
    start: startInfo,
    end: endInfo,
    timeZone: context.timeZone,
    localeCodes: context.locale.codes,
    defaultSeparator: betterDefaultSeparator || context.defaultSeparator
  };
}
/*
TODO: fix the terminology of "formatter" vs "formatting func"
*/

/*
At the time of instantiation, this object does not know which cmd-formatting system it will use.
It receives this at the time of formatting, as a setting.
*/


var CmdFormatter = /*#__PURE__*/function () {
  function CmdFormatter(cmdStr) {
    _classCallCheck(this, CmdFormatter);

    this.cmdStr = cmdStr;
  }

  _createClass(CmdFormatter, [{
    key: "format",
    value: function format(date, context, betterDefaultSeparator) {
      return context.cmdFormatter(this.cmdStr, createVerboseFormattingArg(date, null, context, betterDefaultSeparator));
    }
  }, {
    key: "formatRange",
    value: function formatRange(start, end, context, betterDefaultSeparator) {
      return context.cmdFormatter(this.cmdStr, createVerboseFormattingArg(start, end, context, betterDefaultSeparator));
    }
  }]);

  return CmdFormatter;
}();

var FuncFormatter = /*#__PURE__*/function () {
  function FuncFormatter(func) {
    _classCallCheck(this, FuncFormatter);

    this.func = func;
  }

  _createClass(FuncFormatter, [{
    key: "format",
    value: function format(date, context, betterDefaultSeparator) {
      return this.func(createVerboseFormattingArg(date, null, context, betterDefaultSeparator));
    }
  }, {
    key: "formatRange",
    value: function formatRange(start, end, context, betterDefaultSeparator) {
      return this.func(createVerboseFormattingArg(start, end, context, betterDefaultSeparator));
    }
  }]);

  return FuncFormatter;
}();

function createFormatter(input) {
  if (_typeof(input) === 'object' && input) {
    // non-null object
    return new NativeFormatter(input);
  }

  if (typeof input === 'string') {
    return new CmdFormatter(input);
  }

  if (typeof input === 'function') {
    return new FuncFormatter(input);
  }

  return null;
} // base options
// ------------


var BASE_OPTION_REFINERS = {
  navLinkDayClick: identity,
  navLinkWeekClick: identity,
  duration: createDuration,
  bootstrapFontAwesome: identity,
  buttonIcons: identity,
  customButtons: identity,
  defaultAllDayEventDuration: createDuration,
  defaultTimedEventDuration: createDuration,
  nextDayThreshold: createDuration,
  scrollTime: createDuration,
  scrollTimeReset: Boolean,
  slotMinTime: createDuration,
  slotMaxTime: createDuration,
  dayPopoverFormat: createFormatter,
  slotDuration: createDuration,
  snapDuration: createDuration,
  headerToolbar: identity,
  footerToolbar: identity,
  defaultRangeSeparator: String,
  titleRangeSeparator: String,
  forceEventDuration: Boolean,
  dayHeaders: Boolean,
  dayHeaderFormat: createFormatter,
  dayHeaderClassNames: identity,
  dayHeaderContent: identity,
  dayHeaderDidMount: identity,
  dayHeaderWillUnmount: identity,
  dayCellClassNames: identity,
  dayCellContent: identity,
  dayCellDidMount: identity,
  dayCellWillUnmount: identity,
  initialView: String,
  aspectRatio: Number,
  weekends: Boolean,
  weekNumberCalculation: identity,
  weekNumbers: Boolean,
  weekNumberClassNames: identity,
  weekNumberContent: identity,
  weekNumberDidMount: identity,
  weekNumberWillUnmount: identity,
  editable: Boolean,
  viewClassNames: identity,
  viewDidMount: identity,
  viewWillUnmount: identity,
  nowIndicator: Boolean,
  nowIndicatorClassNames: identity,
  nowIndicatorContent: identity,
  nowIndicatorDidMount: identity,
  nowIndicatorWillUnmount: identity,
  showNonCurrentDates: Boolean,
  lazyFetching: Boolean,
  startParam: String,
  endParam: String,
  timeZoneParam: String,
  timeZone: String,
  locales: identity,
  locale: identity,
  themeSystem: String,
  dragRevertDuration: Number,
  dragScroll: Boolean,
  allDayMaintainDuration: Boolean,
  unselectAuto: Boolean,
  dropAccept: identity,
  eventOrder: parseFieldSpecs,
  eventOrderStrict: Boolean,
  handleWindowResize: Boolean,
  windowResizeDelay: Number,
  longPressDelay: Number,
  eventDragMinDistance: Number,
  expandRows: Boolean,
  height: identity,
  contentHeight: identity,
  direction: String,
  weekNumberFormat: createFormatter,
  eventResizableFromStart: Boolean,
  displayEventTime: Boolean,
  displayEventEnd: Boolean,
  weekText: String,
  weekTextLong: String,
  progressiveEventRendering: Boolean,
  businessHours: identity,
  initialDate: identity,
  now: identity,
  eventDataTransform: identity,
  stickyHeaderDates: identity,
  stickyFooterScrollbar: identity,
  viewHeight: identity,
  defaultAllDay: Boolean,
  eventSourceFailure: identity,
  eventSourceSuccess: identity,
  eventDisplay: String,
  eventStartEditable: Boolean,
  eventDurationEditable: Boolean,
  eventOverlap: identity,
  eventConstraint: identity,
  eventAllow: identity,
  eventBackgroundColor: String,
  eventBorderColor: String,
  eventTextColor: String,
  eventColor: String,
  eventClassNames: identity,
  eventContent: identity,
  eventDidMount: identity,
  eventWillUnmount: identity,
  selectConstraint: identity,
  selectOverlap: identity,
  selectAllow: identity,
  droppable: Boolean,
  unselectCancel: String,
  slotLabelFormat: identity,
  slotLaneClassNames: identity,
  slotLaneContent: identity,
  slotLaneDidMount: identity,
  slotLaneWillUnmount: identity,
  slotLabelClassNames: identity,
  slotLabelContent: identity,
  slotLabelDidMount: identity,
  slotLabelWillUnmount: identity,
  dayMaxEvents: identity,
  dayMaxEventRows: identity,
  dayMinWidth: Number,
  slotLabelInterval: createDuration,
  allDayText: String,
  allDayClassNames: identity,
  allDayContent: identity,
  allDayDidMount: identity,
  allDayWillUnmount: identity,
  slotMinWidth: Number,
  navLinks: Boolean,
  eventTimeFormat: createFormatter,
  rerenderDelay: Number,
  moreLinkText: identity,
  moreLinkHint: identity,
  selectMinDistance: Number,
  selectable: Boolean,
  selectLongPressDelay: Number,
  eventLongPressDelay: Number,
  selectMirror: Boolean,
  eventMaxStack: Number,
  eventMinHeight: Number,
  eventMinWidth: Number,
  eventShortHeight: Number,
  slotEventOverlap: Boolean,
  plugins: identity,
  firstDay: Number,
  dayCount: Number,
  dateAlignment: String,
  dateIncrement: createDuration,
  hiddenDays: identity,
  fixedWeekCount: Boolean,
  validRange: identity,
  visibleRange: identity,
  titleFormat: identity,
  eventInteractive: Boolean,
  // only used by list-view, but languages define the value, so we need it in base options
  noEventsText: String,
  viewHint: identity,
  navLinkHint: identity,
  closeHint: String,
  timeHint: String,
  eventHint: String,
  moreLinkClick: identity,
  moreLinkClassNames: identity,
  moreLinkContent: identity,
  moreLinkDidMount: identity,
  moreLinkWillUnmount: identity,
  monthStartFormat: createFormatter,
  // for connectors
  // (can't be part of plugin system b/c must be provided at runtime)
  handleCustomRendering: identity,
  customRenderingMetaMap: identity,
  customRenderingReplaces: Boolean
}; // do NOT give a type here. need `typeof BASE_OPTION_DEFAULTS` to give real results.
// raw values.

var BASE_OPTION_DEFAULTS = {
  eventDisplay: 'auto',
  defaultRangeSeparator: ' - ',
  titleRangeSeparator: " \u2013 ",
  defaultTimedEventDuration: '01:00:00',
  defaultAllDayEventDuration: {
    day: 1
  },
  forceEventDuration: false,
  nextDayThreshold: '00:00:00',
  dayHeaders: true,
  initialView: '',
  aspectRatio: 1.35,
  headerToolbar: {
    start: 'title',
    center: '',
    end: 'today prev,next'
  },
  weekends: true,
  weekNumbers: false,
  weekNumberCalculation: 'local',
  editable: false,
  nowIndicator: false,
  scrollTime: '06:00:00',
  scrollTimeReset: true,
  slotMinTime: '00:00:00',
  slotMaxTime: '24:00:00',
  showNonCurrentDates: true,
  lazyFetching: true,
  startParam: 'start',
  endParam: 'end',
  timeZoneParam: 'timeZone',
  timeZone: 'local',
  locales: [],
  locale: '',
  themeSystem: 'standard',
  dragRevertDuration: 500,
  dragScroll: true,
  allDayMaintainDuration: false,
  unselectAuto: true,
  dropAccept: '*',
  eventOrder: 'start,-duration,allDay,title',
  dayPopoverFormat: {
    month: 'long',
    day: 'numeric',
    year: 'numeric'
  },
  handleWindowResize: true,
  windowResizeDelay: 100,
  longPressDelay: 1000,
  eventDragMinDistance: 5,
  expandRows: false,
  navLinks: false,
  selectable: false,
  eventMinHeight: 15,
  eventMinWidth: 30,
  eventShortHeight: 30,
  monthStartFormat: {
    month: 'long',
    day: 'numeric'
  }
}; // calendar listeners
// ------------------

var CALENDAR_LISTENER_REFINERS = {
  datesSet: identity,
  eventsSet: identity,
  eventAdd: identity,
  eventChange: identity,
  eventRemove: identity,
  windowResize: identity,
  eventClick: identity,
  eventMouseEnter: identity,
  eventMouseLeave: identity,
  select: identity,
  unselect: identity,
  loading: identity,
  // internal
  _unmount: identity,
  _beforeprint: identity,
  _afterprint: identity,
  _noEventDrop: identity,
  _noEventResize: identity,
  _resize: identity,
  _scrollRequest: identity
}; // calendar-specific options
// -------------------------

var CALENDAR_OPTION_REFINERS = {
  buttonText: identity,
  buttonHints: identity,
  views: identity,
  plugins: identity,
  initialEvents: identity,
  events: identity,
  eventSources: identity
};

var COMPLEX_OPTION_COMPARATORS = _defineProperty({
  headerToolbar: isMaybeObjectsEqual,
  footerToolbar: isMaybeObjectsEqual,
  buttonText: isMaybeObjectsEqual,
  buttonHints: isMaybeObjectsEqual,
  buttonIcons: isMaybeObjectsEqual,
  dateIncrement: isMaybeObjectsEqual,
  plugins: isMaybeArraysEqual,
  events: isMaybeArraysEqual,
  eventSources: isMaybeArraysEqual
}, 'resources', isMaybeArraysEqual);

function isMaybeObjectsEqual(a, b) {
  if (_typeof(a) === 'object' && _typeof(b) === 'object' && a && b) {
    // both non-null objects
    return isPropsEqual(a, b);
  }

  return a === b;
}

function isMaybeArraysEqual(a, b) {
  if (Array.isArray(a) && Array.isArray(b)) {
    return isArraysEqual(a, b);
  }

  return a === b;
} // view-specific options
// ---------------------


var VIEW_OPTION_REFINERS = {
  type: String,
  component: identity,
  buttonText: String,
  buttonTextKey: String,
  dateProfileGeneratorClass: identity,
  usesMinMaxTime: Boolean,
  classNames: identity,
  content: identity,
  didMount: identity,
  willUnmount: identity
}; // util funcs
// ----------------------------------------------------------------------------------------------------

function mergeRawOptions(optionSets) {
  return mergeProps(optionSets, COMPLEX_OPTION_COMPARATORS);
}

function refineProps(input, refiners) {
  var refined = {};
  var extra = {};

  for (var propName in refiners) {
    if (propName in input) {
      refined[propName] = refiners[propName](input[propName]);
    }
  }

  for (var _propName in input) {
    if (!(_propName in refiners)) {
      extra[_propName] = input[_propName];
    }
  }

  return {
    refined: refined,
    extra: extra
  };
}

function identity(raw) {
  return raw;
}

var hasOwnProperty = Object.prototype.hasOwnProperty; // Merges an array of objects into a single object.
// The second argument allows for an array of property names who's object values will be merged together.

function mergeProps(propObjs, complexPropsMap) {
  var dest = {};

  if (complexPropsMap) {
    for (var name in complexPropsMap) {
      if (complexPropsMap[name] === isMaybeObjectsEqual) {
        // implies that it's object-mergeable
        var complexObjs = []; // collect the trailing object values, stopping when a non-object is discovered

        for (var i = propObjs.length - 1; i >= 0; i -= 1) {
          var val = propObjs[i][name];

          if (_typeof(val) === 'object' && val) {
            // non-null object
            complexObjs.unshift(val);
          } else if (val !== undefined) {
            dest[name] = val; // if there were no objects, this value will be used

            break;
          }
        } // if the trailing values were objects, use the merged value


        if (complexObjs.length) {
          dest[name] = mergeProps(complexObjs);
        }
      }
    }
  } // copy values into the destination, going from last to first


  for (var _i = propObjs.length - 1; _i >= 0; _i -= 1) {
    var props = propObjs[_i];

    for (var _name in props) {
      if (!(_name in dest)) {
        // if already assigned by previous props or complex props, don't reassign
        dest[_name] = props[_name];
      }
    }
  }

  return dest;
}

function filterHash(hash, func) {
  var filtered = {};

  for (var key in hash) {
    if (func(hash[key], key)) {
      filtered[key] = hash[key];
    }
  }

  return filtered;
}

function mapHash(hash, func) {
  var newHash = {};

  for (var key in hash) {
    newHash[key] = func(hash[key], key);
  }

  return newHash;
}

function arrayToHash(a) {
  var hash = {};

  var _iterator2 = _createForOfIteratorHelper(a),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var item = _step2.value;
      hash[item] = true;
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  return hash;
} // TODO: reassess browser support
// https://caniuse.com/?search=object.values


function hashValuesToArray(obj) {
  var a = [];

  for (var key in obj) {
    a.push(obj[key]);
  }

  return a;
}

function isPropsEqual(obj0, obj1) {
  if (obj0 === obj1) {
    return true;
  }

  for (var key in obj0) {
    if (hasOwnProperty.call(obj0, key)) {
      if (!(key in obj1)) {
        return false;
      }
    }
  }

  for (var _key2 in obj1) {
    if (hasOwnProperty.call(obj1, _key2)) {
      if (obj0[_key2] !== obj1[_key2]) {
        return false;
      }
    }
  }

  return true;
}

var HANDLER_RE = /^on[A-Z]/;

function isNonHandlerPropsEqual(obj0, obj1) {
  var keys = getUnequalProps(obj0, obj1);

  var _iterator3 = _createForOfIteratorHelper(keys),
      _step3;

  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var key = _step3.value;

      if (!HANDLER_RE.test(key)) {
        return false;
      }
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }

  return true;
}

function getUnequalProps(obj0, obj1) {
  var keys = [];

  for (var key in obj0) {
    if (hasOwnProperty.call(obj0, key)) {
      if (!(key in obj1)) {
        keys.push(key);
      }
    }
  }

  for (var _key3 in obj1) {
    if (hasOwnProperty.call(obj1, _key3)) {
      if (obj0[_key3] !== obj1[_key3]) {
        keys.push(_key3);
      }
    }
  }

  return keys;
}

function compareObjs(oldProps, newProps) {
  var equalityFuncs = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  if (oldProps === newProps) {
    return true;
  }

  for (var key in newProps) {
    if (key in oldProps && isObjValsEqual(oldProps[key], newProps[key], equalityFuncs[key])) ;else {
      return false;
    }
  } // check for props that were omitted in the new


  for (var _key4 in oldProps) {
    if (!(_key4 in newProps)) {
      return false;
    }
  }

  return true;
}
/*
assumed "true" equality for handler names like "onReceiveSomething"
*/


function isObjValsEqual(val0, val1, comparator) {
  if (val0 === val1 || comparator === true) {
    return true;
  }

  if (comparator) {
    return comparator(val0, val1);
  }

  return false;
}

function collectFromHash(hash) {
  var startIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var endIndex = arguments.length > 2 ? arguments[2] : undefined;
  var step = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
  var res = [];

  if (endIndex == null) {
    endIndex = Object.keys(hash).length;
  }

  for (var i = startIndex; i < endIndex; i += step) {
    var val = hash[i];

    if (val !== undefined) {
      // will disregard undefined for sparse arrays
      res.push(val);
    }
  }

  return res;
}

var calendarSystemClassMap = {};

function registerCalendarSystem(name, theClass) {
  calendarSystemClassMap[name] = theClass;
}

function createCalendarSystem(name) {
  return new calendarSystemClassMap[name]();
}

var GregorianCalendarSystem = /*#__PURE__*/function () {
  function GregorianCalendarSystem() {
    _classCallCheck(this, GregorianCalendarSystem);
  }

  _createClass(GregorianCalendarSystem, [{
    key: "getMarkerYear",
    value: function getMarkerYear(d) {
      return d.getUTCFullYear();
    }
  }, {
    key: "getMarkerMonth",
    value: function getMarkerMonth(d) {
      return d.getUTCMonth();
    }
  }, {
    key: "getMarkerDay",
    value: function getMarkerDay(d) {
      return d.getUTCDate();
    }
  }, {
    key: "arrayToMarker",
    value: function arrayToMarker(arr) {
      return arrayToUtcDate(arr);
    }
  }, {
    key: "markerToArray",
    value: function markerToArray(marker) {
      return dateToUtcArray(marker);
    }
  }]);

  return GregorianCalendarSystem;
}();

registerCalendarSystem('gregory', GregorianCalendarSystem);
var ISO_RE = /^\s*(\d{4})(-?(\d{2})(-?(\d{2})([T ](\d{2}):?(\d{2})(:?(\d{2})(\.(\d+))?)?(Z|(([-+])(\d{2})(:?(\d{2}))?))?)?)?)?$/;

function _parse(str) {
  var m = ISO_RE.exec(str);

  if (m) {
    var marker = new Date(Date.UTC(Number(m[1]), m[3] ? Number(m[3]) - 1 : 0, Number(m[5] || 1), Number(m[7] || 0), Number(m[8] || 0), Number(m[10] || 0), m[12] ? Number("0.".concat(m[12])) * 1000 : 0));

    if (isValidDate(marker)) {
      var timeZoneOffset = null;

      if (m[13]) {
        timeZoneOffset = (m[15] === '-' ? -1 : 1) * (Number(m[16] || 0) * 60 + Number(m[18] || 0));
      }

      return {
        marker: marker,
        isTimeUnspecified: !m[6],
        timeZoneOffset: timeZoneOffset
      };
    }
  }

  return null;
}

var DateEnv = /*#__PURE__*/function () {
  function DateEnv(settings) {
    _classCallCheck(this, DateEnv);

    var timeZone = this.timeZone = settings.timeZone;
    var isNamedTimeZone = timeZone !== 'local' && timeZone !== 'UTC';

    if (settings.namedTimeZoneImpl && isNamedTimeZone) {
      this.namedTimeZoneImpl = new settings.namedTimeZoneImpl(timeZone);
    }

    this.canComputeOffset = Boolean(!isNamedTimeZone || this.namedTimeZoneImpl);
    this.calendarSystem = createCalendarSystem(settings.calendarSystem);
    this.locale = settings.locale;
    this.weekDow = settings.locale.week.dow;
    this.weekDoy = settings.locale.week.doy;

    if (settings.weekNumberCalculation === 'ISO') {
      this.weekDow = 1;
      this.weekDoy = 4;
    }

    if (typeof settings.firstDay === 'number') {
      this.weekDow = settings.firstDay;
    }

    if (typeof settings.weekNumberCalculation === 'function') {
      this.weekNumberFunc = settings.weekNumberCalculation;
    }

    this.weekText = settings.weekText != null ? settings.weekText : settings.locale.options.weekText;
    this.weekTextLong = (settings.weekTextLong != null ? settings.weekTextLong : settings.locale.options.weekTextLong) || this.weekText;
    this.cmdFormatter = settings.cmdFormatter;
    this.defaultSeparator = settings.defaultSeparator;
  } // Creating / Parsing


  _createClass(DateEnv, [{
    key: "createMarker",
    value: function createMarker(input) {
      var meta = this.createMarkerMeta(input);

      if (meta === null) {
        return null;
      }

      return meta.marker;
    }
  }, {
    key: "createNowMarker",
    value: function createNowMarker() {
      if (this.canComputeOffset) {
        return this.timestampToMarker(new Date().valueOf());
      } // if we can't compute the current date val for a timezone,
      // better to give the current local date vals than UTC


      return arrayToUtcDate(dateToLocalArray(new Date()));
    }
  }, {
    key: "createMarkerMeta",
    value: function createMarkerMeta(input) {
      if (typeof input === 'string') {
        return this.parse(input);
      }

      var marker = null;

      if (typeof input === 'number') {
        marker = this.timestampToMarker(input);
      } else if (input instanceof Date) {
        input = input.valueOf();

        if (!isNaN(input)) {
          marker = this.timestampToMarker(input);
        }
      } else if (Array.isArray(input)) {
        marker = arrayToUtcDate(input);
      }

      if (marker === null || !isValidDate(marker)) {
        return null;
      }

      return {
        marker: marker,
        isTimeUnspecified: false,
        forcedTzo: null
      };
    }
  }, {
    key: "parse",
    value: function parse(s) {
      var parts = _parse(s);

      if (parts === null) {
        return null;
      }

      var marker = parts.marker;
      var forcedTzo = null;

      if (parts.timeZoneOffset !== null) {
        if (this.canComputeOffset) {
          marker = this.timestampToMarker(marker.valueOf() - parts.timeZoneOffset * 60 * 1000);
        } else {
          forcedTzo = parts.timeZoneOffset;
        }
      }

      return {
        marker: marker,
        isTimeUnspecified: parts.isTimeUnspecified,
        forcedTzo: forcedTzo
      };
    } // Accessors

  }, {
    key: "getYear",
    value: function getYear(marker) {
      return this.calendarSystem.getMarkerYear(marker);
    }
  }, {
    key: "getMonth",
    value: function getMonth(marker) {
      return this.calendarSystem.getMarkerMonth(marker);
    }
  }, {
    key: "getDay",
    value: function getDay(marker) {
      return this.calendarSystem.getMarkerDay(marker);
    } // Adding / Subtracting

  }, {
    key: "add",
    value: function add(marker, dur) {
      var a = this.calendarSystem.markerToArray(marker);
      a[0] += dur.years;
      a[1] += dur.months;
      a[2] += dur.days;
      a[6] += dur.milliseconds;
      return this.calendarSystem.arrayToMarker(a);
    }
  }, {
    key: "subtract",
    value: function subtract(marker, dur) {
      var a = this.calendarSystem.markerToArray(marker);
      a[0] -= dur.years;
      a[1] -= dur.months;
      a[2] -= dur.days;
      a[6] -= dur.milliseconds;
      return this.calendarSystem.arrayToMarker(a);
    }
  }, {
    key: "addYears",
    value: function addYears(marker, n) {
      var a = this.calendarSystem.markerToArray(marker);
      a[0] += n;
      return this.calendarSystem.arrayToMarker(a);
    }
  }, {
    key: "addMonths",
    value: function addMonths(marker, n) {
      var a = this.calendarSystem.markerToArray(marker);
      a[1] += n;
      return this.calendarSystem.arrayToMarker(a);
    } // Diffing Whole Units

  }, {
    key: "diffWholeYears",
    value: function diffWholeYears(m0, m1) {
      var calendarSystem = this.calendarSystem;

      if (timeAsMs(m0) === timeAsMs(m1) && calendarSystem.getMarkerDay(m0) === calendarSystem.getMarkerDay(m1) && calendarSystem.getMarkerMonth(m0) === calendarSystem.getMarkerMonth(m1)) {
        return calendarSystem.getMarkerYear(m1) - calendarSystem.getMarkerYear(m0);
      }

      return null;
    }
  }, {
    key: "diffWholeMonths",
    value: function diffWholeMonths(m0, m1) {
      var calendarSystem = this.calendarSystem;

      if (timeAsMs(m0) === timeAsMs(m1) && calendarSystem.getMarkerDay(m0) === calendarSystem.getMarkerDay(m1)) {
        return calendarSystem.getMarkerMonth(m1) - calendarSystem.getMarkerMonth(m0) + (calendarSystem.getMarkerYear(m1) - calendarSystem.getMarkerYear(m0)) * 12;
      }

      return null;
    } // Range / Duration

  }, {
    key: "greatestWholeUnit",
    value: function greatestWholeUnit(m0, m1) {
      var n = this.diffWholeYears(m0, m1);

      if (n !== null) {
        return {
          unit: 'year',
          value: n
        };
      }

      n = this.diffWholeMonths(m0, m1);

      if (n !== null) {
        return {
          unit: 'month',
          value: n
        };
      }

      n = diffWholeWeeks(m0, m1);

      if (n !== null) {
        return {
          unit: 'week',
          value: n
        };
      }

      n = diffWholeDays(m0, m1);

      if (n !== null) {
        return {
          unit: 'day',
          value: n
        };
      }

      n = diffHours(m0, m1);

      if (isInt(n)) {
        return {
          unit: 'hour',
          value: n
        };
      }

      n = diffMinutes(m0, m1);

      if (isInt(n)) {
        return {
          unit: 'minute',
          value: n
        };
      }

      n = diffSeconds(m0, m1);

      if (isInt(n)) {
        return {
          unit: 'second',
          value: n
        };
      }

      return {
        unit: 'millisecond',
        value: m1.valueOf() - m0.valueOf()
      };
    }
  }, {
    key: "countDurationsBetween",
    value: function countDurationsBetween(m0, m1, d) {
      // TODO: can use greatestWholeUnit
      var diff;

      if (d.years) {
        diff = this.diffWholeYears(m0, m1);

        if (diff !== null) {
          return diff / asRoughYears(d);
        }
      }

      if (d.months) {
        diff = this.diffWholeMonths(m0, m1);

        if (diff !== null) {
          return diff / asRoughMonths(d);
        }
      }

      if (d.days) {
        diff = diffWholeDays(m0, m1);

        if (diff !== null) {
          return diff / asRoughDays(d);
        }
      }

      return (m1.valueOf() - m0.valueOf()) / asRoughMs(d);
    } // Start-Of
    // these DON'T return zoned-dates. only UTC start-of dates

  }, {
    key: "startOf",
    value: function startOf(m, unit) {
      if (unit === 'year') {
        return this.startOfYear(m);
      }

      if (unit === 'month') {
        return this.startOfMonth(m);
      }

      if (unit === 'week') {
        return this.startOfWeek(m);
      }

      if (unit === 'day') {
        return startOfDay(m);
      }

      if (unit === 'hour') {
        return startOfHour(m);
      }

      if (unit === 'minute') {
        return startOfMinute(m);
      }

      if (unit === 'second') {
        return startOfSecond(m);
      }

      return null;
    }
  }, {
    key: "startOfYear",
    value: function startOfYear(m) {
      return this.calendarSystem.arrayToMarker([this.calendarSystem.getMarkerYear(m)]);
    }
  }, {
    key: "startOfMonth",
    value: function startOfMonth(m) {
      return this.calendarSystem.arrayToMarker([this.calendarSystem.getMarkerYear(m), this.calendarSystem.getMarkerMonth(m)]);
    }
  }, {
    key: "startOfWeek",
    value: function startOfWeek(m) {
      return this.calendarSystem.arrayToMarker([this.calendarSystem.getMarkerYear(m), this.calendarSystem.getMarkerMonth(m), m.getUTCDate() - (m.getUTCDay() - this.weekDow + 7) % 7]);
    } // Week Number

  }, {
    key: "computeWeekNumber",
    value: function computeWeekNumber(marker) {
      if (this.weekNumberFunc) {
        return this.weekNumberFunc(this.toDate(marker));
      }

      return weekOfYear(marker, this.weekDow, this.weekDoy);
    } // TODO: choke on timeZoneName: long

  }, {
    key: "format",
    value: function format(marker, formatter) {
      var dateOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      return formatter.format({
        marker: marker,
        timeZoneOffset: dateOptions.forcedTzo != null ? dateOptions.forcedTzo : this.offsetForMarker(marker)
      }, this);
    }
  }, {
    key: "formatRange",
    value: function formatRange(start, end, formatter) {
      var dateOptions = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

      if (dateOptions.isEndExclusive) {
        end = addMs(end, -1);
      }

      return formatter.formatRange({
        marker: start,
        timeZoneOffset: dateOptions.forcedStartTzo != null ? dateOptions.forcedStartTzo : this.offsetForMarker(start)
      }, {
        marker: end,
        timeZoneOffset: dateOptions.forcedEndTzo != null ? dateOptions.forcedEndTzo : this.offsetForMarker(end)
      }, this, dateOptions.defaultSeparator);
    }
    /*
    DUMB: the omitTime arg is dumb. if we omit the time, we want to omit the timezone offset. and if we do that,
    might as well use buildIsoString or some other util directly
    */

  }, {
    key: "formatIso",
    value: function formatIso(marker) {
      var extraOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var timeZoneOffset = null;

      if (!extraOptions.omitTimeZoneOffset) {
        if (extraOptions.forcedTzo != null) {
          timeZoneOffset = extraOptions.forcedTzo;
        } else {
          timeZoneOffset = this.offsetForMarker(marker);
        }
      }

      return buildIsoString(marker, timeZoneOffset, extraOptions.omitTime);
    } // TimeZone

  }, {
    key: "timestampToMarker",
    value: function timestampToMarker(ms) {
      if (this.timeZone === 'local') {
        return arrayToUtcDate(dateToLocalArray(new Date(ms)));
      }

      if (this.timeZone === 'UTC' || !this.namedTimeZoneImpl) {
        return new Date(ms);
      }

      return arrayToUtcDate(this.namedTimeZoneImpl.timestampToArray(ms));
    }
  }, {
    key: "offsetForMarker",
    value: function offsetForMarker(m) {
      if (this.timeZone === 'local') {
        return -arrayToLocalDate(dateToUtcArray(m)).getTimezoneOffset(); // convert "inverse" offset to "normal" offset
      }

      if (this.timeZone === 'UTC') {
        return 0;
      }

      if (this.namedTimeZoneImpl) {
        return this.namedTimeZoneImpl.offsetForArray(dateToUtcArray(m));
      }

      return null;
    } // Conversion

  }, {
    key: "toDate",
    value: function toDate(m, forcedTzo) {
      if (this.timeZone === 'local') {
        return arrayToLocalDate(dateToUtcArray(m));
      }

      if (this.timeZone === 'UTC') {
        return new Date(m.valueOf()); // make sure it's a copy
      }

      if (!this.namedTimeZoneImpl) {
        return new Date(m.valueOf() - (forcedTzo || 0));
      }

      return new Date(m.valueOf() - this.namedTimeZoneImpl.offsetForArray(dateToUtcArray(m)) * 1000 * 60);
    }
  }]);

  return DateEnv;
}();

var Theme = /*#__PURE__*/function () {
  function Theme(calendarOptions) {
    _classCallCheck(this, Theme);

    if (this.iconOverrideOption) {
      this.setIconOverride(calendarOptions[this.iconOverrideOption]);
    }
  }

  _createClass(Theme, [{
    key: "setIconOverride",
    value: function setIconOverride(iconOverrideHash) {
      var iconClassesCopy;
      var buttonName;

      if (_typeof(iconOverrideHash) === 'object' && iconOverrideHash) {
        // non-null object
        iconClassesCopy = Object.assign({}, this.iconClasses);

        for (buttonName in iconOverrideHash) {
          iconClassesCopy[buttonName] = this.applyIconOverridePrefix(iconOverrideHash[buttonName]);
        }

        this.iconClasses = iconClassesCopy;
      } else if (iconOverrideHash === false) {
        this.iconClasses = {};
      }
    }
  }, {
    key: "applyIconOverridePrefix",
    value: function applyIconOverridePrefix(className) {
      var prefix = this.iconOverridePrefix;

      if (prefix && className.indexOf(prefix) !== 0) {
        // if not already present
        className = prefix + className;
      }

      return className;
    }
  }, {
    key: "getClass",
    value: function getClass(key) {
      return this.classes[key] || '';
    }
  }, {
    key: "getIconClass",
    value: function getIconClass(buttonName, isRtl) {
      var className;

      if (isRtl && this.rtlIconClasses) {
        className = this.rtlIconClasses[buttonName] || this.iconClasses[buttonName];
      } else {
        className = this.iconClasses[buttonName];
      }

      if (className) {
        return "".concat(this.baseIconClass, " ").concat(className);
      }

      return '';
    }
  }, {
    key: "getCustomButtonIconClass",
    value: function getCustomButtonIconClass(customButtonProps) {
      var className;

      if (this.iconOverrideCustomButtonOption) {
        className = customButtonProps[this.iconOverrideCustomButtonOption];

        if (className) {
          return "".concat(this.baseIconClass, " ").concat(this.applyIconOverridePrefix(className));
        }
      }

      return '';
    }
  }]);

  return Theme;
}();

Theme.prototype.classes = {};
Theme.prototype.iconClasses = {};
Theme.prototype.baseIconClass = '';
Theme.prototype.iconOverridePrefix = '';
/*
NOTE: this can be a public API, especially createElement for hooks.
See examples/typescript-scheduler/src/index.ts
*/

function flushSync(runBeforeFlush) {
  runBeforeFlush();
  var oldDebounceRendering = preact.options.debounceRendering; // orig

  var callbackQ = [];

  function execCallbackSync(callback) {
    callbackQ.push(callback);
  }

  preact.options.debounceRendering = execCallbackSync;
  preact.render(preact.createElement(FakeComponent, {}), document.createElement('div'));

  while (callbackQ.length) {
    callbackQ.shift()();
  }

  preact.options.debounceRendering = oldDebounceRendering;
}

var FakeComponent = /*#__PURE__*/function (_preact$Component) {
  _inherits(FakeComponent, _preact$Component);

  var _super = _createSuper(FakeComponent);

  function FakeComponent() {
    _classCallCheck(this, FakeComponent);

    return _super.apply(this, arguments);
  }

  _createClass(FakeComponent, [{
    key: "render",
    value: function render() {
      return preact.createElement('div', {});
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setState({});
    }
  }]);

  return FakeComponent;
}(preact.Component); // TODO: use preact/compat instead?


function createContext(defaultValue) {
  var ContextType = preact.createContext(defaultValue);
  var origProvider = ContextType.Provider;

  ContextType.Provider = function () {
    var _this4 = this;

    var isNew = !this.getChildContext;
    var children = origProvider.apply(this, arguments); // eslint-disable-line prefer-rest-params

    if (isNew) {
      var subs = [];

      this.shouldComponentUpdate = function (_props) {
        if (_this4.props.value !== _props.value) {
          subs.forEach(function (c) {
            c.context = _props.value;
            c.forceUpdate();
          });
        }
      };

      this.sub = function (c) {
        subs.push(c);
        var old = c.componentWillUnmount;

        c.componentWillUnmount = function () {
          subs.splice(subs.indexOf(c), 1);
          old && old.call(c);
        };
      };
    }

    return children;
  };

  return ContextType;
}

var ScrollResponder = /*#__PURE__*/function () {
  function ScrollResponder(execFunc, emitter, scrollTime, scrollTimeReset) {
    var _this5 = this;

    _classCallCheck(this, ScrollResponder);

    this.execFunc = execFunc;
    this.emitter = emitter;
    this.scrollTime = scrollTime;
    this.scrollTimeReset = scrollTimeReset;

    this.handleScrollRequest = function (request) {
      _this5.queuedRequest = Object.assign({}, _this5.queuedRequest || {}, request);

      _this5.drain();
    };

    emitter.on('_scrollRequest', this.handleScrollRequest);
    this.fireInitialScroll();
  }

  _createClass(ScrollResponder, [{
    key: "detach",
    value: function detach() {
      this.emitter.off('_scrollRequest', this.handleScrollRequest);
    }
  }, {
    key: "update",
    value: function update(isDatesNew) {
      if (isDatesNew && this.scrollTimeReset) {
        this.fireInitialScroll(); // will drain
      } else {
        this.drain();
      }
    }
  }, {
    key: "fireInitialScroll",
    value: function fireInitialScroll() {
      this.handleScrollRequest({
        time: this.scrollTime
      });
    }
  }, {
    key: "drain",
    value: function drain() {
      if (this.queuedRequest && this.execFunc(this.queuedRequest)) {
        this.queuedRequest = null;
      }
    }
  }]);

  return ScrollResponder;
}();

var ViewContextType = createContext({}); // for Components

function buildViewContext(viewSpec, viewApi, viewOptions, dateProfileGenerator, dateEnv, theme, pluginHooks, dispatch, getCurrentData, emitter, calendarApi, registerInteractiveComponent, unregisterInteractiveComponent) {
  return {
    dateEnv: dateEnv,
    options: viewOptions,
    pluginHooks: pluginHooks,
    emitter: emitter,
    dispatch: dispatch,
    getCurrentData: getCurrentData,
    calendarApi: calendarApi,
    viewSpec: viewSpec,
    viewApi: viewApi,
    dateProfileGenerator: dateProfileGenerator,
    theme: theme,
    isRtl: viewOptions.direction === 'rtl',
    addResizeHandler: function addResizeHandler(handler) {
      emitter.on('_resize', handler);
    },
    removeResizeHandler: function removeResizeHandler(handler) {
      emitter.off('_resize', handler);
    },
    createScrollResponder: function createScrollResponder(execFunc) {
      return new ScrollResponder(execFunc, emitter, createDuration(viewOptions.scrollTime), viewOptions.scrollTimeReset);
    },
    registerInteractiveComponent: registerInteractiveComponent,
    unregisterInteractiveComponent: unregisterInteractiveComponent
  };
}
/* eslint max-classes-per-file: off */


var PureComponent = /*#__PURE__*/function (_Component) {
  _inherits(PureComponent, _Component);

  var _super2 = _createSuper(PureComponent);

  function PureComponent() {
    _classCallCheck(this, PureComponent);

    return _super2.apply(this, arguments);
  }

  _createClass(PureComponent, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      if (this.debug) {
        // eslint-disable-next-line no-console
        console.log(getUnequalProps(nextProps, this.props), getUnequalProps(nextState, this.state));
      }

      return !compareObjs(this.props, nextProps, this.propEquality) || !compareObjs(this.state, nextState, this.stateEquality);
    } // HACK for freakin' React StrictMode

  }, {
    key: "safeSetState",
    value: function safeSetState(newState) {
      if (!compareObjs(this.state, Object.assign(Object.assign({}, this.state), newState), this.stateEquality)) {
        this.setState(newState);
      }
    }
  }]);

  return PureComponent;
}(Component);

PureComponent.addPropsEquality = addPropsEquality;
PureComponent.addStateEquality = addStateEquality;
PureComponent.contextType = ViewContextType;
PureComponent.prototype.propEquality = {};
PureComponent.prototype.stateEquality = {};

var BaseComponent = /*#__PURE__*/function (_PureComponent) {
  _inherits(BaseComponent, _PureComponent);

  var _super3 = _createSuper(BaseComponent);

  function BaseComponent() {
    _classCallCheck(this, BaseComponent);

    return _super3.apply(this, arguments);
  }

  return BaseComponent;
}(PureComponent);

BaseComponent.contextType = ViewContextType;

function addPropsEquality(propEquality) {
  var hash = Object.create(this.prototype.propEquality);
  Object.assign(hash, propEquality);
  this.prototype.propEquality = hash;
}

function addStateEquality(stateEquality) {
  var hash = Object.create(this.prototype.stateEquality);
  Object.assign(hash, stateEquality);
  this.prototype.stateEquality = hash;
} // use other one


function setRef(ref, current) {
  if (typeof ref === 'function') {
    ref(current);
  } else if (ref) {
    // see https://github.com/facebook/react/issues/13029
    ref.current = current;
  }
}

var ContentInjector = /*#__PURE__*/function (_BaseComponent) {
  _inherits(ContentInjector, _BaseComponent);

  var _super4 = _createSuper(ContentInjector);

  function ContentInjector() {
    var _this6;

    _classCallCheck(this, ContentInjector);

    _this6 = _super4.apply(this, arguments);
    _this6.id = guid();
    _this6.queuedDomNodes = [];
    _this6.currentDomNodes = [];

    _this6.handleEl = function (el) {
      var options = _this6.context.options;
      var generatorName = _this6.props.generatorName;

      if (!options.customRenderingReplaces || !hasCustomRenderingHandler(generatorName, options)) {
        _this6.updateElRef(el);
      }
    };

    _this6.updateElRef = function (el) {
      if (_this6.props.elRef) {
        setRef(_this6.props.elRef, el);
      }
    };

    return _this6;
  }

  _createClass(ContentInjector, [{
    key: "render",
    value: function render() {
      var props = this.props,
          context = this.context;
      var options = context.options;
      var customGenerator = props.customGenerator,
          defaultGenerator = props.defaultGenerator,
          renderProps = props.renderProps;
      var attrs = buildElAttrs(props, [], this.handleEl);
      var useDefault = false;
      var innerContent;
      var queuedDomNodes = [];
      var currentGeneratorMeta;

      if (customGenerator != null) {
        var customGeneratorRes = typeof customGenerator === 'function' ? customGenerator(renderProps, createElement) : customGenerator;

        if (customGeneratorRes === true) {
          useDefault = true;
        } else {
          var isObject = customGeneratorRes && _typeof(customGeneratorRes) === 'object'; // non-null

          if (isObject && 'html' in customGeneratorRes) {
            attrs.dangerouslySetInnerHTML = {
              __html: customGeneratorRes.html
            };
          } else if (isObject && 'domNodes' in customGeneratorRes) {
            queuedDomNodes = Array.prototype.slice.call(customGeneratorRes.domNodes);
          } else if (isObject ? isValidElement(customGeneratorRes) // vdom node
          : typeof customGeneratorRes !== 'function' // primitive value (like string or number)
          ) {
              // use in vdom
              innerContent = customGeneratorRes;
            } else {
            // an exotic object for handleCustomRendering
            currentGeneratorMeta = customGeneratorRes;
          }
        }
      } else {
        useDefault = !hasCustomRenderingHandler(props.generatorName, options);
      }

      if (useDefault && defaultGenerator) {
        innerContent = defaultGenerator(renderProps);
      }

      this.queuedDomNodes = queuedDomNodes;
      this.currentGeneratorMeta = currentGeneratorMeta;
      return createElement(props.elTag, attrs, innerContent);
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.applyQueueudDomNodes();
      this.triggerCustomRendering(true);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.applyQueueudDomNodes();
      this.triggerCustomRendering(true);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.triggerCustomRendering(false); // TODO: different API for removal?
    }
  }, {
    key: "triggerCustomRendering",
    value: function triggerCustomRendering(isActive) {
      var _a;

      var props = this.props,
          context = this.context;
      var _context$options = context.options,
          handleCustomRendering = _context$options.handleCustomRendering,
          customRenderingMetaMap = _context$options.customRenderingMetaMap;

      if (handleCustomRendering) {
        var generatorMeta = (_a = this.currentGeneratorMeta) !== null && _a !== void 0 ? _a : customRenderingMetaMap === null || customRenderingMetaMap === void 0 ? void 0 : customRenderingMetaMap[props.generatorName];

        if (generatorMeta) {
          handleCustomRendering(Object.assign(Object.assign({
            id: this.id,
            isActive: isActive,
            containerEl: this.base,
            reportNewContainerEl: this.updateElRef,
            // front-end framework tells us about new container els
            generatorMeta: generatorMeta
          }, props), {
            elClasses: (props.elClasses || []).filter(isTruthy)
          }));
        }
      }
    }
  }, {
    key: "applyQueueudDomNodes",
    value: function applyQueueudDomNodes() {
      var queuedDomNodes = this.queuedDomNodes,
          currentDomNodes = this.currentDomNodes;
      var el = this.base;

      if (!isArraysEqual(queuedDomNodes, currentDomNodes)) {
        currentDomNodes.forEach(removeElement);

        var _iterator4 = _createForOfIteratorHelper(queuedDomNodes),
            _step4;

        try {
          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
            var newNode = _step4.value;
            el.appendChild(newNode);
          }
        } catch (err) {
          _iterator4.e(err);
        } finally {
          _iterator4.f();
        }

        this.currentDomNodes = queuedDomNodes;
      }
    }
  }]);

  return ContentInjector;
}(BaseComponent);

ContentInjector.addPropsEquality({
  elClasses: isArraysEqual,
  elStyle: isPropsEqual,
  elAttrs: isNonHandlerPropsEqual,
  renderProps: isPropsEqual
}); // Util

/*
Does UI-framework provide custom way of rendering that does not use Preact VDOM
AND does the calendar's options define custom rendering?
AKA. Should we NOT render the default content?
*/

function hasCustomRenderingHandler(generatorName, options) {
  var _a;

  return Boolean(options.handleCustomRendering && generatorName && ((_a = options.customRenderingMetaMap) === null || _a === void 0 ? void 0 : _a[generatorName]));
}

function buildElAttrs(props, extraClassNames, elRef) {
  var attrs = Object.assign(Object.assign({}, props.elAttrs), {
    ref: elRef
  });

  if (props.elClasses || extraClassNames) {
    attrs.className = (props.elClasses || []).concat(extraClassNames || []).concat(attrs.className || []).filter(Boolean).join(' ');
  }

  if (props.elStyle) {
    attrs.style = props.elStyle;
  }

  return attrs;
}

function isTruthy(val) {
  return Boolean(val);
}

var RenderId = createContext(0);

var ContentContainer = /*#__PURE__*/function (_Component2) {
  _inherits(ContentContainer, _Component2);

  var _super5 = _createSuper(ContentContainer);

  function ContentContainer() {
    var _this7;

    _classCallCheck(this, ContentContainer);

    _this7 = _super5.apply(this, arguments);
    _this7.InnerContent = InnerContentInjector.bind(undefined, _assertThisInitialized(_this7));

    _this7.handleEl = function (el) {
      _this7.el = el;

      if (_this7.props.elRef) {
        setRef(_this7.props.elRef, el);

        if (el && _this7.didMountMisfire) {
          _this7.componentDidMount();
        }
      }
    };

    return _this7;
  }

  _createClass(ContentContainer, [{
    key: "render",
    value: function render() {
      var props = this.props;
      var generatedClassNames = generateClassNames(props.classNameGenerator, props.renderProps);

      if (props.children) {
        var elAttrs = buildElAttrs(props, generatedClassNames, this.handleEl);
        var children = props.children(this.InnerContent, props.renderProps, elAttrs);

        if (props.elTag) {
          return createElement(props.elTag, elAttrs, children);
        } else {
          return children;
        }
      } else {
        return createElement(ContentInjector, Object.assign(Object.assign({}, props), {
          elRef: this.handleEl,
          elTag: props.elTag || 'div',
          elClasses: (props.elClasses || []).concat(generatedClassNames),
          renderId: this.context
        }));
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _a, _b;

      if (this.el) {
        (_b = (_a = this.props).didMount) === null || _b === void 0 ? void 0 : _b.call(_a, Object.assign(Object.assign({}, this.props.renderProps), {
          el: this.el
        }));
      } else {
        this.didMountMisfire = true;
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _a, _b;

      (_b = (_a = this.props).willUnmount) === null || _b === void 0 ? void 0 : _b.call(_a, Object.assign(Object.assign({}, this.props.renderProps), {
        el: this.el
      }));
    }
  }]);

  return ContentContainer;
}(Component);

ContentContainer.contextType = RenderId;

function InnerContentInjector(containerComponent, props) {
  var parentProps = containerComponent.props;
  return createElement(ContentInjector, Object.assign({
    renderProps: parentProps.renderProps,
    generatorName: parentProps.generatorName,
    customGenerator: parentProps.customGenerator,
    defaultGenerator: parentProps.defaultGenerator,
    renderId: containerComponent.context
  }, props));
} // Utils


function generateClassNames(classNameGenerator, renderProps) {
  var classNames = typeof classNameGenerator === 'function' ? classNameGenerator(renderProps) : classNameGenerator || [];
  return typeof classNames === 'string' ? [classNames] : classNames;
}

var ViewContainer = /*#__PURE__*/function (_BaseComponent2) {
  _inherits(ViewContainer, _BaseComponent2);

  var _super6 = _createSuper(ViewContainer);

  function ViewContainer() {
    _classCallCheck(this, ViewContainer);

    return _super6.apply(this, arguments);
  }

  _createClass(ViewContainer, [{
    key: "render",
    value: function render() {
      var props = this.props,
          context = this.context;
      var options = context.options;
      var renderProps = {
        view: context.viewApi
      };
      return createElement(ContentContainer, Object.assign({}, props, {
        elTag: props.elTag || 'div',
        elClasses: [].concat(_toConsumableArray(buildViewClassNames(props.viewSpec)), _toConsumableArray(props.elClasses || [])),
        renderProps: renderProps,
        classNameGenerator: options.viewClassNames,
        generatorName: undefined,
        didMount: options.viewDidMount,
        willUnmount: options.viewWillUnmount
      }), function () {
        return props.children;
      });
    }
  }]);

  return ViewContainer;
}(BaseComponent);

function buildViewClassNames(viewSpec) {
  return ["fc-".concat(viewSpec.type, "-view"), 'fc-view'];
}

function parseRange(input, dateEnv) {
  var start = null;
  var end = null;

  if (input.start) {
    start = dateEnv.createMarker(input.start);
  }

  if (input.end) {
    end = dateEnv.createMarker(input.end);
  }

  if (!start && !end) {
    return null;
  }

  if (start && end && end < start) {
    return null;
  }

  return {
    start: start,
    end: end
  };
} // SIDE-EFFECT: will mutate ranges.
// Will return a new array result.


function invertRanges(ranges, constraintRange) {
  var invertedRanges = [];
  var start = constraintRange.start; // the end of the previous range. the start of the new range

  var i;
  var dateRange; // ranges need to be in order. required for our date-walking algorithm

  ranges.sort(compareRanges);

  for (i = 0; i < ranges.length; i += 1) {
    dateRange = ranges[i]; // add the span of time before the event (if there is any)

    if (dateRange.start > start) {
      // compare millisecond time (skip any ambig logic)
      invertedRanges.push({
        start: start,
        end: dateRange.start
      });
    }

    if (dateRange.end > start) {
      start = dateRange.end;
    }
  } // add the span of time after the last event (if there is any)


  if (start < constraintRange.end) {
    // compare millisecond time (skip any ambig logic)
    invertedRanges.push({
      start: start,
      end: constraintRange.end
    });
  }

  return invertedRanges;
}

function compareRanges(range0, range1) {
  return range0.start.valueOf() - range1.start.valueOf(); // earlier ranges go first
}

function intersectRanges(range0, range1) {
  var start = range0.start,
      end = range0.end;
  var newRange = null;

  if (range1.start !== null) {
    if (start === null) {
      start = range1.start;
    } else {
      start = new Date(Math.max(start.valueOf(), range1.start.valueOf()));
    }
  }

  if (range1.end != null) {
    if (end === null) {
      end = range1.end;
    } else {
      end = new Date(Math.min(end.valueOf(), range1.end.valueOf()));
    }
  }

  if (start === null || end === null || start < end) {
    newRange = {
      start: start,
      end: end
    };
  }

  return newRange;
}

function rangesEqual(range0, range1) {
  return (range0.start === null ? null : range0.start.valueOf()) === (range1.start === null ? null : range1.start.valueOf()) && (range0.end === null ? null : range0.end.valueOf()) === (range1.end === null ? null : range1.end.valueOf());
}

function rangesIntersect(range0, range1) {
  return (range0.end === null || range1.start === null || range0.end > range1.start) && (range0.start === null || range1.end === null || range0.start < range1.end);
}

function rangeContainsRange(outerRange, innerRange) {
  return (outerRange.start === null || innerRange.start !== null && innerRange.start >= outerRange.start) && (outerRange.end === null || innerRange.end !== null && innerRange.end <= outerRange.end);
}

function rangeContainsMarker(range, date) {
  return (range.start === null || date >= range.start) && (range.end === null || date < range.end);
} // If the given date is not within the given range, move it inside.
// (If it's past the end, make it one millisecond before the end).


function constrainMarkerToRange(date, range) {
  if (range.start != null && date < range.start) {
    return range.start;
  }

  if (range.end != null && date >= range.end) {
    return new Date(range.end.valueOf() - 1);
  }

  return date;
}
/* Date stuff that doesn't belong in datelib core
----------------------------------------------------------------------------------------------------------------------*/
// given a timed range, computes an all-day range that has the same exact duration,
// but whose start time is aligned with the start of the day.


function computeAlignedDayRange(timedRange) {
  var dayCnt = Math.floor(diffDays(timedRange.start, timedRange.end)) || 1;
  var start = startOfDay(timedRange.start);
  var end = addDays(start, dayCnt);
  return {
    start: start,
    end: end
  };
} // given a timed range, computes an all-day range based on how for the end date bleeds into the next day
// TODO: give nextDayThreshold a default arg


function computeVisibleDayRange(timedRange) {
  var nextDayThreshold = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : createDuration(0);
  var startDay = null;
  var endDay = null;

  if (timedRange.end) {
    endDay = startOfDay(timedRange.end);
    var endTimeMS = timedRange.end.valueOf() - endDay.valueOf(); // # of milliseconds into `endDay`
    // If the end time is actually inclusively part of the next day and is equal to or
    // beyond the next day threshold, adjust the end to be the exclusive end of `endDay`.
    // Otherwise, leaving it as inclusive will cause it to exclude `endDay`.

    if (endTimeMS && endTimeMS >= asRoughMs(nextDayThreshold)) {
      endDay = addDays(endDay, 1);
    }
  }

  if (timedRange.start) {
    startDay = startOfDay(timedRange.start); // the beginning of the day the range starts
    // If end is within `startDay` but not past nextDayThreshold, assign the default duration of one day.

    if (endDay && endDay <= startDay) {
      endDay = addDays(startDay, 1);
    }
  }

  return {
    start: startDay,
    end: endDay
  };
} // spans from one day into another?


function isMultiDayRange(range) {
  var visibleRange = computeVisibleDayRange(range);
  return diffDays(visibleRange.start, visibleRange.end) > 1;
}

function diffDates(date0, date1, dateEnv, largeUnit) {
  if (largeUnit === 'year') {
    return createDuration(dateEnv.diffWholeYears(date0, date1), 'year');
  }

  if (largeUnit === 'month') {
    return createDuration(dateEnv.diffWholeMonths(date0, date1), 'month');
  }

  return diffDayAndTime(date0, date1); // returns a duration
}

function reduceCurrentDate(currentDate, action) {
  switch (action.type) {
    case 'CHANGE_DATE':
      return action.dateMarker;

    default:
      return currentDate;
  }
}

function getInitialDate(options, dateEnv) {
  var initialDateInput = options.initialDate; // compute the initial ambig-timezone date

  if (initialDateInput != null) {
    return dateEnv.createMarker(initialDateInput);
  }

  return getNow(options.now, dateEnv); // getNow already returns unzoned
}

function getNow(nowInput, dateEnv) {
  if (typeof nowInput === 'function') {
    nowInput = nowInput();
  }

  if (nowInput == null) {
    return dateEnv.createNowMarker();
  }

  return dateEnv.createMarker(nowInput);
}

var DateProfileGenerator = /*#__PURE__*/function () {
  function DateProfileGenerator(props) {
    _classCallCheck(this, DateProfileGenerator);

    this.props = props;
    this.nowDate = getNow(props.nowInput, props.dateEnv);
    this.initHiddenDays();
  }
  /* Date Range Computation
  ------------------------------------------------------------------------------------------------------------------*/
  // Builds a structure with info about what the dates/ranges will be for the "prev" view.


  _createClass(DateProfileGenerator, [{
    key: "buildPrev",
    value: function buildPrev(currentDateProfile, currentDate, forceToValid) {
      var dateEnv = this.props.dateEnv;
      var prevDate = dateEnv.subtract(dateEnv.startOf(currentDate, currentDateProfile.currentRangeUnit), // important for start-of-month
      currentDateProfile.dateIncrement);
      return this.build(prevDate, -1, forceToValid);
    } // Builds a structure with info about what the dates/ranges will be for the "next" view.

  }, {
    key: "buildNext",
    value: function buildNext(currentDateProfile, currentDate, forceToValid) {
      var dateEnv = this.props.dateEnv;
      var nextDate = dateEnv.add(dateEnv.startOf(currentDate, currentDateProfile.currentRangeUnit), // important for start-of-month
      currentDateProfile.dateIncrement);
      return this.build(nextDate, 1, forceToValid);
    } // Builds a structure holding dates/ranges for rendering around the given date.
    // Optional direction param indicates whether the date is being incremented/decremented
    // from its previous value. decremented = -1, incremented = 1 (default).

  }, {
    key: "build",
    value: function build(currentDate, direction) {
      var forceToValid = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      var props = this.props;
      var validRange;
      var currentInfo;
      var isRangeAllDay;
      var renderRange;
      var activeRange;
      var isValid;
      validRange = this.buildValidRange();
      validRange = this.trimHiddenDays(validRange);

      if (forceToValid) {
        currentDate = constrainMarkerToRange(currentDate, validRange);
      }

      currentInfo = this.buildCurrentRangeInfo(currentDate, direction);
      isRangeAllDay = /^(year|month|week|day)$/.test(currentInfo.unit);
      renderRange = this.buildRenderRange(this.trimHiddenDays(currentInfo.range), currentInfo.unit, isRangeAllDay);
      renderRange = this.trimHiddenDays(renderRange);
      activeRange = renderRange;

      if (!props.showNonCurrentDates) {
        activeRange = intersectRanges(activeRange, currentInfo.range);
      }

      activeRange = this.adjustActiveRange(activeRange);
      activeRange = intersectRanges(activeRange, validRange); // might return null
      // it's invalid if the originally requested date is not contained,
      // or if the range is completely outside of the valid range.

      isValid = rangesIntersect(currentInfo.range, validRange); // HACK: constrain to render-range so `currentDate` is more useful to view rendering

      if (!rangeContainsMarker(renderRange, currentDate)) {
        currentDate = renderRange.start;
      }

      return {
        currentDate: currentDate,
        // constraint for where prev/next operations can go and where events can be dragged/resized to.
        // an object with optional start and end properties.
        validRange: validRange,
        // range the view is formally responsible for.
        // for example, a month view might have 1st-31st, excluding padded dates
        currentRange: currentInfo.range,
        // name of largest unit being displayed, like "month" or "week"
        currentRangeUnit: currentInfo.unit,
        isRangeAllDay: isRangeAllDay,
        // dates that display events and accept drag-n-drop
        // will be `null` if no dates accept events
        activeRange: activeRange,
        // date range with a rendered skeleton
        // includes not-active days that need some sort of DOM
        renderRange: renderRange,
        // Duration object that denotes the first visible time of any given day
        slotMinTime: props.slotMinTime,
        // Duration object that denotes the exclusive visible end time of any given day
        slotMaxTime: props.slotMaxTime,
        isValid: isValid,
        // how far the current date will move for a prev/next operation
        dateIncrement: this.buildDateIncrement(currentInfo.duration) // pass a fallback (might be null) ^

      };
    } // Builds an object with optional start/end properties.
    // Indicates the minimum/maximum dates to display.
    // not responsible for trimming hidden days.

  }, {
    key: "buildValidRange",
    value: function buildValidRange() {
      var input = this.props.validRangeInput;
      var simpleInput = typeof input === 'function' ? input.call(this.props.calendarApi, this.nowDate) : input;
      return this.refineRange(simpleInput) || {
        start: null,
        end: null
      }; // completely open-ended
    } // Builds a structure with info about the "current" range, the range that is
    // highlighted as being the current month for example.
    // See build() for a description of `direction`.
    // Guaranteed to have `range` and `unit` properties. `duration` is optional.

  }, {
    key: "buildCurrentRangeInfo",
    value: function buildCurrentRangeInfo(date, direction) {
      var props = this.props;
      var duration = null;
      var unit = null;
      var range = null;
      var dayCount;

      if (props.duration) {
        duration = props.duration;
        unit = props.durationUnit;
        range = this.buildRangeFromDuration(date, direction, duration, unit);
      } else if (dayCount = this.props.dayCount) {
        unit = 'day';
        range = this.buildRangeFromDayCount(date, direction, dayCount);
      } else if (range = this.buildCustomVisibleRange(date)) {
        unit = props.dateEnv.greatestWholeUnit(range.start, range.end).unit;
      } else {
        duration = this.getFallbackDuration();
        unit = greatestDurationDenominator(duration).unit;
        range = this.buildRangeFromDuration(date, direction, duration, unit);
      }

      return {
        duration: duration,
        unit: unit,
        range: range
      };
    }
  }, {
    key: "getFallbackDuration",
    value: function getFallbackDuration() {
      return createDuration({
        day: 1
      });
    } // Returns a new activeRange to have time values (un-ambiguate)
    // slotMinTime or slotMaxTime causes the range to expand.

  }, {
    key: "adjustActiveRange",
    value: function adjustActiveRange(range) {
      var _this$props = this.props,
          dateEnv = _this$props.dateEnv,
          usesMinMaxTime = _this$props.usesMinMaxTime,
          slotMinTime = _this$props.slotMinTime,
          slotMaxTime = _this$props.slotMaxTime;
      var start = range.start,
          end = range.end;

      if (usesMinMaxTime) {
        // expand active range if slotMinTime is negative (why not when positive?)
        if (asRoughDays(slotMinTime) < 0) {
          start = startOfDay(start); // necessary?

          start = dateEnv.add(start, slotMinTime);
        } // expand active range if slotMaxTime is beyond one day (why not when negative?)


        if (asRoughDays(slotMaxTime) > 1) {
          end = startOfDay(end); // necessary?

          end = addDays(end, -1);
          end = dateEnv.add(end, slotMaxTime);
        }
      }

      return {
        start: start,
        end: end
      };
    } // Builds the "current" range when it is specified as an explicit duration.
    // `unit` is the already-computed greatestDurationDenominator unit of duration.

  }, {
    key: "buildRangeFromDuration",
    value: function buildRangeFromDuration(date, direction, duration, unit) {
      var _this$props2 = this.props,
          dateEnv = _this$props2.dateEnv,
          dateAlignment = _this$props2.dateAlignment;
      var start;
      var end;
      var res; // compute what the alignment should be

      if (!dateAlignment) {
        var dateIncrement = this.props.dateIncrement;

        if (dateIncrement) {
          // use the smaller of the two units
          if (asRoughMs(dateIncrement) < asRoughMs(duration)) {
            dateAlignment = greatestDurationDenominator(dateIncrement).unit;
          } else {
            dateAlignment = unit;
          }
        } else {
          dateAlignment = unit;
        }
      } // if the view displays a single day or smaller


      if (asRoughDays(duration) <= 1) {
        if (this.isHiddenDay(start)) {
          start = this.skipHiddenDays(start, direction);
          start = startOfDay(start);
        }
      }

      function computeRes() {
        start = dateEnv.startOf(date, dateAlignment);
        end = dateEnv.add(start, duration);
        res = {
          start: start,
          end: end
        };
      }

      computeRes(); // if range is completely enveloped by hidden days, go past the hidden days

      if (!this.trimHiddenDays(res)) {
        date = this.skipHiddenDays(date, direction);
        computeRes();
      }

      return res;
    } // Builds the "current" range when a dayCount is specified.

  }, {
    key: "buildRangeFromDayCount",
    value: function buildRangeFromDayCount(date, direction, dayCount) {
      var _this$props3 = this.props,
          dateEnv = _this$props3.dateEnv,
          dateAlignment = _this$props3.dateAlignment;
      var runningCount = 0;
      var start = date;
      var end;

      if (dateAlignment) {
        start = dateEnv.startOf(start, dateAlignment);
      }

      start = startOfDay(start);
      start = this.skipHiddenDays(start, direction);
      end = start;

      do {
        end = addDays(end, 1);

        if (!this.isHiddenDay(end)) {
          runningCount += 1;
        }
      } while (runningCount < dayCount);

      return {
        start: start,
        end: end
      };
    } // Builds a normalized range object for the "visible" range,
    // which is a way to define the currentRange and activeRange at the same time.

  }, {
    key: "buildCustomVisibleRange",
    value: function buildCustomVisibleRange(date) {
      var props = this.props;
      var input = props.visibleRangeInput;
      var simpleInput = typeof input === 'function' ? input.call(props.calendarApi, props.dateEnv.toDate(date)) : input;
      var range = this.refineRange(simpleInput);

      if (range && (range.start == null || range.end == null)) {
        return null;
      }

      return range;
    } // Computes the range that will represent the element/cells for *rendering*,
    // but which may have voided days/times.
    // not responsible for trimming hidden days.

  }, {
    key: "buildRenderRange",
    value: function buildRenderRange(currentRange, currentRangeUnit, isRangeAllDay) {
      return currentRange;
    } // Compute the duration value that should be added/substracted to the current date
    // when a prev/next operation happens.

  }, {
    key: "buildDateIncrement",
    value: function buildDateIncrement(fallback) {
      var dateIncrement = this.props.dateIncrement;
      var customAlignment;

      if (dateIncrement) {
        return dateIncrement;
      }

      if (customAlignment = this.props.dateAlignment) {
        return createDuration(1, customAlignment);
      }

      if (fallback) {
        return fallback;
      }

      return createDuration({
        days: 1
      });
    }
  }, {
    key: "refineRange",
    value: function refineRange(rangeInput) {
      if (rangeInput) {
        var range = parseRange(rangeInput, this.props.dateEnv);

        if (range) {
          range = computeVisibleDayRange(range);
        }

        return range;
      }

      return null;
    }
    /* Hidden Days
    ------------------------------------------------------------------------------------------------------------------*/
    // Initializes internal variables related to calculating hidden days-of-week

  }, {
    key: "initHiddenDays",
    value: function initHiddenDays() {
      var hiddenDays = this.props.hiddenDays || []; // array of day-of-week indices that are hidden

      var isHiddenDayHash = []; // is the day-of-week hidden? (hash with day-of-week-index -> bool)

      var dayCnt = 0;
      var i;

      if (this.props.weekends === false) {
        hiddenDays.push(0, 6); // 0=sunday, 6=saturday
      }

      for (i = 0; i < 7; i += 1) {
        if (!(isHiddenDayHash[i] = hiddenDays.indexOf(i) !== -1)) {
          dayCnt += 1;
        }
      }

      if (!dayCnt) {
        throw new Error('invalid hiddenDays'); // all days were hidden? bad.
      }

      this.isHiddenDayHash = isHiddenDayHash;
    } // Remove days from the beginning and end of the range that are computed as hidden.
    // If the whole range is trimmed off, returns null

  }, {
    key: "trimHiddenDays",
    value: function trimHiddenDays(range) {
      var start = range.start,
          end = range.end;

      if (start) {
        start = this.skipHiddenDays(start);
      }

      if (end) {
        end = this.skipHiddenDays(end, -1, true);
      }

      if (start == null || end == null || start < end) {
        return {
          start: start,
          end: end
        };
      }

      return null;
    } // Is the current day hidden?
    // `day` is a day-of-week index (0-6), or a Date (used for UTC)

  }, {
    key: "isHiddenDay",
    value: function isHiddenDay(day) {
      if (day instanceof Date) {
        day = day.getUTCDay();
      }

      return this.isHiddenDayHash[day];
    } // Incrementing the current day until it is no longer a hidden day, returning a copy.
    // DOES NOT CONSIDER validRange!
    // If the initial value of `date` is not a hidden day, don't do anything.
    // Pass `isExclusive` as `true` if you are dealing with an end date.
    // `inc` defaults to `1` (increment one day forward each time)

  }, {
    key: "skipHiddenDays",
    value: function skipHiddenDays(date) {
      var inc = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
      var isExclusive = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      while (this.isHiddenDayHash[(date.getUTCDay() + (isExclusive ? inc : 0) + 7) % 7]) {
        date = addDays(date, inc);
      }

      return date;
    }
  }]);

  return DateProfileGenerator;
}();

function createEventInstance(defId, range, forcedStartTzo, forcedEndTzo) {
  return {
    instanceId: guid(),
    defId: defId,
    range: range,
    forcedStartTzo: forcedStartTzo == null ? null : forcedStartTzo,
    forcedEndTzo: forcedEndTzo == null ? null : forcedEndTzo
  };
}

function parseRecurring(refined, defaultAllDay, dateEnv, recurringTypes) {
  for (var i = 0; i < recurringTypes.length; i += 1) {
    var parsed = recurringTypes[i].parse(refined, dateEnv);

    if (parsed) {
      var allDay = refined.allDay;

      if (allDay == null) {
        allDay = defaultAllDay;

        if (allDay == null) {
          allDay = parsed.allDayGuess;

          if (allDay == null) {
            allDay = false;
          }
        }
      }

      return {
        allDay: allDay,
        duration: parsed.duration,
        typeData: parsed.typeData,
        typeId: i
      };
    }
  }

  return null;
}

function expandRecurring(eventStore, framingRange, context) {
  var dateEnv = context.dateEnv,
      pluginHooks = context.pluginHooks,
      options = context.options;
  var defs = eventStore.defs,
      instances = eventStore.instances; // remove existing recurring instances
  // TODO: bad. always expand events as a second step

  instances = filterHash(instances, function (instance) {
    return !defs[instance.defId].recurringDef;
  });

  for (var defId in defs) {
    var def = defs[defId];

    if (def.recurringDef) {
      var duration = def.recurringDef.duration;

      if (!duration) {
        duration = def.allDay ? options.defaultAllDayEventDuration : options.defaultTimedEventDuration;
      }

      var starts = expandRecurringRanges(def, duration, framingRange, dateEnv, pluginHooks.recurringTypes);

      var _iterator5 = _createForOfIteratorHelper(starts),
          _step5;

      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var start = _step5.value;
          var instance = createEventInstance(defId, {
            start: start,
            end: dateEnv.add(start, duration)
          });
          instances[instance.instanceId] = instance;
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }
    }
  }

  return {
    defs: defs,
    instances: instances
  };
}
/*
Event MUST have a recurringDef
*/


function expandRecurringRanges(eventDef, duration, framingRange, dateEnv, recurringTypes) {
  var typeDef = recurringTypes[eventDef.recurringDef.typeId];
  var markers = typeDef.expand(eventDef.recurringDef.typeData, {
    start: dateEnv.subtract(framingRange.start, duration),
    end: framingRange.end
  }, dateEnv); // the recurrence plugins don't guarantee that all-day events are start-of-day, so we have to

  if (eventDef.allDay) {
    markers = markers.map(startOfDay);
  }

  return markers;
}

var EVENT_NON_DATE_REFINERS = {
  id: String,
  groupId: String,
  title: String,
  url: String,
  interactive: Boolean
};
var EVENT_DATE_REFINERS = {
  start: identity,
  end: identity,
  date: identity,
  allDay: Boolean
};
var EVENT_REFINERS = Object.assign(Object.assign(Object.assign({}, EVENT_NON_DATE_REFINERS), EVENT_DATE_REFINERS), {
  extendedProps: identity
});

function parseEvent(raw, eventSource, context, allowOpenRange) {
  var refiners = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : buildEventRefiners(context);
  var defIdMap = arguments.length > 5 ? arguments[5] : undefined;
  var instanceIdMap = arguments.length > 6 ? arguments[6] : undefined;

  var _refineEventDef = refineEventDef(raw, context, refiners),
      refined = _refineEventDef.refined,
      extra = _refineEventDef.extra;

  var defaultAllDay = computeIsDefaultAllDay(eventSource, context);
  var recurringRes = parseRecurring(refined, defaultAllDay, context.dateEnv, context.pluginHooks.recurringTypes);

  if (recurringRes) {
    var def = parseEventDef(refined, extra, eventSource ? eventSource.sourceId : '', recurringRes.allDay, Boolean(recurringRes.duration), context, defIdMap);
    def.recurringDef = {
      typeId: recurringRes.typeId,
      typeData: recurringRes.typeData,
      duration: recurringRes.duration
    };
    return {
      def: def,
      instance: null
    };
  }

  var singleRes = parseSingle(refined, defaultAllDay, context, allowOpenRange);

  if (singleRes) {
    var _def = parseEventDef(refined, extra, eventSource ? eventSource.sourceId : '', singleRes.allDay, singleRes.hasEnd, context, defIdMap);

    var instance = createEventInstance(_def.defId, singleRes.range, singleRes.forcedStartTzo, singleRes.forcedEndTzo);

    if (instanceIdMap && _def.publicId && instanceIdMap[_def.publicId]) {
      instance.instanceId = instanceIdMap[_def.publicId];
    }

    return {
      def: _def,
      instance: instance
    };
  }

  return null;
}

function refineEventDef(raw, context) {
  var refiners = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : buildEventRefiners(context);
  return refineProps(raw, refiners);
}

function buildEventRefiners(context) {
  return Object.assign(Object.assign(Object.assign({}, EVENT_UI_REFINERS), EVENT_REFINERS), context.pluginHooks.eventRefiners);
}
/*
Will NOT populate extendedProps with the leftover properties.
Will NOT populate date-related props.
*/


function parseEventDef(refined, extra, sourceId, allDay, hasEnd, context, defIdMap) {
  var def = {
    title: refined.title || '',
    groupId: refined.groupId || '',
    publicId: refined.id || '',
    url: refined.url || '',
    recurringDef: null,
    defId: (defIdMap && refined.id ? defIdMap[refined.id] : '') || guid(),
    sourceId: sourceId,
    allDay: allDay,
    hasEnd: hasEnd,
    interactive: refined.interactive,
    ui: createEventUi(refined, context),
    extendedProps: Object.assign(Object.assign({}, refined.extendedProps || {}), extra)
  };

  var _iterator6 = _createForOfIteratorHelper(context.pluginHooks.eventDefMemberAdders),
      _step6;

  try {
    for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
      var memberAdder = _step6.value;
      Object.assign(def, memberAdder(refined));
    } // help out EventImpl from having user modify props

  } catch (err) {
    _iterator6.e(err);
  } finally {
    _iterator6.f();
  }

  Object.freeze(def.ui.classNames);
  Object.freeze(def.extendedProps);
  return def;
}

function parseSingle(refined, defaultAllDay, context, allowOpenRange) {
  var allDay = refined.allDay;
  var startMeta;
  var startMarker = null;
  var hasEnd = false;
  var endMeta;
  var endMarker = null;
  var startInput = refined.start != null ? refined.start : refined.date;
  startMeta = context.dateEnv.createMarkerMeta(startInput);

  if (startMeta) {
    startMarker = startMeta.marker;
  } else if (!allowOpenRange) {
    return null;
  }

  if (refined.end != null) {
    endMeta = context.dateEnv.createMarkerMeta(refined.end);
  }

  if (allDay == null) {
    if (defaultAllDay != null) {
      allDay = defaultAllDay;
    } else {
      // fall back to the date props LAST
      allDay = (!startMeta || startMeta.isTimeUnspecified) && (!endMeta || endMeta.isTimeUnspecified);
    }
  }

  if (allDay && startMarker) {
    startMarker = startOfDay(startMarker);
  }

  if (endMeta) {
    endMarker = endMeta.marker;

    if (allDay) {
      endMarker = startOfDay(endMarker);
    }

    if (startMarker && endMarker <= startMarker) {
      endMarker = null;
    }
  }

  if (endMarker) {
    hasEnd = true;
  } else if (!allowOpenRange) {
    hasEnd = context.options.forceEventDuration || false;
    endMarker = context.dateEnv.add(startMarker, allDay ? context.options.defaultAllDayEventDuration : context.options.defaultTimedEventDuration);
  }

  return {
    allDay: allDay,
    hasEnd: hasEnd,
    range: {
      start: startMarker,
      end: endMarker
    },
    forcedStartTzo: startMeta ? startMeta.forcedTzo : null,
    forcedEndTzo: endMeta ? endMeta.forcedTzo : null
  };
}

function computeIsDefaultAllDay(eventSource, context) {
  var res = null;

  if (eventSource) {
    res = eventSource.defaultAllDay;
  }

  if (res == null) {
    res = context.options.defaultAllDay;
  }

  return res;
}

function parseEvents(rawEvents, eventSource, context, allowOpenRange, defIdMap, instanceIdMap) {
  var eventStore = createEmptyEventStore();
  var eventRefiners = buildEventRefiners(context);

  var _iterator7 = _createForOfIteratorHelper(rawEvents),
      _step7;

  try {
    for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
      var rawEvent = _step7.value;
      var tuple = parseEvent(rawEvent, eventSource, context, allowOpenRange, eventRefiners, defIdMap, instanceIdMap);

      if (tuple) {
        eventTupleToStore(tuple, eventStore);
      }
    }
  } catch (err) {
    _iterator7.e(err);
  } finally {
    _iterator7.f();
  }

  return eventStore;
}

function eventTupleToStore(tuple) {
  var eventStore = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : createEmptyEventStore();
  eventStore.defs[tuple.def.defId] = tuple.def;

  if (tuple.instance) {
    eventStore.instances[tuple.instance.instanceId] = tuple.instance;
  }

  return eventStore;
} // retrieves events that have the same groupId as the instance specified by `instanceId`
// or they are the same as the instance.
// why might instanceId not be in the store? an event from another calendar?


function getRelevantEvents(eventStore, instanceId) {
  var instance = eventStore.instances[instanceId];

  if (instance) {
    var def = eventStore.defs[instance.defId]; // get events/instances with same group

    var newStore = filterEventStoreDefs(eventStore, function (lookDef) {
      return isEventDefsGrouped(def, lookDef);
    }); // add the original
    // TODO: wish we could use eventTupleToStore or something like it

    newStore.defs[def.defId] = def;
    newStore.instances[instance.instanceId] = instance;
    return newStore;
  }

  return createEmptyEventStore();
}

function isEventDefsGrouped(def0, def1) {
  return Boolean(def0.groupId && def0.groupId === def1.groupId);
}

function createEmptyEventStore() {
  return {
    defs: {},
    instances: {}
  };
}

function mergeEventStores(store0, store1) {
  return {
    defs: Object.assign(Object.assign({}, store0.defs), store1.defs),
    instances: Object.assign(Object.assign({}, store0.instances), store1.instances)
  };
}

function filterEventStoreDefs(eventStore, filterFunc) {
  var defs = filterHash(eventStore.defs, filterFunc);
  var instances = filterHash(eventStore.instances, function (instance) {
    return defs[instance.defId] // still exists?
    ;
  });
  return {
    defs: defs,
    instances: instances
  };
}

function excludeSubEventStore(master, sub) {
  var defs = master.defs,
      instances = master.instances;
  var filteredDefs = {};
  var filteredInstances = {};

  for (var defId in defs) {
    if (!sub.defs[defId]) {
      // not explicitly excluded
      filteredDefs[defId] = defs[defId];
    }
  }

  for (var instanceId in instances) {
    if (!sub.instances[instanceId] && // not explicitly excluded
    filteredDefs[instances[instanceId].defId] // def wasn't filtered away
    ) {
        filteredInstances[instanceId] = instances[instanceId];
      }
  }

  return {
    defs: filteredDefs,
    instances: filteredInstances
  };
}

function normalizeConstraint(input, context) {
  if (Array.isArray(input)) {
    return parseEvents(input, null, context, true); // allowOpenRange=true
  }

  if (_typeof(input) === 'object' && input) {
    // non-null object
    return parseEvents([input], null, context, true); // allowOpenRange=true
  }

  if (input != null) {
    return String(input);
  }

  return null;
}

function parseClassNames(raw) {
  if (Array.isArray(raw)) {
    return raw;
  }

  if (typeof raw === 'string') {
    return raw.split(/\s+/);
  }

  return [];
} // TODO: better called "EventSettings" or "EventConfig"
// TODO: move this file into structs
// TODO: separate constraint/overlap/allow, because selection uses only that, not other props


var EVENT_UI_REFINERS = {
  display: String,
  editable: Boolean,
  startEditable: Boolean,
  durationEditable: Boolean,
  constraint: identity,
  overlap: identity,
  allow: identity,
  className: parseClassNames,
  classNames: parseClassNames,
  color: String,
  backgroundColor: String,
  borderColor: String,
  textColor: String
};
var EMPTY_EVENT_UI = {
  display: null,
  startEditable: null,
  durationEditable: null,
  constraints: [],
  overlap: null,
  allows: [],
  backgroundColor: '',
  borderColor: '',
  textColor: '',
  classNames: []
};

function createEventUi(refined, context) {
  var constraint = normalizeConstraint(refined.constraint, context);
  return {
    display: refined.display || null,
    startEditable: refined.startEditable != null ? refined.startEditable : refined.editable,
    durationEditable: refined.durationEditable != null ? refined.durationEditable : refined.editable,
    constraints: constraint != null ? [constraint] : [],
    overlap: refined.overlap != null ? refined.overlap : null,
    allows: refined.allow != null ? [refined.allow] : [],
    backgroundColor: refined.backgroundColor || refined.color || '',
    borderColor: refined.borderColor || refined.color || '',
    textColor: refined.textColor || '',
    classNames: (refined.className || []).concat(refined.classNames || []) // join singular and plural

  };
} // TODO: prevent against problems with <2 args!


function combineEventUis(uis) {
  return uis.reduce(combineTwoEventUis, EMPTY_EVENT_UI);
}

function combineTwoEventUis(item0, item1) {
  return {
    display: item1.display != null ? item1.display : item0.display,
    startEditable: item1.startEditable != null ? item1.startEditable : item0.startEditable,
    durationEditable: item1.durationEditable != null ? item1.durationEditable : item0.durationEditable,
    constraints: item0.constraints.concat(item1.constraints),
    overlap: typeof item1.overlap === 'boolean' ? item1.overlap : item0.overlap,
    allows: item0.allows.concat(item1.allows),
    backgroundColor: item1.backgroundColor || item0.backgroundColor,
    borderColor: item1.borderColor || item0.borderColor,
    textColor: item1.textColor || item0.textColor,
    classNames: item0.classNames.concat(item1.classNames)
  };
}

var EVENT_SOURCE_REFINERS = {
  id: String,
  defaultAllDay: Boolean,
  url: String,
  format: String,
  events: identity,
  eventDataTransform: identity,
  // for any network-related sources
  success: identity,
  failure: identity
};

function parseEventSource(raw, context) {
  var refiners = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : buildEventSourceRefiners(context);
  var rawObj;

  if (typeof raw === 'string') {
    rawObj = {
      url: raw
    };
  } else if (typeof raw === 'function' || Array.isArray(raw)) {
    rawObj = {
      events: raw
    };
  } else if (_typeof(raw) === 'object' && raw) {
    // not null
    rawObj = raw;
  }

  if (rawObj) {
    var _refineProps = refineProps(rawObj, refiners),
        refined = _refineProps.refined,
        extra = _refineProps.extra;

    var metaRes = buildEventSourceMeta(refined, context);

    if (metaRes) {
      return {
        _raw: raw,
        isFetching: false,
        latestFetchId: '',
        fetchRange: null,
        defaultAllDay: refined.defaultAllDay,
        eventDataTransform: refined.eventDataTransform,
        success: refined.success,
        failure: refined.failure,
        publicId: refined.id || '',
        sourceId: guid(),
        sourceDefId: metaRes.sourceDefId,
        meta: metaRes.meta,
        ui: createEventUi(refined, context),
        extendedProps: extra
      };
    }
  }

  return null;
}

function buildEventSourceRefiners(context) {
  return Object.assign(Object.assign(Object.assign({}, EVENT_UI_REFINERS), EVENT_SOURCE_REFINERS), context.pluginHooks.eventSourceRefiners);
}

function buildEventSourceMeta(raw, context) {
  var defs = context.pluginHooks.eventSourceDefs;

  for (var i = defs.length - 1; i >= 0; i -= 1) {
    // later-added plugins take precedence
    var def = defs[i];
    var meta = def.parseMeta(raw);

    if (meta) {
      return {
        sourceDefId: i,
        meta: meta
      };
    }
  }

  return null;
}

function reduceEventStore(eventStore, action, eventSources, dateProfile, context) {
  switch (action.type) {
    case 'RECEIVE_EVENTS':
      // raw
      return receiveRawEvents(eventStore, eventSources[action.sourceId], action.fetchId, action.fetchRange, action.rawEvents, context);

    case 'RESET_RAW_EVENTS':
      return resetRawEvents(eventStore, eventSources[action.sourceId], action.rawEvents, dateProfile.activeRange, context);

    case 'ADD_EVENTS':
      // already parsed, but not expanded
      return addEvent(eventStore, action.eventStore, // new ones
      dateProfile ? dateProfile.activeRange : null, context);

    case 'RESET_EVENTS':
      return action.eventStore;

    case 'MERGE_EVENTS':
      // already parsed and expanded
      return mergeEventStores(eventStore, action.eventStore);

    case 'PREV': // TODO: how do we track all actions that affect dateProfile :(

    case 'NEXT':
    case 'CHANGE_DATE':
    case 'CHANGE_VIEW_TYPE':
      if (dateProfile) {
        return expandRecurring(eventStore, dateProfile.activeRange, context);
      }

      return eventStore;

    case 'REMOVE_EVENTS':
      return excludeSubEventStore(eventStore, action.eventStore);

    case 'REMOVE_EVENT_SOURCE':
      return excludeEventsBySourceId(eventStore, action.sourceId);

    case 'REMOVE_ALL_EVENT_SOURCES':
      return filterEventStoreDefs(eventStore, function (eventDef) {
        return !eventDef.sourceId // only keep events with no source id
        ;
      });

    case 'REMOVE_ALL_EVENTS':
      return createEmptyEventStore();

    default:
      return eventStore;
  }
}

function receiveRawEvents(eventStore, eventSource, fetchId, fetchRange, rawEvents, context) {
  if (eventSource && // not already removed
  fetchId === eventSource.latestFetchId // TODO: wish this logic was always in event-sources
  ) {
      var subset = parseEvents(transformRawEvents(rawEvents, eventSource, context), eventSource, context);

      if (fetchRange) {
        subset = expandRecurring(subset, fetchRange, context);
      }

      return mergeEventStores(excludeEventsBySourceId(eventStore, eventSource.sourceId), subset);
    }

  return eventStore;
}

function resetRawEvents(existingEventStore, eventSource, rawEvents, activeRange, context) {
  var _buildPublicIdMaps = buildPublicIdMaps(existingEventStore),
      defIdMap = _buildPublicIdMaps.defIdMap,
      instanceIdMap = _buildPublicIdMaps.instanceIdMap;

  var newEventStore = parseEvents(transformRawEvents(rawEvents, eventSource, context), eventSource, context, false, defIdMap, instanceIdMap);
  return expandRecurring(newEventStore, activeRange, context);
}

function transformRawEvents(rawEvents, eventSource, context) {
  var calEachTransform = context.options.eventDataTransform;
  var sourceEachTransform = eventSource ? eventSource.eventDataTransform : null;

  if (sourceEachTransform) {
    rawEvents = transformEachRawEvent(rawEvents, sourceEachTransform);
  }

  if (calEachTransform) {
    rawEvents = transformEachRawEvent(rawEvents, calEachTransform);
  }

  return rawEvents;
}

function transformEachRawEvent(rawEvents, func) {
  var refinedEvents;

  if (!func) {
    refinedEvents = rawEvents;
  } else {
    refinedEvents = [];

    var _iterator8 = _createForOfIteratorHelper(rawEvents),
        _step8;

    try {
      for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
        var rawEvent = _step8.value;
        var refinedEvent = func(rawEvent);

        if (refinedEvent) {
          refinedEvents.push(refinedEvent);
        } else if (refinedEvent == null) {
          refinedEvents.push(rawEvent);
        } // if a different falsy value, do nothing

      }
    } catch (err) {
      _iterator8.e(err);
    } finally {
      _iterator8.f();
    }
  }

  return refinedEvents;
}

function addEvent(eventStore, subset, expandRange, context) {
  if (expandRange) {
    subset = expandRecurring(subset, expandRange, context);
  }

  return mergeEventStores(eventStore, subset);
}

function rezoneEventStoreDates(eventStore, oldDateEnv, newDateEnv) {
  var defs = eventStore.defs;
  var instances = mapHash(eventStore.instances, function (instance) {
    var def = defs[instance.defId];

    if (def.allDay) {
      return instance; // isn't dependent on timezone
    }

    return Object.assign(Object.assign({}, instance), {
      range: {
        start: newDateEnv.createMarker(oldDateEnv.toDate(instance.range.start, instance.forcedStartTzo)),
        end: newDateEnv.createMarker(oldDateEnv.toDate(instance.range.end, instance.forcedEndTzo))
      },
      forcedStartTzo: newDateEnv.canComputeOffset ? null : instance.forcedStartTzo,
      forcedEndTzo: newDateEnv.canComputeOffset ? null : instance.forcedEndTzo
    });
  });
  return {
    defs: defs,
    instances: instances
  };
}

function excludeEventsBySourceId(eventStore, sourceId) {
  return filterEventStoreDefs(eventStore, function (eventDef) {
    return eventDef.sourceId !== sourceId;
  });
} // QUESTION: why not just return instances? do a general object-property-exclusion util


function excludeInstances(eventStore, removals) {
  return {
    defs: eventStore.defs,
    instances: filterHash(eventStore.instances, function (instance) {
      return !removals[instance.instanceId];
    })
  };
}

function buildPublicIdMaps(eventStore) {
  var defs = eventStore.defs,
      instances = eventStore.instances;
  var defIdMap = {};
  var instanceIdMap = {};

  for (var defId in defs) {
    var def = defs[defId];
    var publicId = def.publicId;

    if (publicId) {
      defIdMap[publicId] = defId;
    }
  }

  for (var instanceId in instances) {
    var instance = instances[instanceId];
    var _def2 = defs[instance.defId];
    var _publicId = _def2.publicId;

    if (_publicId) {
      instanceIdMap[_publicId] = instanceId;
    }
  }

  return {
    defIdMap: defIdMap,
    instanceIdMap: instanceIdMap
  };
}

var Emitter = /*#__PURE__*/function () {
  function Emitter() {
    _classCallCheck(this, Emitter);

    this.handlers = {};
    this.thisContext = null;
  }

  _createClass(Emitter, [{
    key: "setThisContext",
    value: function setThisContext(thisContext) {
      this.thisContext = thisContext;
    }
  }, {
    key: "setOptions",
    value: function setOptions(options) {
      this.options = options;
    }
  }, {
    key: "on",
    value: function on(type, handler) {
      addToHash(this.handlers, type, handler);
    }
  }, {
    key: "off",
    value: function off(type, handler) {
      removeFromHash(this.handlers, type, handler);
    }
  }, {
    key: "trigger",
    value: function trigger(type) {
      var attachedHandlers = this.handlers[type] || [];
      var optionHandler = this.options && this.options[type];
      var handlers = [].concat(optionHandler || [], attachedHandlers);

      for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key5 = 1; _key5 < _len2; _key5++) {
        args[_key5 - 1] = arguments[_key5];
      }

      var _iterator9 = _createForOfIteratorHelper(handlers),
          _step9;

      try {
        for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
          var handler = _step9.value;
          handler.apply(this.thisContext, args);
        }
      } catch (err) {
        _iterator9.e(err);
      } finally {
        _iterator9.f();
      }
    }
  }, {
    key: "hasHandlers",
    value: function hasHandlers(type) {
      return Boolean(this.handlers[type] && this.handlers[type].length || this.options && this.options[type]);
    }
  }]);

  return Emitter;
}();

function addToHash(hash, type, handler) {
  (hash[type] || (hash[type] = [])).push(handler);
}

function removeFromHash(hash, type, handler) {
  if (handler) {
    if (hash[type]) {
      hash[type] = hash[type].filter(function (func) {
        return func !== handler;
      });
    }
  } else {
    delete hash[type]; // remove all handler funcs for this type
  }
}

var DEF_DEFAULTS = {
  startTime: '09:00',
  endTime: '17:00',
  daysOfWeek: [1, 2, 3, 4, 5],
  display: 'inverse-background',
  classNames: 'fc-non-business',
  groupId: '_businessHours' // so multiple defs get grouped

};
/*
TODO: pass around as EventDefHash!!!
*/

function parseBusinessHours(input, context) {
  return parseEvents(refineInputs(input), null, context);
}

function refineInputs(input) {
  var rawDefs;

  if (input === true) {
    rawDefs = [{}]; // will get DEF_DEFAULTS verbatim
  } else if (Array.isArray(input)) {
    // if specifying an array, every sub-definition NEEDS a day-of-week
    rawDefs = input.filter(function (rawDef) {
      return rawDef.daysOfWeek;
    });
  } else if (_typeof(input) === 'object' && input) {
    // non-null object
    rawDefs = [input];
  } else {
    // is probably false
    rawDefs = [];
  }

  rawDefs = rawDefs.map(function (rawDef) {
    return Object.assign(Object.assign({}, DEF_DEFAULTS), rawDef);
  });
  return rawDefs;
}

function triggerDateSelect(selection, pev, context) {
  context.emitter.trigger('select', Object.assign(Object.assign({}, buildDateSpanApiWithContext(selection, context)), {
    jsEvent: pev ? pev.origEvent : null,
    view: context.viewApi || context.calendarApi.view
  }));
}

function triggerDateUnselect(pev, context) {
  context.emitter.trigger('unselect', {
    jsEvent: pev ? pev.origEvent : null,
    view: context.viewApi || context.calendarApi.view
  });
}

function buildDateSpanApiWithContext(dateSpan, context) {
  var props = {};

  var _iterator10 = _createForOfIteratorHelper(context.pluginHooks.dateSpanTransforms),
      _step10;

  try {
    for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
      var transform = _step10.value;
      Object.assign(props, transform(dateSpan, context));
    }
  } catch (err) {
    _iterator10.e(err);
  } finally {
    _iterator10.f();
  }

  Object.assign(props, buildDateSpanApi(dateSpan, context.dateEnv));
  return props;
} // Given an event's allDay status and start date, return what its fallback end date should be.
// TODO: rename to computeDefaultEventEnd


function getDefaultEventEnd(allDay, marker, context) {
  var dateEnv = context.dateEnv,
      options = context.options;
  var end = marker;

  if (allDay) {
    end = startOfDay(end);
    end = dateEnv.add(end, options.defaultAllDayEventDuration);
  } else {
    end = dateEnv.add(end, options.defaultTimedEventDuration);
  }

  return end;
} // applies the mutation to ALL defs/instances within the event store


function applyMutationToEventStore(eventStore, eventConfigBase, mutation, context) {
  var eventConfigs = compileEventUis(eventStore.defs, eventConfigBase);
  var dest = createEmptyEventStore();

  for (var defId in eventStore.defs) {
    var def = eventStore.defs[defId];
    dest.defs[defId] = applyMutationToEventDef(def, eventConfigs[defId], mutation, context);
  }

  for (var instanceId in eventStore.instances) {
    var instance = eventStore.instances[instanceId];
    var _def3 = dest.defs[instance.defId]; // important to grab the newly modified def

    dest.instances[instanceId] = applyMutationToEventInstance(instance, _def3, eventConfigs[instance.defId], mutation, context);
  }

  return dest;
}

function applyMutationToEventDef(eventDef, eventConfig, mutation, context) {
  var standardProps = mutation.standardProps || {}; // if hasEnd has not been specified, guess a good value based on deltas.
  // if duration will change, there's no way the default duration will persist,
  // and thus, we need to mark the event as having a real end

  if (standardProps.hasEnd == null && eventConfig.durationEditable && (mutation.startDelta || mutation.endDelta)) {
    standardProps.hasEnd = true; // TODO: is this mutation okay?
  }

  var copy = Object.assign(Object.assign(Object.assign({}, eventDef), standardProps), {
    ui: Object.assign(Object.assign({}, eventDef.ui), standardProps.ui)
  });

  if (mutation.extendedProps) {
    copy.extendedProps = Object.assign(Object.assign({}, copy.extendedProps), mutation.extendedProps);
  }

  var _iterator11 = _createForOfIteratorHelper(context.pluginHooks.eventDefMutationAppliers),
      _step11;

  try {
    for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
      var applier = _step11.value;
      applier(copy, mutation, context);
    }
  } catch (err) {
    _iterator11.e(err);
  } finally {
    _iterator11.f();
  }

  if (!copy.hasEnd && context.options.forceEventDuration) {
    copy.hasEnd = true;
  }

  return copy;
}

function applyMutationToEventInstance(eventInstance, eventDef, // must first be modified by applyMutationToEventDef
eventConfig, mutation, context) {
  var dateEnv = context.dateEnv;
  var forceAllDay = mutation.standardProps && mutation.standardProps.allDay === true;
  var clearEnd = mutation.standardProps && mutation.standardProps.hasEnd === false;
  var copy = Object.assign({}, eventInstance);

  if (forceAllDay) {
    copy.range = computeAlignedDayRange(copy.range);
  }

  if (mutation.datesDelta && eventConfig.startEditable) {
    copy.range = {
      start: dateEnv.add(copy.range.start, mutation.datesDelta),
      end: dateEnv.add(copy.range.end, mutation.datesDelta)
    };
  }

  if (mutation.startDelta && eventConfig.durationEditable) {
    copy.range = {
      start: dateEnv.add(copy.range.start, mutation.startDelta),
      end: copy.range.end
    };
  }

  if (mutation.endDelta && eventConfig.durationEditable) {
    copy.range = {
      start: copy.range.start,
      end: dateEnv.add(copy.range.end, mutation.endDelta)
    };
  }

  if (clearEnd) {
    copy.range = {
      start: copy.range.start,
      end: getDefaultEventEnd(eventDef.allDay, copy.range.start, context)
    };
  } // in case event was all-day but the supplied deltas were not
  // better util for this?


  if (eventDef.allDay) {
    copy.range = {
      start: startOfDay(copy.range.start),
      end: startOfDay(copy.range.end)
    };
  } // handle invalid durations


  if (copy.range.end < copy.range.start) {
    copy.range.end = getDefaultEventEnd(eventDef.allDay, copy.range.start, context);
  }

  return copy;
}

var EventSourceImpl = /*#__PURE__*/function () {
  function EventSourceImpl(context, internalEventSource) {
    _classCallCheck(this, EventSourceImpl);

    this.context = context;
    this.internalEventSource = internalEventSource;
  }

  _createClass(EventSourceImpl, [{
    key: "remove",
    value: function remove() {
      this.context.dispatch({
        type: 'REMOVE_EVENT_SOURCE',
        sourceId: this.internalEventSource.sourceId
      });
    }
  }, {
    key: "refetch",
    value: function refetch() {
      this.context.dispatch({
        type: 'FETCH_EVENT_SOURCES',
        sourceIds: [this.internalEventSource.sourceId],
        isRefetch: true
      });
    }
  }, {
    key: "id",
    get: function get() {
      return this.internalEventSource.publicId;
    }
  }, {
    key: "url",
    get: function get() {
      return this.internalEventSource.meta.url;
    }
  }, {
    key: "format",
    get: function get() {
      return this.internalEventSource.meta.format; // TODO: bad. not guaranteed
    }
  }]);

  return EventSourceImpl;
}();

var EventImpl = /*#__PURE__*/function () {
  // instance will be null if expressing a recurring event that has no current instances,
  // OR if trying to validate an incoming external event that has no dates assigned
  function EventImpl(context, def, instance) {
    _classCallCheck(this, EventImpl);

    this._context = context;
    this._def = def;
    this._instance = instance || null;
  }
  /*
  TODO: make event struct more responsible for this
  */


  _createClass(EventImpl, [{
    key: "setProp",
    value: function setProp(name, val) {
      if (name in EVENT_DATE_REFINERS) {
        console.warn('Could not set date-related prop \'name\'. Use one of the date-related methods instead.'); // TODO: make proper aliasing system?
      } else if (name === 'id') {
        val = EVENT_NON_DATE_REFINERS[name](val);
        this.mutate({
          standardProps: {
            publicId: val
          } // hardcoded internal name

        });
      } else if (name in EVENT_NON_DATE_REFINERS) {
        val = EVENT_NON_DATE_REFINERS[name](val);
        this.mutate({
          standardProps: _defineProperty({}, name, val)
        });
      } else if (name in EVENT_UI_REFINERS) {
        var ui = EVENT_UI_REFINERS[name](val);

        if (name === 'color') {
          ui = {
            backgroundColor: val,
            borderColor: val
          };
        } else if (name === 'editable') {
          ui = {
            startEditable: val,
            durationEditable: val
          };
        } else {
          ui = _defineProperty({}, name, val);
        }

        this.mutate({
          standardProps: {
            ui: ui
          }
        });
      } else {
        console.warn("Could not set prop '".concat(name, "'. Use setExtendedProp instead."));
      }
    }
  }, {
    key: "setExtendedProp",
    value: function setExtendedProp(name, val) {
      this.mutate({
        extendedProps: _defineProperty({}, name, val)
      });
    }
  }, {
    key: "setStart",
    value: function setStart(startInput) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var dateEnv = this._context.dateEnv;
      var start = dateEnv.createMarker(startInput);

      if (start && this._instance) {
        // TODO: warning if parsed bad
        var instanceRange = this._instance.range;
        var startDelta = diffDates(instanceRange.start, start, dateEnv, options.granularity); // what if parsed bad!?

        if (options.maintainDuration) {
          this.mutate({
            datesDelta: startDelta
          });
        } else {
          this.mutate({
            startDelta: startDelta
          });
        }
      }
    }
  }, {
    key: "setEnd",
    value: function setEnd(endInput) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var dateEnv = this._context.dateEnv;
      var end;

      if (endInput != null) {
        end = dateEnv.createMarker(endInput);

        if (!end) {
          return; // TODO: warning if parsed bad
        }
      }

      if (this._instance) {
        if (end) {
          var endDelta = diffDates(this._instance.range.end, end, dateEnv, options.granularity);
          this.mutate({
            endDelta: endDelta
          });
        } else {
          this.mutate({
            standardProps: {
              hasEnd: false
            }
          });
        }
      }
    }
  }, {
    key: "setDates",
    value: function setDates(startInput, endInput) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var dateEnv = this._context.dateEnv;
      var standardProps = {
        allDay: options.allDay
      };
      var start = dateEnv.createMarker(startInput);
      var end;

      if (!start) {
        return; // TODO: warning if parsed bad
      }

      if (endInput != null) {
        end = dateEnv.createMarker(endInput);

        if (!end) {
          // TODO: warning if parsed bad
          return;
        }
      }

      if (this._instance) {
        var instanceRange = this._instance.range; // when computing the diff for an event being converted to all-day,
        // compute diff off of the all-day values the way event-mutation does.

        if (options.allDay === true) {
          instanceRange = computeAlignedDayRange(instanceRange);
        }

        var startDelta = diffDates(instanceRange.start, start, dateEnv, options.granularity);

        if (end) {
          var endDelta = diffDates(instanceRange.end, end, dateEnv, options.granularity);

          if (durationsEqual(startDelta, endDelta)) {
            this.mutate({
              datesDelta: startDelta,
              standardProps: standardProps
            });
          } else {
            this.mutate({
              startDelta: startDelta,
              endDelta: endDelta,
              standardProps: standardProps
            });
          }
        } else {
          // means "clear the end"
          standardProps.hasEnd = false;
          this.mutate({
            datesDelta: startDelta,
            standardProps: standardProps
          });
        }
      }
    }
  }, {
    key: "moveStart",
    value: function moveStart(deltaInput) {
      var delta = createDuration(deltaInput);

      if (delta) {
        // TODO: warning if parsed bad
        this.mutate({
          startDelta: delta
        });
      }
    }
  }, {
    key: "moveEnd",
    value: function moveEnd(deltaInput) {
      var delta = createDuration(deltaInput);

      if (delta) {
        // TODO: warning if parsed bad
        this.mutate({
          endDelta: delta
        });
      }
    }
  }, {
    key: "moveDates",
    value: function moveDates(deltaInput) {
      var delta = createDuration(deltaInput);

      if (delta) {
        // TODO: warning if parsed bad
        this.mutate({
          datesDelta: delta
        });
      }
    }
  }, {
    key: "setAllDay",
    value: function setAllDay(allDay) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var standardProps = {
        allDay: allDay
      };
      var maintainDuration = options.maintainDuration;

      if (maintainDuration == null) {
        maintainDuration = this._context.options.allDayMaintainDuration;
      }

      if (this._def.allDay !== allDay) {
        standardProps.hasEnd = maintainDuration;
      }

      this.mutate({
        standardProps: standardProps
      });
    }
  }, {
    key: "formatRange",
    value: function formatRange(formatInput) {
      var dateEnv = this._context.dateEnv;
      var instance = this._instance;
      var formatter = createFormatter(formatInput);

      if (this._def.hasEnd) {
        return dateEnv.formatRange(instance.range.start, instance.range.end, formatter, {
          forcedStartTzo: instance.forcedStartTzo,
          forcedEndTzo: instance.forcedEndTzo
        });
      }

      return dateEnv.format(instance.range.start, formatter, {
        forcedTzo: instance.forcedStartTzo
      });
    }
  }, {
    key: "mutate",
    value: function mutate(mutation) {
      var instance = this._instance;

      if (instance) {
        var def = this._def;
        var context = this._context;

        var _context$getCurrentDa = context.getCurrentData(),
            eventStore = _context$getCurrentDa.eventStore;

        var relevantEvents = getRelevantEvents(eventStore, instance.instanceId);
        var eventConfigBase = {
          '': {
            display: '',
            startEditable: true,
            durationEditable: true,
            constraints: [],
            overlap: null,
            allows: [],
            backgroundColor: '',
            borderColor: '',
            textColor: '',
            classNames: []
          }
        };
        relevantEvents = applyMutationToEventStore(relevantEvents, eventConfigBase, mutation, context);
        var oldEvent = new EventImpl(context, def, instance); // snapshot

        this._def = relevantEvents.defs[def.defId];
        this._instance = relevantEvents.instances[instance.instanceId];
        context.dispatch({
          type: 'MERGE_EVENTS',
          eventStore: relevantEvents
        });
        context.emitter.trigger('eventChange', {
          oldEvent: oldEvent,
          event: this,
          relatedEvents: buildEventApis(relevantEvents, context, instance),
          revert: function revert() {
            context.dispatch({
              type: 'RESET_EVENTS',
              eventStore: eventStore // the ORIGINAL store

            });
          }
        });
      }
    }
  }, {
    key: "remove",
    value: function remove() {
      var context = this._context;
      var asStore = eventApiToStore(this);
      context.dispatch({
        type: 'REMOVE_EVENTS',
        eventStore: asStore
      });
      context.emitter.trigger('eventRemove', {
        event: this,
        relatedEvents: [],
        revert: function revert() {
          context.dispatch({
            type: 'MERGE_EVENTS',
            eventStore: asStore
          });
        }
      });
    }
  }, {
    key: "toPlainObject",
    value: function toPlainObject() {
      var settings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var def = this._def;
      var ui = def.ui;
      var startStr = this.startStr,
          endStr = this.endStr;
      var res = {
        allDay: def.allDay
      };

      if (def.title) {
        res.title = def.title;
      }

      if (startStr) {
        res.start = startStr;
      }

      if (endStr) {
        res.end = endStr;
      }

      if (def.publicId) {
        res.id = def.publicId;
      }

      if (def.groupId) {
        res.groupId = def.groupId;
      }

      if (def.url) {
        res.url = def.url;
      }

      if (ui.display && ui.display !== 'auto') {
        res.display = ui.display;
      } // TODO: what about recurring-event properties???
      // TODO: include startEditable/durationEditable/constraint/overlap/allow


      if (settings.collapseColor && ui.backgroundColor && ui.backgroundColor === ui.borderColor) {
        res.color = ui.backgroundColor;
      } else {
        if (ui.backgroundColor) {
          res.backgroundColor = ui.backgroundColor;
        }

        if (ui.borderColor) {
          res.borderColor = ui.borderColor;
        }
      }

      if (ui.textColor) {
        res.textColor = ui.textColor;
      }

      if (ui.classNames.length) {
        res.classNames = ui.classNames;
      }

      if (Object.keys(def.extendedProps).length) {
        if (settings.collapseExtendedProps) {
          Object.assign(res, def.extendedProps);
        } else {
          res.extendedProps = def.extendedProps;
        }
      }

      return res;
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return this.toPlainObject();
    }
  }, {
    key: "source",
    get: function get() {
      var sourceId = this._def.sourceId;

      if (sourceId) {
        return new EventSourceImpl(this._context, this._context.getCurrentData().eventSources[sourceId]);
      }

      return null;
    }
  }, {
    key: "start",
    get: function get() {
      return this._instance ? this._context.dateEnv.toDate(this._instance.range.start) : null;
    }
  }, {
    key: "end",
    get: function get() {
      return this._instance && this._def.hasEnd ? this._context.dateEnv.toDate(this._instance.range.end) : null;
    }
  }, {
    key: "startStr",
    get: function get() {
      var instance = this._instance;

      if (instance) {
        return this._context.dateEnv.formatIso(instance.range.start, {
          omitTime: this._def.allDay,
          forcedTzo: instance.forcedStartTzo
        });
      }

      return '';
    }
  }, {
    key: "endStr",
    get: function get() {
      var instance = this._instance;

      if (instance && this._def.hasEnd) {
        return this._context.dateEnv.formatIso(instance.range.end, {
          omitTime: this._def.allDay,
          forcedTzo: instance.forcedEndTzo
        });
      }

      return '';
    } // computable props that all access the def
    // TODO: find a TypeScript-compatible way to do this at scale

  }, {
    key: "id",
    get: function get() {
      return this._def.publicId;
    }
  }, {
    key: "groupId",
    get: function get() {
      return this._def.groupId;
    }
  }, {
    key: "allDay",
    get: function get() {
      return this._def.allDay;
    }
  }, {
    key: "title",
    get: function get() {
      return this._def.title;
    }
  }, {
    key: "url",
    get: function get() {
      return this._def.url;
    }
  }, {
    key: "display",
    get: function get() {
      return this._def.ui.display || 'auto';
    } // bad. just normalize the type earlier

  }, {
    key: "startEditable",
    get: function get() {
      return this._def.ui.startEditable;
    }
  }, {
    key: "durationEditable",
    get: function get() {
      return this._def.ui.durationEditable;
    }
  }, {
    key: "constraint",
    get: function get() {
      return this._def.ui.constraints[0] || null;
    }
  }, {
    key: "overlap",
    get: function get() {
      return this._def.ui.overlap;
    }
  }, {
    key: "allow",
    get: function get() {
      return this._def.ui.allows[0] || null;
    }
  }, {
    key: "backgroundColor",
    get: function get() {
      return this._def.ui.backgroundColor;
    }
  }, {
    key: "borderColor",
    get: function get() {
      return this._def.ui.borderColor;
    }
  }, {
    key: "textColor",
    get: function get() {
      return this._def.ui.textColor;
    } // NOTE: user can't modify these because Object.freeze was called in event-def parsing

  }, {
    key: "classNames",
    get: function get() {
      return this._def.ui.classNames;
    }
  }, {
    key: "extendedProps",
    get: function get() {
      return this._def.extendedProps;
    }
  }]);

  return EventImpl;
}();

function eventApiToStore(eventApi) {
  var def = eventApi._def;
  var instance = eventApi._instance;
  return {
    defs: _defineProperty({}, def.defId, def),
    instances: instance ? _defineProperty({}, instance.instanceId, instance) : {}
  };
}

function buildEventApis(eventStore, context, excludeInstance) {
  var defs = eventStore.defs,
      instances = eventStore.instances;
  var eventApis = [];
  var excludeInstanceId = excludeInstance ? excludeInstance.instanceId : '';

  for (var id in instances) {
    var instance = instances[id];
    var def = defs[instance.defId];

    if (instance.instanceId !== excludeInstanceId) {
      eventApis.push(new EventImpl(context, def, instance));
    }
  }

  return eventApis;
}
/*
Specifying nextDayThreshold signals that all-day ranges should be sliced.
*/


function sliceEventStore(eventStore, eventUiBases, framingRange, nextDayThreshold) {
  var inverseBgByGroupId = {};
  var inverseBgByDefId = {};
  var defByGroupId = {};
  var bgRanges = [];
  var fgRanges = [];
  var eventUis = compileEventUis(eventStore.defs, eventUiBases);

  for (var defId in eventStore.defs) {
    var def = eventStore.defs[defId];
    var ui = eventUis[def.defId];

    if (ui.display === 'inverse-background') {
      if (def.groupId) {
        inverseBgByGroupId[def.groupId] = [];

        if (!defByGroupId[def.groupId]) {
          defByGroupId[def.groupId] = def;
        }
      } else {
        inverseBgByDefId[defId] = [];
      }
    }
  }

  for (var instanceId in eventStore.instances) {
    var instance = eventStore.instances[instanceId];
    var _def4 = eventStore.defs[instance.defId];
    var _ui2 = eventUis[_def4.defId];
    var origRange = instance.range;
    var normalRange = !_def4.allDay && nextDayThreshold ? computeVisibleDayRange(origRange, nextDayThreshold) : origRange;
    var slicedRange = intersectRanges(normalRange, framingRange);

    if (slicedRange) {
      if (_ui2.display === 'inverse-background') {
        if (_def4.groupId) {
          inverseBgByGroupId[_def4.groupId].push(slicedRange);
        } else {
          inverseBgByDefId[instance.defId].push(slicedRange);
        }
      } else if (_ui2.display !== 'none') {
        (_ui2.display === 'background' ? bgRanges : fgRanges).push({
          def: _def4,
          ui: _ui2,
          instance: instance,
          range: slicedRange,
          isStart: normalRange.start && normalRange.start.valueOf() === slicedRange.start.valueOf(),
          isEnd: normalRange.end && normalRange.end.valueOf() === slicedRange.end.valueOf()
        });
      }
    }
  }

  for (var groupId in inverseBgByGroupId) {
    // BY GROUP
    var ranges = inverseBgByGroupId[groupId];
    var invertedRanges = invertRanges(ranges, framingRange);

    var _iterator12 = _createForOfIteratorHelper(invertedRanges),
        _step12;

    try {
      for (_iterator12.s(); !(_step12 = _iterator12.n()).done;) {
        var invertedRange = _step12.value;
        var _def5 = defByGroupId[groupId];
        var _ui3 = eventUis[_def5.defId];
        bgRanges.push({
          def: _def5,
          ui: _ui3,
          instance: null,
          range: invertedRange,
          isStart: false,
          isEnd: false
        });
      }
    } catch (err) {
      _iterator12.e(err);
    } finally {
      _iterator12.f();
    }
  }

  for (var _defId in inverseBgByDefId) {
    var _ranges = inverseBgByDefId[_defId];

    var _invertedRanges = invertRanges(_ranges, framingRange);

    var _iterator13 = _createForOfIteratorHelper(_invertedRanges),
        _step13;

    try {
      for (_iterator13.s(); !(_step13 = _iterator13.n()).done;) {
        var _invertedRange = _step13.value;
        bgRanges.push({
          def: eventStore.defs[_defId],
          ui: eventUis[_defId],
          instance: null,
          range: _invertedRange,
          isStart: false,
          isEnd: false
        });
      }
    } catch (err) {
      _iterator13.e(err);
    } finally {
      _iterator13.f();
    }
  }

  return {
    bg: bgRanges,
    fg: fgRanges
  };
}

function hasBgRendering(def) {
  return def.ui.display === 'background' || def.ui.display === 'inverse-background';
}

function setElSeg(el, seg) {
  el.fcSeg = seg;
}

function getElSeg(el) {
  return el.fcSeg || el.parentNode.fcSeg || // for the harness
  null;
} // event ui computation


function compileEventUis(eventDefs, eventUiBases) {
  return mapHash(eventDefs, function (eventDef) {
    return compileEventUi(eventDef, eventUiBases);
  });
}

function compileEventUi(eventDef, eventUiBases) {
  var uis = [];

  if (eventUiBases['']) {
    uis.push(eventUiBases['']);
  }

  if (eventUiBases[eventDef.defId]) {
    uis.push(eventUiBases[eventDef.defId]);
  }

  uis.push(eventDef.ui);
  return combineEventUis(uis);
}

function sortEventSegs(segs, eventOrderSpecs) {
  var objs = segs.map(buildSegCompareObj);
  objs.sort(function (obj0, obj1) {
    return compareByFieldSpecs(obj0, obj1, eventOrderSpecs);
  });
  return objs.map(function (c) {
    return c._seg;
  });
} // returns a object with all primitive props that can be compared


function buildSegCompareObj(seg) {
  var eventRange = seg.eventRange;
  var eventDef = eventRange.def;
  var range = eventRange.instance ? eventRange.instance.range : eventRange.range;
  var start = range.start ? range.start.valueOf() : 0; // TODO: better support for open-range events

  var end = range.end ? range.end.valueOf() : 0; // "

  return Object.assign(Object.assign(Object.assign({}, eventDef.extendedProps), eventDef), {
    id: eventDef.publicId,
    start: start,
    end: end,
    duration: end - start,
    allDay: Number(eventDef.allDay),
    _seg: seg
  });
}

function computeSegDraggable(seg, context) {
  var pluginHooks = context.pluginHooks;
  var transformers = pluginHooks.isDraggableTransformers;
  var _seg$eventRange = seg.eventRange,
      def = _seg$eventRange.def,
      ui = _seg$eventRange.ui;
  var val = ui.startEditable;

  var _iterator14 = _createForOfIteratorHelper(transformers),
      _step14;

  try {
    for (_iterator14.s(); !(_step14 = _iterator14.n()).done;) {
      var transformer = _step14.value;
      val = transformer(val, def, ui, context);
    }
  } catch (err) {
    _iterator14.e(err);
  } finally {
    _iterator14.f();
  }

  return val;
}

function computeSegStartResizable(seg, context) {
  return seg.isStart && seg.eventRange.ui.durationEditable && context.options.eventResizableFromStart;
}

function computeSegEndResizable(seg, context) {
  return seg.isEnd && seg.eventRange.ui.durationEditable;
}

function buildSegTimeText(seg, timeFormat, context, defaultDisplayEventTime, // defaults to true
defaultDisplayEventEnd, // defaults to true
startOverride, endOverride) {
  var dateEnv = context.dateEnv,
      options = context.options;
  var displayEventTime = options.displayEventTime,
      displayEventEnd = options.displayEventEnd;
  var eventDef = seg.eventRange.def;
  var eventInstance = seg.eventRange.instance;

  if (displayEventTime == null) {
    displayEventTime = defaultDisplayEventTime !== false;
  }

  if (displayEventEnd == null) {
    displayEventEnd = defaultDisplayEventEnd !== false;
  }

  var wholeEventStart = eventInstance.range.start;
  var wholeEventEnd = eventInstance.range.end;
  var segStart = startOverride || seg.start || seg.eventRange.range.start;
  var segEnd = endOverride || seg.end || seg.eventRange.range.end;
  var isStartDay = startOfDay(wholeEventStart).valueOf() === startOfDay(segStart).valueOf();
  var isEndDay = startOfDay(addMs(wholeEventEnd, -1)).valueOf() === startOfDay(addMs(segEnd, -1)).valueOf();

  if (displayEventTime && !eventDef.allDay && (isStartDay || isEndDay)) {
    segStart = isStartDay ? wholeEventStart : segStart;
    segEnd = isEndDay ? wholeEventEnd : segEnd;

    if (displayEventEnd && eventDef.hasEnd) {
      return dateEnv.formatRange(segStart, segEnd, timeFormat, {
        forcedStartTzo: startOverride ? null : eventInstance.forcedStartTzo,
        forcedEndTzo: endOverride ? null : eventInstance.forcedEndTzo
      });
    }

    return dateEnv.format(segStart, timeFormat, {
      forcedTzo: startOverride ? null : eventInstance.forcedStartTzo // nooooo, same

    });
  }

  return '';
}

function getSegMeta(seg, todayRange, nowDate) {
  var segRange = seg.eventRange.range;
  return {
    isPast: segRange.end < (nowDate || todayRange.start),
    isFuture: segRange.start >= (nowDate || todayRange.end),
    isToday: todayRange && rangeContainsMarker(todayRange, segRange.start)
  };
}

function getEventClassNames(props) {
  var classNames = ['fc-event'];

  if (props.isMirror) {
    classNames.push('fc-event-mirror');
  }

  if (props.isDraggable) {
    classNames.push('fc-event-draggable');
  }

  if (props.isStartResizable || props.isEndResizable) {
    classNames.push('fc-event-resizable');
  }

  if (props.isDragging) {
    classNames.push('fc-event-dragging');
  }

  if (props.isResizing) {
    classNames.push('fc-event-resizing');
  }

  if (props.isSelected) {
    classNames.push('fc-event-selected');
  }

  if (props.isStart) {
    classNames.push('fc-event-start');
  }

  if (props.isEnd) {
    classNames.push('fc-event-end');
  }

  if (props.isPast) {
    classNames.push('fc-event-past');
  }

  if (props.isToday) {
    classNames.push('fc-event-today');
  }

  if (props.isFuture) {
    classNames.push('fc-event-future');
  }

  return classNames;
}

function buildEventRangeKey(eventRange) {
  return eventRange.instance ? eventRange.instance.instanceId : "".concat(eventRange.def.defId, ":").concat(eventRange.range.start.toISOString()); // inverse-background events don't have specific instances. TODO: better solution
}

function getSegAnchorAttrs(seg, context) {
  var _seg$eventRange2 = seg.eventRange,
      def = _seg$eventRange2.def,
      instance = _seg$eventRange2.instance;
  var url = def.url;

  if (url) {
    return {
      href: url
    };
  }

  var emitter = context.emitter,
      options = context.options;
  var eventInteractive = options.eventInteractive;

  if (eventInteractive == null) {
    eventInteractive = def.interactive;

    if (eventInteractive == null) {
      eventInteractive = Boolean(emitter.hasHandlers('eventClick'));
    }
  } // mock what happens in EventClicking


  if (eventInteractive) {
    // only attach keyboard-related handlers because click handler is already done in EventClicking
    return createAriaKeyboardAttrs(function (ev) {
      emitter.trigger('eventClick', {
        el: ev.target,
        event: new EventImpl(context, def, instance),
        jsEvent: ev,
        view: context.viewApi
      });
    });
  }

  return {};
}

var STANDARD_PROPS = {
  start: identity,
  end: identity,
  allDay: Boolean
};

function parseDateSpan(raw, dateEnv, defaultDuration) {
  var span = parseOpenDateSpan(raw, dateEnv);
  var range = span.range;

  if (!range.start) {
    return null;
  }

  if (!range.end) {
    if (defaultDuration == null) {
      return null;
    }

    range.end = dateEnv.add(range.start, defaultDuration);
  }

  return span;
}
/*
TODO: somehow combine with parseRange?
Will return null if the start/end props were present but parsed invalidly.
*/


function parseOpenDateSpan(raw, dateEnv) {
  var _refineProps2 = refineProps(raw, STANDARD_PROPS),
      standardProps = _refineProps2.refined,
      extra = _refineProps2.extra;

  var startMeta = standardProps.start ? dateEnv.createMarkerMeta(standardProps.start) : null;
  var endMeta = standardProps.end ? dateEnv.createMarkerMeta(standardProps.end) : null;
  var allDay = standardProps.allDay;

  if (allDay == null) {
    allDay = startMeta && startMeta.isTimeUnspecified && (!endMeta || endMeta.isTimeUnspecified);
  }

  return Object.assign({
    range: {
      start: startMeta ? startMeta.marker : null,
      end: endMeta ? endMeta.marker : null
    },
    allDay: allDay
  }, extra);
}

function isDateSpansEqual(span0, span1) {
  return rangesEqual(span0.range, span1.range) && span0.allDay === span1.allDay && isSpanPropsEqual(span0, span1);
} // the NON-DATE-RELATED props


function isSpanPropsEqual(span0, span1) {
  for (var propName in span1) {
    if (propName !== 'range' && propName !== 'allDay') {
      if (span0[propName] !== span1[propName]) {
        return false;
      }
    }
  } // are there any props that span0 has that span1 DOESN'T have?
  // both have range/allDay, so no need to special-case.


  for (var _propName2 in span0) {
    if (!(_propName2 in span1)) {
      return false;
    }
  }

  return true;
}

function buildDateSpanApi(span, dateEnv) {
  return Object.assign(Object.assign({}, buildRangeApi(span.range, dateEnv, span.allDay)), {
    allDay: span.allDay
  });
}

function buildRangeApiWithTimeZone(range, dateEnv, omitTime) {
  return Object.assign(Object.assign({}, buildRangeApi(range, dateEnv, omitTime)), {
    timeZone: dateEnv.timeZone
  });
}

function buildRangeApi(range, dateEnv, omitTime) {
  return {
    start: dateEnv.toDate(range.start),
    end: dateEnv.toDate(range.end),
    startStr: dateEnv.formatIso(range.start, {
      omitTime: omitTime
    }),
    endStr: dateEnv.formatIso(range.end, {
      omitTime: omitTime
    })
  };
}

function fabricateEventRange(dateSpan, eventUiBases, context) {
  var res = refineEventDef({
    editable: false
  }, context);
  var def = parseEventDef(res.refined, res.extra, '', // sourceId
  dateSpan.allDay, true, // hasEnd
  context);
  return {
    def: def,
    ui: compileEventUi(def, eventUiBases),
    instance: createEventInstance(def.defId, dateSpan.range),
    range: dateSpan.range,
    isStart: true,
    isEnd: true
  };
}
/*
given a function that resolves a result asynchronously.
the function can either call passed-in success and failure callbacks,
or it can return a promise.
if you need to pass additional params to func, bind them first.
*/


function unpromisify(func, normalizedSuccessCallback, normalizedFailureCallback) {
  // guard against success/failure callbacks being called more than once
  // and guard against a promise AND callback being used together.
  var isResolved = false;

  var wrappedSuccess = function wrappedSuccess(res) {
    if (!isResolved) {
      isResolved = true;
      normalizedSuccessCallback(res);
    }
  };

  var wrappedFailure = function wrappedFailure(error) {
    if (!isResolved) {
      isResolved = true;
      normalizedFailureCallback(error);
    }
  };

  var res = func(wrappedSuccess, wrappedFailure);

  if (res && typeof res.then === 'function') {
    res.then(wrappedSuccess, wrappedFailure);
  }
}

var JsonRequestError = /*#__PURE__*/function (_Error) {
  _inherits(JsonRequestError, _Error);

  var _super7 = _createSuper(JsonRequestError);

  function JsonRequestError(message, response) {
    var _this8;

    _classCallCheck(this, JsonRequestError);

    _this8 = _super7.call(this, message);
    _this8.response = response;
    return _this8;
  }

  return JsonRequestError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

function requestJson(method, url, params) {
  method = method.toUpperCase();
  var fetchOptions = {
    method: method
  };

  if (method === 'GET') {
    url += (url.indexOf('?') === -1 ? '?' : '&') + new URLSearchParams(params);
  } else {
    fetchOptions.body = new URLSearchParams(params);
    fetchOptions.headers = {
      'Content-Type': 'application/x-www-form-urlencoded'
    };
  }

  return fetch(url, fetchOptions).then(function (fetchRes) {
    if (fetchRes.ok) {
      return fetchRes.json().then(function (parsedResponse) {
        return [parsedResponse, fetchRes];
      }, function () {
        throw new JsonRequestError('Failure parsing JSON', fetchRes);
      });
    } else {
      throw new JsonRequestError('Request failed', fetchRes);
    }
  });
}

var canVGrowWithinCell;

function getCanVGrowWithinCell() {
  if (canVGrowWithinCell == null) {
    canVGrowWithinCell = computeCanVGrowWithinCell();
  }

  return canVGrowWithinCell;
}

function computeCanVGrowWithinCell() {
  // for SSR, because this function is call immediately at top-level
  // TODO: just make this logic execute top-level, immediately, instead of doing lazily
  if (typeof document === 'undefined') {
    return true;
  }

  var el = document.createElement('div');
  el.style.position = 'absolute';
  el.style.top = '0px';
  el.style.left = '0px';
  el.innerHTML = '<table><tr><td><div></div></td></tr></table>';
  el.querySelector('table').style.height = '100px';
  el.querySelector('div').style.height = '100%';
  document.body.appendChild(el);
  var div = el.querySelector('div');
  var possible = div.offsetHeight > 0;
  document.body.removeChild(el);
  return possible;
}

var CalendarRoot = /*#__PURE__*/function (_BaseComponent3) {
  _inherits(CalendarRoot, _BaseComponent3);

  var _super8 = _createSuper(CalendarRoot);

  function CalendarRoot() {
    var _this9;

    _classCallCheck(this, CalendarRoot);

    _this9 = _super8.apply(this, arguments);
    _this9.state = {
      forPrint: false
    };

    _this9.handleBeforePrint = function () {
      _this9.setState({
        forPrint: true
      });
    };

    _this9.handleAfterPrint = function () {
      _this9.setState({
        forPrint: false
      });
    };

    return _this9;
  }

  _createClass(CalendarRoot, [{
    key: "render",
    value: function render() {
      var props = this.props;
      var options = props.options;
      var forPrint = this.state.forPrint;
      var isHeightAuto = forPrint || options.height === 'auto' || options.contentHeight === 'auto';
      var height = !isHeightAuto && options.height != null ? options.height : '';
      var classNames = ['fc', forPrint ? 'fc-media-print' : 'fc-media-screen', "fc-direction-".concat(options.direction), props.theme.getClass('root')];

      if (!getCanVGrowWithinCell()) {
        classNames.push('fc-liquid-hack');
      }

      return props.children(classNames, height, isHeightAuto, forPrint);
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var emitter = this.props.emitter;
      emitter.on('_beforeprint', this.handleBeforePrint);
      emitter.on('_afterprint', this.handleAfterPrint);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var emitter = this.props.emitter;
      emitter.off('_beforeprint', this.handleBeforePrint);
      emitter.off('_afterprint', this.handleAfterPrint);
    }
  }]);

  return CalendarRoot;
}(BaseComponent);

var Interaction = /*#__PURE__*/function () {
  function Interaction(settings) {
    _classCallCheck(this, Interaction);

    this.component = settings.component;
    this.isHitComboAllowed = settings.isHitComboAllowed || null;
  }

  _createClass(Interaction, [{
    key: "destroy",
    value: function destroy() {}
  }]);

  return Interaction;
}();

function parseInteractionSettings(component, input) {
  return {
    component: component,
    el: input.el,
    useEventCenter: input.useEventCenter != null ? input.useEventCenter : true,
    isHitComboAllowed: input.isHitComboAllowed || null
  };
}

function interactionSettingsToStore(settings) {
  return _defineProperty({}, settings.component.uid, settings);
} // global state


var interactionSettingsStore = {};

var CalendarImpl = /*#__PURE__*/function () {
  function CalendarImpl() {
    _classCallCheck(this, CalendarImpl);
  }

  _createClass(CalendarImpl, [{
    key: "getCurrentData",
    value: function getCurrentData() {
      return this.currentDataManager.getCurrentData();
    }
  }, {
    key: "dispatch",
    value: function dispatch(action) {
      this.currentDataManager.dispatch(action);
    }
  }, {
    key: "batchRendering",
    value: function batchRendering(callback) {
      callback();
    }
  }, {
    key: "updateSize",
    value: function updateSize() {
      this.trigger('_resize', true);
    } // Options
    // -----------------------------------------------------------------------------------------------------------------

  }, {
    key: "setOption",
    value: function setOption(name, val) {
      this.dispatch({
        type: 'SET_OPTION',
        optionName: name,
        rawOptionValue: val
      });
    }
  }, {
    key: "getOption",
    value: function getOption(name) {
      return this.currentDataManager.currentCalendarOptionsInput[name];
    }
  }, {
    key: "getAvailableLocaleCodes",
    value: function getAvailableLocaleCodes() {
      return Object.keys(this.getCurrentData().availableRawLocales);
    } // Trigger
    // -----------------------------------------------------------------------------------------------------------------

  }, {
    key: "on",
    value: function on(handlerName, handler) {
      var currentDataManager = this.currentDataManager;

      if (currentDataManager.currentCalendarOptionsRefiners[handlerName]) {
        currentDataManager.emitter.on(handlerName, handler);
      } else {
        console.warn("Unknown listener name '".concat(handlerName, "'"));
      }
    }
  }, {
    key: "off",
    value: function off(handlerName, handler) {
      this.currentDataManager.emitter.off(handlerName, handler);
    } // not meant for public use

  }, {
    key: "trigger",
    value: function trigger(handlerName) {
      var _this$currentDataMana;

      for (var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key6 = 1; _key6 < _len3; _key6++) {
        args[_key6 - 1] = arguments[_key6];
      }

      (_this$currentDataMana = this.currentDataManager.emitter).trigger.apply(_this$currentDataMana, [handlerName].concat(args));
    } // View
    // -----------------------------------------------------------------------------------------------------------------

  }, {
    key: "changeView",
    value: function changeView(viewType, dateOrRange) {
      var _this10 = this;

      this.batchRendering(function () {
        _this10.unselect();

        if (dateOrRange) {
          if (dateOrRange.start && dateOrRange.end) {
            // a range
            _this10.dispatch({
              type: 'CHANGE_VIEW_TYPE',
              viewType: viewType
            });

            _this10.dispatch({
              type: 'SET_OPTION',
              optionName: 'visibleRange',
              rawOptionValue: dateOrRange
            });
          } else {
            var _this10$getCurrentDat = _this10.getCurrentData(),
                dateEnv = _this10$getCurrentDat.dateEnv;

            _this10.dispatch({
              type: 'CHANGE_VIEW_TYPE',
              viewType: viewType,
              dateMarker: dateEnv.createMarker(dateOrRange)
            });
          }
        } else {
          _this10.dispatch({
            type: 'CHANGE_VIEW_TYPE',
            viewType: viewType
          });
        }
      });
    } // Forces navigation to a view for the given date.
    // `viewType` can be a specific view name or a generic one like "week" or "day".
    // needs to change

  }, {
    key: "zoomTo",
    value: function zoomTo(dateMarker, viewType) {
      var state = this.getCurrentData();
      var spec;
      viewType = viewType || 'day'; // day is default zoom

      spec = state.viewSpecs[viewType] || this.getUnitViewSpec(viewType);
      this.unselect();

      if (spec) {
        this.dispatch({
          type: 'CHANGE_VIEW_TYPE',
          viewType: spec.type,
          dateMarker: dateMarker
        });
      } else {
        this.dispatch({
          type: 'CHANGE_DATE',
          dateMarker: dateMarker
        });
      }
    } // Given a duration singular unit, like "week" or "day", finds a matching view spec.
    // Preference is given to views that have corresponding buttons.

  }, {
    key: "getUnitViewSpec",
    value: function getUnitViewSpec(unit) {
      var _this$getCurrentData = this.getCurrentData(),
          viewSpecs = _this$getCurrentData.viewSpecs,
          toolbarConfig = _this$getCurrentData.toolbarConfig;

      var viewTypes = [].concat(toolbarConfig.header ? toolbarConfig.header.viewsWithButtons : [], toolbarConfig.footer ? toolbarConfig.footer.viewsWithButtons : []);
      var i;
      var spec;

      for (var viewType in viewSpecs) {
        viewTypes.push(viewType);
      }

      for (i = 0; i < viewTypes.length; i += 1) {
        spec = viewSpecs[viewTypes[i]];

        if (spec) {
          if (spec.singleUnit === unit) {
            return spec;
          }
        }
      }

      return null;
    } // Current Date
    // -----------------------------------------------------------------------------------------------------------------

  }, {
    key: "prev",
    value: function prev() {
      this.unselect();
      this.dispatch({
        type: 'PREV'
      });
    }
  }, {
    key: "next",
    value: function next() {
      this.unselect();
      this.dispatch({
        type: 'NEXT'
      });
    }
  }, {
    key: "prevYear",
    value: function prevYear() {
      var state = this.getCurrentData();
      this.unselect();
      this.dispatch({
        type: 'CHANGE_DATE',
        dateMarker: state.dateEnv.addYears(state.currentDate, -1)
      });
    }
  }, {
    key: "nextYear",
    value: function nextYear() {
      var state = this.getCurrentData();
      this.unselect();
      this.dispatch({
        type: 'CHANGE_DATE',
        dateMarker: state.dateEnv.addYears(state.currentDate, 1)
      });
    }
  }, {
    key: "today",
    value: function today() {
      var state = this.getCurrentData();
      this.unselect();
      this.dispatch({
        type: 'CHANGE_DATE',
        dateMarker: getNow(state.calendarOptions.now, state.dateEnv)
      });
    }
  }, {
    key: "gotoDate",
    value: function gotoDate(zonedDateInput) {
      var state = this.getCurrentData();
      this.unselect();
      this.dispatch({
        type: 'CHANGE_DATE',
        dateMarker: state.dateEnv.createMarker(zonedDateInput)
      });
    }
  }, {
    key: "incrementDate",
    value: function incrementDate(deltaInput) {
      var state = this.getCurrentData();
      var delta = createDuration(deltaInput);

      if (delta) {
        // else, warn about invalid input?
        this.unselect();
        this.dispatch({
          type: 'CHANGE_DATE',
          dateMarker: state.dateEnv.add(state.currentDate, delta)
        });
      }
    }
  }, {
    key: "getDate",
    value: function getDate() {
      var state = this.getCurrentData();
      return state.dateEnv.toDate(state.currentDate);
    } // Date Formatting Utils
    // -----------------------------------------------------------------------------------------------------------------

  }, {
    key: "formatDate",
    value: function formatDate(d, formatter) {
      var _this$getCurrentData2 = this.getCurrentData(),
          dateEnv = _this$getCurrentData2.dateEnv;

      return dateEnv.format(dateEnv.createMarker(d), createFormatter(formatter));
    } // `settings` is for formatter AND isEndExclusive

  }, {
    key: "formatRange",
    value: function formatRange(d0, d1, settings) {
      var _this$getCurrentData3 = this.getCurrentData(),
          dateEnv = _this$getCurrentData3.dateEnv;

      return dateEnv.formatRange(dateEnv.createMarker(d0), dateEnv.createMarker(d1), createFormatter(settings), settings);
    }
  }, {
    key: "formatIso",
    value: function formatIso(d, omitTime) {
      var _this$getCurrentData4 = this.getCurrentData(),
          dateEnv = _this$getCurrentData4.dateEnv;

      return dateEnv.formatIso(dateEnv.createMarker(d), {
        omitTime: omitTime
      });
    } // Date Selection / Event Selection / DayClick
    // -----------------------------------------------------------------------------------------------------------------

  }, {
    key: "select",
    value: function select(dateOrObj, endDate) {
      var selectionInput;

      if (endDate == null) {
        if (dateOrObj.start != null) {
          selectionInput = dateOrObj;
        } else {
          selectionInput = {
            start: dateOrObj,
            end: null
          };
        }
      } else {
        selectionInput = {
          start: dateOrObj,
          end: endDate
        };
      }

      var state = this.getCurrentData();
      var selection = parseDateSpan(selectionInput, state.dateEnv, createDuration({
        days: 1
      }));

      if (selection) {
        // throw parse error otherwise?
        this.dispatch({
          type: 'SELECT_DATES',
          selection: selection
        });
        triggerDateSelect(selection, null, state);
      }
    }
  }, {
    key: "unselect",
    value: function unselect(pev) {
      var state = this.getCurrentData();

      if (state.dateSelection) {
        this.dispatch({
          type: 'UNSELECT_DATES'
        });
        triggerDateUnselect(pev, state);
      }
    } // Public Events API
    // -----------------------------------------------------------------------------------------------------------------

  }, {
    key: "addEvent",
    value: function addEvent(eventInput, sourceInput) {
      if (eventInput instanceof EventImpl) {
        var def = eventInput._def;
        var instance = eventInput._instance;
        var currentData = this.getCurrentData(); // not already present? don't want to add an old snapshot

        if (!currentData.eventStore.defs[def.defId]) {
          this.dispatch({
            type: 'ADD_EVENTS',
            eventStore: eventTupleToStore({
              def: def,
              instance: instance
            }) // TODO: better util for two args?

          });
          this.triggerEventAdd(eventInput);
        }

        return eventInput;
      }

      var state = this.getCurrentData();
      var eventSource;

      if (sourceInput instanceof EventSourceImpl) {
        eventSource = sourceInput.internalEventSource;
      } else if (typeof sourceInput === 'boolean') {
        if (sourceInput) {
          // true. part of the first event source
          var _hashValuesToArray = hashValuesToArray(state.eventSources);

          var _hashValuesToArray2 = _slicedToArray(_hashValuesToArray, 1);

          eventSource = _hashValuesToArray2[0];
        }
      } else if (sourceInput != null) {
        // an ID. accepts a number too
        var sourceApi = this.getEventSourceById(sourceInput); // TODO: use an internal function

        if (!sourceApi) {
          console.warn("Could not find an event source with ID \"".concat(sourceInput, "\"")); // TODO: test

          return null;
        }

        eventSource = sourceApi.internalEventSource;
      }

      var tuple = parseEvent(eventInput, eventSource, state, false);

      if (tuple) {
        var newEventApi = new EventImpl(state, tuple.def, tuple.def.recurringDef ? null : tuple.instance);
        this.dispatch({
          type: 'ADD_EVENTS',
          eventStore: eventTupleToStore(tuple)
        });
        this.triggerEventAdd(newEventApi);
        return newEventApi;
      }

      return null;
    }
  }, {
    key: "triggerEventAdd",
    value: function triggerEventAdd(eventApi) {
      var _this11 = this;

      var _this$getCurrentData5 = this.getCurrentData(),
          emitter = _this$getCurrentData5.emitter;

      emitter.trigger('eventAdd', {
        event: eventApi,
        relatedEvents: [],
        revert: function revert() {
          _this11.dispatch({
            type: 'REMOVE_EVENTS',
            eventStore: eventApiToStore(eventApi)
          });
        }
      });
    } // TODO: optimize

  }, {
    key: "getEventById",
    value: function getEventById(id) {
      var state = this.getCurrentData();
      var _state$eventStore = state.eventStore,
          defs = _state$eventStore.defs,
          instances = _state$eventStore.instances;
      id = String(id);

      for (var defId in defs) {
        var def = defs[defId];

        if (def.publicId === id) {
          if (def.recurringDef) {
            return new EventImpl(state, def, null);
          }

          for (var instanceId in instances) {
            var instance = instances[instanceId];

            if (instance.defId === def.defId) {
              return new EventImpl(state, def, instance);
            }
          }
        }
      }

      return null;
    }
  }, {
    key: "getEvents",
    value: function getEvents() {
      var currentData = this.getCurrentData();
      return buildEventApis(currentData.eventStore, currentData);
    }
  }, {
    key: "removeAllEvents",
    value: function removeAllEvents() {
      this.dispatch({
        type: 'REMOVE_ALL_EVENTS'
      });
    } // Public Event Sources API
    // -----------------------------------------------------------------------------------------------------------------

  }, {
    key: "getEventSources",
    value: function getEventSources() {
      var state = this.getCurrentData();
      var sourceHash = state.eventSources;
      var sourceApis = [];

      for (var internalId in sourceHash) {
        sourceApis.push(new EventSourceImpl(state, sourceHash[internalId]));
      }

      return sourceApis;
    }
  }, {
    key: "getEventSourceById",
    value: function getEventSourceById(id) {
      var state = this.getCurrentData();
      var sourceHash = state.eventSources;
      id = String(id);

      for (var sourceId in sourceHash) {
        if (sourceHash[sourceId].publicId === id) {
          return new EventSourceImpl(state, sourceHash[sourceId]);
        }
      }

      return null;
    }
  }, {
    key: "addEventSource",
    value: function addEventSource(sourceInput) {
      var state = this.getCurrentData();

      if (sourceInput instanceof EventSourceImpl) {
        // not already present? don't want to add an old snapshot
        if (!state.eventSources[sourceInput.internalEventSource.sourceId]) {
          this.dispatch({
            type: 'ADD_EVENT_SOURCES',
            sources: [sourceInput.internalEventSource]
          });
        }

        return sourceInput;
      }

      var eventSource = parseEventSource(sourceInput, state);

      if (eventSource) {
        // TODO: error otherwise?
        this.dispatch({
          type: 'ADD_EVENT_SOURCES',
          sources: [eventSource]
        });
        return new EventSourceImpl(state, eventSource);
      }

      return null;
    }
  }, {
    key: "removeAllEventSources",
    value: function removeAllEventSources() {
      this.dispatch({
        type: 'REMOVE_ALL_EVENT_SOURCES'
      });
    }
  }, {
    key: "refetchEvents",
    value: function refetchEvents() {
      this.dispatch({
        type: 'FETCH_EVENT_SOURCES',
        isRefetch: true
      });
    } // Scroll
    // -----------------------------------------------------------------------------------------------------------------

  }, {
    key: "scrollToTime",
    value: function scrollToTime(timeInput) {
      var time = createDuration(timeInput);

      if (time) {
        this.trigger('_scrollRequest', {
          time: time
        });
      }
    }
  }, {
    key: "view",
    get: function get() {
      return this.getCurrentData().viewApi;
    }
  }]);

  return CalendarImpl;
}();

function pointInsideRect(point, rect) {
  return point.left >= rect.left && point.left < rect.right && point.top >= rect.top && point.top < rect.bottom;
} // Returns a new rectangle that is the intersection of the two rectangles. If they don't intersect, returns false


function intersectRects(rect1, rect2) {
  var res = {
    left: Math.max(rect1.left, rect2.left),
    right: Math.min(rect1.right, rect2.right),
    top: Math.max(rect1.top, rect2.top),
    bottom: Math.min(rect1.bottom, rect2.bottom)
  };

  if (res.left < res.right && res.top < res.bottom) {
    return res;
  }

  return false;
}

function translateRect(rect, deltaX, deltaY) {
  return {
    left: rect.left + deltaX,
    right: rect.right + deltaX,
    top: rect.top + deltaY,
    bottom: rect.bottom + deltaY
  };
} // Returns a new point that will have been moved to reside within the given rectangle


function constrainPoint(point, rect) {
  return {
    left: Math.min(Math.max(point.left, rect.left), rect.right),
    top: Math.min(Math.max(point.top, rect.top), rect.bottom)
  };
} // Returns a point that is the center of the given rectangle


function getRectCenter(rect) {
  return {
    left: (rect.left + rect.right) / 2,
    top: (rect.top + rect.bottom) / 2
  };
} // Subtracts point2's coordinates from point1's coordinates, returning a delta


function diffPoints(point1, point2) {
  return {
    left: point1.left - point2.left,
    top: point1.top - point2.top
  };
}

var EMPTY_EVENT_STORE = createEmptyEventStore(); // for purecomponents. TODO: keep elsewhere

var Splitter = /*#__PURE__*/function () {
  function Splitter() {
    _classCallCheck(this, Splitter);

    this.getKeysForEventDefs = memoize(this._getKeysForEventDefs);
    this.splitDateSelection = memoize(this._splitDateSpan);
    this.splitEventStore = memoize(this._splitEventStore);
    this.splitIndividualUi = memoize(this._splitIndividualUi);
    this.splitEventDrag = memoize(this._splitInteraction);
    this.splitEventResize = memoize(this._splitInteraction);
    this.eventUiBuilders = {}; // TODO: typescript protection
  }

  _createClass(Splitter, [{
    key: "splitProps",
    value: function splitProps(props) {
      var _this12 = this;

      var keyInfos = this.getKeyInfo(props);
      var defKeys = this.getKeysForEventDefs(props.eventStore);
      var dateSelections = this.splitDateSelection(props.dateSelection);
      var individualUi = this.splitIndividualUi(props.eventUiBases, defKeys); // the individual *bases*

      var eventStores = this.splitEventStore(props.eventStore, defKeys);
      var eventDrags = this.splitEventDrag(props.eventDrag);
      var eventResizes = this.splitEventResize(props.eventResize);
      var splitProps = {};
      this.eventUiBuilders = mapHash(keyInfos, function (info, key) {
        return _this12.eventUiBuilders[key] || memoize(buildEventUiForKey);
      });

      for (var key in keyInfos) {
        var keyInfo = keyInfos[key];
        var eventStore = eventStores[key] || EMPTY_EVENT_STORE;
        var buildEventUi = this.eventUiBuilders[key];
        splitProps[key] = {
          businessHours: keyInfo.businessHours || props.businessHours,
          dateSelection: dateSelections[key] || null,
          eventStore: eventStore,
          eventUiBases: buildEventUi(props.eventUiBases[''], keyInfo.ui, individualUi[key]),
          eventSelection: eventStore.instances[props.eventSelection] ? props.eventSelection : '',
          eventDrag: eventDrags[key] || null,
          eventResize: eventResizes[key] || null
        };
      }

      return splitProps;
    }
  }, {
    key: "_splitDateSpan",
    value: function _splitDateSpan(dateSpan) {
      var dateSpans = {};

      if (dateSpan) {
        var keys = this.getKeysForDateSpan(dateSpan);

        var _iterator15 = _createForOfIteratorHelper(keys),
            _step15;

        try {
          for (_iterator15.s(); !(_step15 = _iterator15.n()).done;) {
            var key = _step15.value;
            dateSpans[key] = dateSpan;
          }
        } catch (err) {
          _iterator15.e(err);
        } finally {
          _iterator15.f();
        }
      }

      return dateSpans;
    }
  }, {
    key: "_getKeysForEventDefs",
    value: function _getKeysForEventDefs(eventStore) {
      var _this13 = this;

      return mapHash(eventStore.defs, function (eventDef) {
        return _this13.getKeysForEventDef(eventDef);
      });
    }
  }, {
    key: "_splitEventStore",
    value: function _splitEventStore(eventStore, defKeys) {
      var defs = eventStore.defs,
          instances = eventStore.instances;
      var splitStores = {};

      for (var defId in defs) {
        var _iterator16 = _createForOfIteratorHelper(defKeys[defId]),
            _step16;

        try {
          for (_iterator16.s(); !(_step16 = _iterator16.n()).done;) {
            var key = _step16.value;

            if (!splitStores[key]) {
              splitStores[key] = createEmptyEventStore();
            }

            splitStores[key].defs[defId] = defs[defId];
          }
        } catch (err) {
          _iterator16.e(err);
        } finally {
          _iterator16.f();
        }
      }

      for (var instanceId in instances) {
        var instance = instances[instanceId];

        var _iterator17 = _createForOfIteratorHelper(defKeys[instance.defId]),
            _step17;

        try {
          for (_iterator17.s(); !(_step17 = _iterator17.n()).done;) {
            var _key7 = _step17.value;

            if (splitStores[_key7]) {
              // must have already been created
              splitStores[_key7].instances[instanceId] = instance;
            }
          }
        } catch (err) {
          _iterator17.e(err);
        } finally {
          _iterator17.f();
        }
      }

      return splitStores;
    }
  }, {
    key: "_splitIndividualUi",
    value: function _splitIndividualUi(eventUiBases, defKeys) {
      var splitHashes = {};

      for (var defId in eventUiBases) {
        if (defId) {
          // not the '' key
          var _iterator18 = _createForOfIteratorHelper(defKeys[defId]),
              _step18;

          try {
            for (_iterator18.s(); !(_step18 = _iterator18.n()).done;) {
              var key = _step18.value;

              if (!splitHashes[key]) {
                splitHashes[key] = {};
              }

              splitHashes[key][defId] = eventUiBases[defId];
            }
          } catch (err) {
            _iterator18.e(err);
          } finally {
            _iterator18.f();
          }
        }
      }

      return splitHashes;
    }
  }, {
    key: "_splitInteraction",
    value: function _splitInteraction(interaction) {
      var splitStates = {};

      if (interaction) {
        var affectedStores = this._splitEventStore(interaction.affectedEvents, this._getKeysForEventDefs(interaction.affectedEvents)); // can't rely on defKeys because event data is mutated


        var mutatedKeysByDefId = this._getKeysForEventDefs(interaction.mutatedEvents);

        var mutatedStores = this._splitEventStore(interaction.mutatedEvents, mutatedKeysByDefId);

        var populate = function populate(key) {
          if (!splitStates[key]) {
            splitStates[key] = {
              affectedEvents: affectedStores[key] || EMPTY_EVENT_STORE,
              mutatedEvents: mutatedStores[key] || EMPTY_EVENT_STORE,
              isEvent: interaction.isEvent
            };
          }
        };

        for (var key in affectedStores) {
          populate(key);
        }

        for (var _key8 in mutatedStores) {
          populate(_key8);
        }
      }

      return splitStates;
    }
  }]);

  return Splitter;
}();

function buildEventUiForKey(allUi, eventUiForKey, individualUi) {
  var baseParts = [];

  if (allUi) {
    baseParts.push(allUi);
  }

  if (eventUiForKey) {
    baseParts.push(eventUiForKey);
  }

  var stuff = {
    '': combineEventUis(baseParts)
  };

  if (individualUi) {
    Object.assign(stuff, individualUi);
  }

  return stuff;
}

function getDateMeta(date, todayRange, nowDate, dateProfile) {
  return {
    dow: date.getUTCDay(),
    isDisabled: Boolean(dateProfile && !rangeContainsMarker(dateProfile.activeRange, date)),
    isOther: Boolean(dateProfile && !rangeContainsMarker(dateProfile.currentRange, date)),
    isToday: Boolean(todayRange && rangeContainsMarker(todayRange, date)),
    isPast: Boolean(nowDate ? date < nowDate : todayRange ? date < todayRange.start : false),
    isFuture: Boolean(nowDate ? date > nowDate : todayRange ? date >= todayRange.end : false)
  };
}

function getDayClassNames(meta, theme) {
  var classNames = ['fc-day', "fc-day-".concat(DAY_IDS[meta.dow])];

  if (meta.isDisabled) {
    classNames.push('fc-day-disabled');
  } else {
    if (meta.isToday) {
      classNames.push('fc-day-today');
      classNames.push(theme.getClass('today'));
    }

    if (meta.isPast) {
      classNames.push('fc-day-past');
    }

    if (meta.isFuture) {
      classNames.push('fc-day-future');
    }

    if (meta.isOther) {
      classNames.push('fc-day-other');
    }
  }

  return classNames;
}

function getSlotClassNames(meta, theme) {
  var classNames = ['fc-slot', "fc-slot-".concat(DAY_IDS[meta.dow])];

  if (meta.isDisabled) {
    classNames.push('fc-slot-disabled');
  } else {
    if (meta.isToday) {
      classNames.push('fc-slot-today');
      classNames.push(theme.getClass('today'));
    }

    if (meta.isPast) {
      classNames.push('fc-slot-past');
    }

    if (meta.isFuture) {
      classNames.push('fc-slot-future');
    }
  }

  return classNames;
}

var DAY_FORMAT = createFormatter({
  year: 'numeric',
  month: 'long',
  day: 'numeric'
});
var WEEK_FORMAT = createFormatter({
  week: 'long'
});

function buildNavLinkAttrs(context, dateMarker) {
  var viewType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'day';
  var isTabbable = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  var dateEnv = context.dateEnv,
      options = context.options,
      calendarApi = context.calendarApi;
  var dateStr = dateEnv.format(dateMarker, viewType === 'week' ? WEEK_FORMAT : DAY_FORMAT);

  if (options.navLinks) {
    var zonedDate = dateEnv.toDate(dateMarker);

    var handleInteraction = function handleInteraction(ev) {
      var customAction = viewType === 'day' ? options.navLinkDayClick : viewType === 'week' ? options.navLinkWeekClick : null;

      if (typeof customAction === 'function') {
        customAction.call(calendarApi, dateEnv.toDate(dateMarker), ev);
      } else {
        if (typeof customAction === 'string') {
          viewType = customAction;
        }

        calendarApi.zoomTo(dateMarker, viewType);
      }
    };

    return Object.assign({
      title: formatWithOrdinals(options.navLinkHint, [dateStr, zonedDate], dateStr),
      'data-navlink': ''
    }, isTabbable ? createAriaClickAttrs(handleInteraction) : {
      onClick: handleInteraction
    });
  }

  return {
    'aria-label': dateStr
  };
}

var _isRtlScrollbarOnLeft = null;

function getIsRtlScrollbarOnLeft() {
  if (_isRtlScrollbarOnLeft === null) {
    _isRtlScrollbarOnLeft = computeIsRtlScrollbarOnLeft();
  }

  return _isRtlScrollbarOnLeft;
}

function computeIsRtlScrollbarOnLeft() {
  var outerEl = document.createElement('div');
  applyStyle(outerEl, {
    position: 'absolute',
    top: -1000,
    left: 0,
    border: 0,
    padding: 0,
    overflow: 'scroll',
    direction: 'rtl'
  });
  outerEl.innerHTML = '<div></div>';
  document.body.appendChild(outerEl);
  var innerEl = outerEl.firstChild;
  var res = innerEl.getBoundingClientRect().left > outerEl.getBoundingClientRect().left;
  removeElement(outerEl);
  return res;
}

var _scrollbarWidths;

function getScrollbarWidths() {
  if (!_scrollbarWidths) {
    _scrollbarWidths = computeScrollbarWidths();
  }

  return _scrollbarWidths;
}

function computeScrollbarWidths() {
  var el = document.createElement('div');
  el.style.overflow = 'scroll';
  el.style.position = 'absolute';
  el.style.top = '-9999px';
  el.style.left = '-9999px';
  document.body.appendChild(el);
  var res = computeScrollbarWidthsForEl(el);
  document.body.removeChild(el);
  return res;
} // WARNING: will include border


function computeScrollbarWidthsForEl(el) {
  return {
    x: el.offsetHeight - el.clientHeight,
    y: el.offsetWidth - el.clientWidth
  };
}

function computeEdges(el) {
  var getPadding = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var computedStyle = window.getComputedStyle(el);
  var borderLeft = parseInt(computedStyle.borderLeftWidth, 10) || 0;
  var borderRight = parseInt(computedStyle.borderRightWidth, 10) || 0;
  var borderTop = parseInt(computedStyle.borderTopWidth, 10) || 0;
  var borderBottom = parseInt(computedStyle.borderBottomWidth, 10) || 0;
  var badScrollbarWidths = computeScrollbarWidthsForEl(el); // includes border!

  var scrollbarLeftRight = badScrollbarWidths.y - borderLeft - borderRight;
  var scrollbarBottom = badScrollbarWidths.x - borderTop - borderBottom;
  var res = {
    borderLeft: borderLeft,
    borderRight: borderRight,
    borderTop: borderTop,
    borderBottom: borderBottom,
    scrollbarBottom: scrollbarBottom,
    scrollbarLeft: 0,
    scrollbarRight: 0
  };

  if (getIsRtlScrollbarOnLeft() && computedStyle.direction === 'rtl') {
    // is the scrollbar on the left side?
    res.scrollbarLeft = scrollbarLeftRight;
  } else {
    res.scrollbarRight = scrollbarLeftRight;
  }

  if (getPadding) {
    res.paddingLeft = parseInt(computedStyle.paddingLeft, 10) || 0;
    res.paddingRight = parseInt(computedStyle.paddingRight, 10) || 0;
    res.paddingTop = parseInt(computedStyle.paddingTop, 10) || 0;
    res.paddingBottom = parseInt(computedStyle.paddingBottom, 10) || 0;
  }

  return res;
}

function computeInnerRect(el) {
  var goWithinPadding = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var doFromWindowViewport = arguments.length > 2 ? arguments[2] : undefined;
  var outerRect = doFromWindowViewport ? el.getBoundingClientRect() : computeRect(el);
  var edges = computeEdges(el, goWithinPadding);
  var res = {
    left: outerRect.left + edges.borderLeft + edges.scrollbarLeft,
    right: outerRect.right - edges.borderRight - edges.scrollbarRight,
    top: outerRect.top + edges.borderTop,
    bottom: outerRect.bottom - edges.borderBottom - edges.scrollbarBottom
  };

  if (goWithinPadding) {
    res.left += edges.paddingLeft;
    res.right -= edges.paddingRight;
    res.top += edges.paddingTop;
    res.bottom -= edges.paddingBottom;
  }

  return res;
}

function computeRect(el) {
  var rect = el.getBoundingClientRect();
  return {
    left: rect.left + window.pageXOffset,
    top: rect.top + window.pageYOffset,
    right: rect.right + window.pageXOffset,
    bottom: rect.bottom + window.pageYOffset
  };
}

function computeClippedClientRect(el) {
  var clippingParents = getClippingParents(el);
  var rect = el.getBoundingClientRect();

  var _iterator19 = _createForOfIteratorHelper(clippingParents),
      _step19;

  try {
    for (_iterator19.s(); !(_step19 = _iterator19.n()).done;) {
      var clippingParent = _step19.value;
      var intersection = intersectRects(rect, clippingParent.getBoundingClientRect());

      if (intersection) {
        rect = intersection;
      } else {
        return null;
      }
    }
  } catch (err) {
    _iterator19.e(err);
  } finally {
    _iterator19.f();
  }

  return rect;
} // does not return window


function getClippingParents(el) {
  var parents = [];

  while (el instanceof HTMLElement) {
    // will stop when gets to document or null
    var computedStyle = window.getComputedStyle(el);

    if (computedStyle.position === 'fixed') {
      break;
    }

    if (/(auto|scroll)/.test(computedStyle.overflow + computedStyle.overflowY + computedStyle.overflowX)) {
      parents.push(el);
    }

    el = el.parentNode;
  }

  return parents;
}
/*
Records offset information for a set of elements, relative to an origin element.
Can record the left/right OR the top/bottom OR both.
Provides methods for querying the cache by position.
*/


var PositionCache = /*#__PURE__*/function () {
  function PositionCache(originEl, els, isHorizontal, isVertical) {
    _classCallCheck(this, PositionCache);

    this.els = els;
    var originClientRect = this.originClientRect = originEl.getBoundingClientRect(); // relative to viewport top-left

    if (isHorizontal) {
      this.buildElHorizontals(originClientRect.left);
    }

    if (isVertical) {
      this.buildElVerticals(originClientRect.top);
    }
  } // Populates the left/right internal coordinate arrays


  _createClass(PositionCache, [{
    key: "buildElHorizontals",
    value: function buildElHorizontals(originClientLeft) {
      var lefts = [];
      var rights = [];

      var _iterator20 = _createForOfIteratorHelper(this.els),
          _step20;

      try {
        for (_iterator20.s(); !(_step20 = _iterator20.n()).done;) {
          var el = _step20.value;
          var rect = el.getBoundingClientRect();
          lefts.push(rect.left - originClientLeft);
          rights.push(rect.right - originClientLeft);
        }
      } catch (err) {
        _iterator20.e(err);
      } finally {
        _iterator20.f();
      }

      this.lefts = lefts;
      this.rights = rights;
    } // Populates the top/bottom internal coordinate arrays

  }, {
    key: "buildElVerticals",
    value: function buildElVerticals(originClientTop) {
      var tops = [];
      var bottoms = [];

      var _iterator21 = _createForOfIteratorHelper(this.els),
          _step21;

      try {
        for (_iterator21.s(); !(_step21 = _iterator21.n()).done;) {
          var el = _step21.value;
          var rect = el.getBoundingClientRect();
          tops.push(rect.top - originClientTop);
          bottoms.push(rect.bottom - originClientTop);
        }
      } catch (err) {
        _iterator21.e(err);
      } finally {
        _iterator21.f();
      }

      this.tops = tops;
      this.bottoms = bottoms;
    } // Given a left offset (from document left), returns the index of the el that it horizontally intersects.
    // If no intersection is made, returns undefined.

  }, {
    key: "leftToIndex",
    value: function leftToIndex(leftPosition) {
      var lefts = this.lefts,
          rights = this.rights;
      var len = lefts.length;
      var i;

      for (i = 0; i < len; i += 1) {
        if (leftPosition >= lefts[i] && leftPosition < rights[i]) {
          return i;
        }
      }

      return undefined; // TODO: better
    } // Given a top offset (from document top), returns the index of the el that it vertically intersects.
    // If no intersection is made, returns undefined.

  }, {
    key: "topToIndex",
    value: function topToIndex(topPosition) {
      var tops = this.tops,
          bottoms = this.bottoms;
      var len = tops.length;
      var i;

      for (i = 0; i < len; i += 1) {
        if (topPosition >= tops[i] && topPosition < bottoms[i]) {
          return i;
        }
      }

      return undefined; // TODO: better
    } // Gets the width of the element at the given index

  }, {
    key: "getWidth",
    value: function getWidth(leftIndex) {
      return this.rights[leftIndex] - this.lefts[leftIndex];
    } // Gets the height of the element at the given index

  }, {
    key: "getHeight",
    value: function getHeight(topIndex) {
      return this.bottoms[topIndex] - this.tops[topIndex];
    }
  }, {
    key: "similarTo",
    value: function similarTo(otherCache) {
      return similarNumArrays(this.tops || [], otherCache.tops || []) && similarNumArrays(this.bottoms || [], otherCache.bottoms || []) && similarNumArrays(this.lefts || [], otherCache.lefts || []) && similarNumArrays(this.rights || [], otherCache.rights || []);
    }
  }]);

  return PositionCache;
}();

function similarNumArrays(a, b) {
  var len = a.length;

  if (len !== b.length) {
    return false;
  }

  for (var i = 0; i < len; i++) {
    if (Math.round(a[i]) !== Math.round(b[i])) {
      return false;
    }
  }

  return true;
}
/* eslint max-classes-per-file: "off" */

/*
An object for getting/setting scroll-related information for an element.
Internally, this is done very differently for window versus DOM element,
so this object serves as a common interface.
*/


var ScrollController = /*#__PURE__*/function () {
  function ScrollController() {
    _classCallCheck(this, ScrollController);
  }

  _createClass(ScrollController, [{
    key: "getMaxScrollTop",
    value: function getMaxScrollTop() {
      return this.getScrollHeight() - this.getClientHeight();
    }
  }, {
    key: "getMaxScrollLeft",
    value: function getMaxScrollLeft() {
      return this.getScrollWidth() - this.getClientWidth();
    }
  }, {
    key: "canScrollVertically",
    value: function canScrollVertically() {
      return this.getMaxScrollTop() > 0;
    }
  }, {
    key: "canScrollHorizontally",
    value: function canScrollHorizontally() {
      return this.getMaxScrollLeft() > 0;
    }
  }, {
    key: "canScrollUp",
    value: function canScrollUp() {
      return this.getScrollTop() > 0;
    }
  }, {
    key: "canScrollDown",
    value: function canScrollDown() {
      return this.getScrollTop() < this.getMaxScrollTop();
    }
  }, {
    key: "canScrollLeft",
    value: function canScrollLeft() {
      return this.getScrollLeft() > 0;
    }
  }, {
    key: "canScrollRight",
    value: function canScrollRight() {
      return this.getScrollLeft() < this.getMaxScrollLeft();
    }
  }]);

  return ScrollController;
}();

var ElementScrollController = /*#__PURE__*/function (_ScrollController) {
  _inherits(ElementScrollController, _ScrollController);

  var _super9 = _createSuper(ElementScrollController);

  function ElementScrollController(el) {
    var _this14;

    _classCallCheck(this, ElementScrollController);

    _this14 = _super9.call(this);
    _this14.el = el;
    return _this14;
  }

  _createClass(ElementScrollController, [{
    key: "getScrollTop",
    value: function getScrollTop() {
      return this.el.scrollTop;
    }
  }, {
    key: "getScrollLeft",
    value: function getScrollLeft() {
      return this.el.scrollLeft;
    }
  }, {
    key: "setScrollTop",
    value: function setScrollTop(top) {
      this.el.scrollTop = top;
    }
  }, {
    key: "setScrollLeft",
    value: function setScrollLeft(left) {
      this.el.scrollLeft = left;
    }
  }, {
    key: "getScrollWidth",
    value: function getScrollWidth() {
      return this.el.scrollWidth;
    }
  }, {
    key: "getScrollHeight",
    value: function getScrollHeight() {
      return this.el.scrollHeight;
    }
  }, {
    key: "getClientHeight",
    value: function getClientHeight() {
      return this.el.clientHeight;
    }
  }, {
    key: "getClientWidth",
    value: function getClientWidth() {
      return this.el.clientWidth;
    }
  }]);

  return ElementScrollController;
}(ScrollController);

var WindowScrollController = /*#__PURE__*/function (_ScrollController2) {
  _inherits(WindowScrollController, _ScrollController2);

  var _super10 = _createSuper(WindowScrollController);

  function WindowScrollController() {
    _classCallCheck(this, WindowScrollController);

    return _super10.apply(this, arguments);
  }

  _createClass(WindowScrollController, [{
    key: "getScrollTop",
    value: function getScrollTop() {
      return window.pageYOffset;
    }
  }, {
    key: "getScrollLeft",
    value: function getScrollLeft() {
      return window.pageXOffset;
    }
  }, {
    key: "setScrollTop",
    value: function setScrollTop(n) {
      window.scroll(window.pageXOffset, n);
    }
  }, {
    key: "setScrollLeft",
    value: function setScrollLeft(n) {
      window.scroll(n, window.pageYOffset);
    }
  }, {
    key: "getScrollWidth",
    value: function getScrollWidth() {
      return document.documentElement.scrollWidth;
    }
  }, {
    key: "getScrollHeight",
    value: function getScrollHeight() {
      return document.documentElement.scrollHeight;
    }
  }, {
    key: "getClientHeight",
    value: function getClientHeight() {
      return document.documentElement.clientHeight;
    }
  }, {
    key: "getClientWidth",
    value: function getClientWidth() {
      return document.documentElement.clientWidth;
    }
  }]);

  return WindowScrollController;
}(ScrollController);
/*
an INTERACTABLE date component

PURPOSES:
- hook up to fg, fill, and mirror renderers
- interface for dragging and hits
*/


var DateComponent = /*#__PURE__*/function (_BaseComponent4) {
  _inherits(DateComponent, _BaseComponent4);

  var _super11 = _createSuper(DateComponent);

  function DateComponent() {
    var _this15;

    _classCallCheck(this, DateComponent);

    _this15 = _super11.apply(this, arguments);
    _this15.uid = guid();
    return _this15;
  } // Hit System
  // -----------------------------------------------------------------------------------------------------------------


  _createClass(DateComponent, [{
    key: "prepareHits",
    value: function prepareHits() {}
  }, {
    key: "queryHit",
    value: function queryHit(positionLeft, positionTop, elWidth, elHeight) {
      return null; // this should be abstract
    } // Pointer Interaction Utils
    // -----------------------------------------------------------------------------------------------------------------

  }, {
    key: "isValidSegDownEl",
    value: function isValidSegDownEl(el) {
      return !this.props.eventDrag && // HACK
      !this.props.eventResize && // HACK
      !elementClosest(el, '.fc-event-mirror');
    }
  }, {
    key: "isValidDateDownEl",
    value: function isValidDateDownEl(el) {
      return !elementClosest(el, '.fc-event:not(.fc-bg-event)') && !elementClosest(el, '.fc-more-link') && // a "more.." link
      !elementClosest(el, 'a[data-navlink]') && // a clickable nav link
      !elementClosest(el, '.fc-popover'); // hack
    }
  }]);

  return DateComponent;
}(BaseComponent);

var NamedTimeZoneImpl = function NamedTimeZoneImpl(timeZoneName) {
  _classCallCheck(this, NamedTimeZoneImpl);

  this.timeZoneName = timeZoneName;
};

var SegHierarchy = /*#__PURE__*/function () {
  function SegHierarchy() {
    var getEntryThickness = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (entry) {
      // should return an integer
      return entry.thickness;
    };

    _classCallCheck(this, SegHierarchy);

    this.getEntryThickness = getEntryThickness; // settings

    this.strictOrder = false;
    this.allowReslicing = false;
    this.maxCoord = -1; // -1 means no max

    this.maxStackCnt = -1; // -1 means no max

    this.levelCoords = []; // ordered

    this.entriesByLevel = []; // parallel with levelCoords

    this.stackCnts = {}; // TODO: use better technique!?
  }

  _createClass(SegHierarchy, [{
    key: "addSegs",
    value: function addSegs(inputs) {
      var hiddenEntries = [];

      var _iterator22 = _createForOfIteratorHelper(inputs),
          _step22;

      try {
        for (_iterator22.s(); !(_step22 = _iterator22.n()).done;) {
          var input = _step22.value;
          this.insertEntry(input, hiddenEntries);
        }
      } catch (err) {
        _iterator22.e(err);
      } finally {
        _iterator22.f();
      }

      return hiddenEntries;
    }
  }, {
    key: "insertEntry",
    value: function insertEntry(entry, hiddenEntries) {
      var insertion = this.findInsertion(entry);

      if (this.isInsertionValid(insertion, entry)) {
        this.insertEntryAt(entry, insertion);
        return 1;
      }

      return this.handleInvalidInsertion(insertion, entry, hiddenEntries);
    }
  }, {
    key: "isInsertionValid",
    value: function isInsertionValid(insertion, entry) {
      return (this.maxCoord === -1 || insertion.levelCoord + this.getEntryThickness(entry) <= this.maxCoord) && (this.maxStackCnt === -1 || insertion.stackCnt < this.maxStackCnt);
    } // returns number of new entries inserted

  }, {
    key: "handleInvalidInsertion",
    value: function handleInvalidInsertion(insertion, entry, hiddenEntries) {
      if (this.allowReslicing && insertion.touchingEntry) {
        return this.splitEntry(entry, insertion.touchingEntry, hiddenEntries);
      }

      hiddenEntries.push(entry);
      return 0;
    }
  }, {
    key: "splitEntry",
    value: function splitEntry(entry, barrier, hiddenEntries) {
      var partCnt = 0;
      var splitHiddenEntries = [];
      var entrySpan = entry.span;
      var barrierSpan = barrier.span;

      if (entrySpan.start < barrierSpan.start) {
        partCnt += this.insertEntry({
          index: entry.index,
          thickness: entry.thickness,
          span: {
            start: entrySpan.start,
            end: barrierSpan.start
          }
        }, splitHiddenEntries);
      }

      if (entrySpan.end > barrierSpan.end) {
        partCnt += this.insertEntry({
          index: entry.index,
          thickness: entry.thickness,
          span: {
            start: barrierSpan.end,
            end: entrySpan.end
          }
        }, splitHiddenEntries);
      }

      if (partCnt) {
        hiddenEntries.push.apply(hiddenEntries, [{
          index: entry.index,
          thickness: entry.thickness,
          span: intersectSpans(barrierSpan, entrySpan) // guaranteed to intersect

        }].concat(splitHiddenEntries));
        return partCnt;
      }

      hiddenEntries.push(entry);
      return 0;
    }
  }, {
    key: "insertEntryAt",
    value: function insertEntryAt(entry, insertion) {
      var entriesByLevel = this.entriesByLevel,
          levelCoords = this.levelCoords;

      if (insertion.lateral === -1) {
        // create a new level
        insertAt(levelCoords, insertion.level, insertion.levelCoord);
        insertAt(entriesByLevel, insertion.level, [entry]);
      } else {
        // insert into existing level
        insertAt(entriesByLevel[insertion.level], insertion.lateral, entry);
      }

      this.stackCnts[buildEntryKey(entry)] = insertion.stackCnt;
    }
  }, {
    key: "findInsertion",
    value: function findInsertion(newEntry) {
      var levelCoords = this.levelCoords,
          entriesByLevel = this.entriesByLevel,
          strictOrder = this.strictOrder,
          stackCnts = this.stackCnts;
      var levelCnt = levelCoords.length;
      var candidateCoord = 0;
      var touchingLevel = -1;
      var touchingLateral = -1;
      var touchingEntry = null;
      var stackCnt = 0;

      for (var trackingLevel = 0; trackingLevel < levelCnt; trackingLevel += 1) {
        var trackingCoord = levelCoords[trackingLevel]; // if the current level is past the placed entry, we have found a good empty space and can stop.
        // if strictOrder, keep finding more lateral intersections.

        if (!strictOrder && trackingCoord >= candidateCoord + this.getEntryThickness(newEntry)) {
          break;
        }

        var trackingEntries = entriesByLevel[trackingLevel];
        var trackingEntry = void 0;
        var searchRes = binarySearch(trackingEntries, newEntry.span.start, getEntrySpanEnd); // find first entry after newEntry's end

        var lateralIndex = searchRes[0] + searchRes[1]; // if exact match (which doesn't collide), go to next one

        while ( // loop through entries that horizontally intersect
        (trackingEntry = trackingEntries[lateralIndex]) && // but not past the whole entry list
        trackingEntry.span.start < newEntry.span.end // and not entirely past newEntry
        ) {
          var trackingEntryBottom = trackingCoord + this.getEntryThickness(trackingEntry); // intersects into the top of the candidate?

          if (trackingEntryBottom > candidateCoord) {
            candidateCoord = trackingEntryBottom;
            touchingEntry = trackingEntry;
            touchingLevel = trackingLevel;
            touchingLateral = lateralIndex;
          } // butts up against top of candidate? (will happen if just intersected as well)


          if (trackingEntryBottom === candidateCoord) {
            // accumulate the highest possible stackCnt of the trackingEntries that butt up
            stackCnt = Math.max(stackCnt, stackCnts[buildEntryKey(trackingEntry)] + 1);
          }

          lateralIndex += 1;
        }
      } // the destination level will be after touchingEntry's level. find it


      var destLevel = 0;

      if (touchingEntry) {
        destLevel = touchingLevel + 1;

        while (destLevel < levelCnt && levelCoords[destLevel] < candidateCoord) {
          destLevel += 1;
        }
      } // if adding to an existing level, find where to insert


      var destLateral = -1;

      if (destLevel < levelCnt && levelCoords[destLevel] === candidateCoord) {
        destLateral = binarySearch(entriesByLevel[destLevel], newEntry.span.end, getEntrySpanEnd)[0];
      }

      return {
        touchingLevel: touchingLevel,
        touchingLateral: touchingLateral,
        touchingEntry: touchingEntry,
        stackCnt: stackCnt,
        levelCoord: candidateCoord,
        level: destLevel,
        lateral: destLateral
      };
    } // sorted by levelCoord (lowest to highest)

  }, {
    key: "toRects",
    value: function toRects() {
      var entriesByLevel = this.entriesByLevel,
          levelCoords = this.levelCoords;
      var levelCnt = entriesByLevel.length;
      var rects = [];

      for (var level = 0; level < levelCnt; level += 1) {
        var entries = entriesByLevel[level];
        var levelCoord = levelCoords[level];

        var _iterator23 = _createForOfIteratorHelper(entries),
            _step23;

        try {
          for (_iterator23.s(); !(_step23 = _iterator23.n()).done;) {
            var entry = _step23.value;
            rects.push(Object.assign(Object.assign({}, entry), {
              thickness: this.getEntryThickness(entry),
              levelCoord: levelCoord
            }));
          }
        } catch (err) {
          _iterator23.e(err);
        } finally {
          _iterator23.f();
        }
      }

      return rects;
    }
  }]);

  return SegHierarchy;
}();

function getEntrySpanEnd(entry) {
  return entry.span.end;
}

function buildEntryKey(entry) {
  return entry.index + ':' + entry.span.start;
} // returns groups with entries sorted by input order


function groupIntersectingEntries(entries) {
  var merges = [];

  var _iterator24 = _createForOfIteratorHelper(entries),
      _step24;

  try {
    for (_iterator24.s(); !(_step24 = _iterator24.n()).done;) {
      var entry = _step24.value;
      var filteredMerges = [];
      var hungryMerge = {
        span: entry.span,
        entries: [entry]
      };

      var _iterator25 = _createForOfIteratorHelper(merges),
          _step25;

      try {
        for (_iterator25.s(); !(_step25 = _iterator25.n()).done;) {
          var merge = _step25.value;

          if (intersectSpans(merge.span, hungryMerge.span)) {
            hungryMerge = {
              entries: merge.entries.concat(hungryMerge.entries),
              span: joinSpans(merge.span, hungryMerge.span)
            };
          } else {
            filteredMerges.push(merge);
          }
        }
      } catch (err) {
        _iterator25.e(err);
      } finally {
        _iterator25.f();
      }

      filteredMerges.push(hungryMerge);
      merges = filteredMerges;
    }
  } catch (err) {
    _iterator24.e(err);
  } finally {
    _iterator24.f();
  }

  return merges;
}

function joinSpans(span0, span1) {
  return {
    start: Math.min(span0.start, span1.start),
    end: Math.max(span0.end, span1.end)
  };
}

function intersectSpans(span0, span1) {
  var start = Math.max(span0.start, span1.start);
  var end = Math.min(span0.end, span1.end);

  if (start < end) {
    return {
      start: start,
      end: end
    };
  }

  return null;
} // general util
// ---------------------------------------------------------------------------------------------------------------------


function insertAt(arr, index, item) {
  arr.splice(index, 0, item);
}

function binarySearch(a, searchVal, getItemVal) {
  var startIndex = 0;
  var endIndex = a.length; // exclusive

  if (!endIndex || searchVal < getItemVal(a[startIndex])) {
    // no items OR before first item
    return [0, 0];
  }

  if (searchVal > getItemVal(a[endIndex - 1])) {
    // after last item
    return [endIndex, 0];
  }

  while (startIndex < endIndex) {
    var middleIndex = Math.floor(startIndex + (endIndex - startIndex) / 2);
    var middleVal = getItemVal(a[middleIndex]);

    if (searchVal < middleVal) {
      endIndex = middleIndex;
    } else if (searchVal > middleVal) {
      startIndex = middleIndex + 1;
    } else {
      // equal!
      return [middleIndex, 1];
    }
  }

  return [startIndex, 0];
}
/*
An abstraction for a dragging interaction originating on an event.
Does higher-level things than PointerDragger, such as possibly:
- a "mirror" that moves with the pointer
- a minimum number of pixels or other criteria for a true drag to begin

subclasses must emit:
- pointerdown
- dragstart
- dragmove
- pointerup
- dragend
*/


var ElementDragging = /*#__PURE__*/function () {
  function ElementDragging(el, selector) {
    _classCallCheck(this, ElementDragging);

    this.emitter = new Emitter();
  }

  _createClass(ElementDragging, [{
    key: "destroy",
    value: function destroy() {}
  }, {
    key: "setMirrorIsVisible",
    value: function setMirrorIsVisible(bool) {// optional if subclass doesn't want to support a mirror
    }
  }, {
    key: "setMirrorNeedsRevert",
    value: function setMirrorNeedsRevert(bool) {// optional if subclass doesn't want to support a mirror
    }
  }, {
    key: "setAutoScrollEnabled",
    value: function setAutoScrollEnabled(bool) {// optional
    }
  }]);

  return ElementDragging;
}(); // TODO: get rid of this in favor of options system,
// tho it's really easy to access this globally rather than pass thru options.


var config = {};
/*
Information about what will happen when an external element is dragged-and-dropped
onto a calendar. Contains information for creating an event.
*/

var DRAG_META_REFINERS = {
  startTime: createDuration,
  duration: createDuration,
  create: Boolean,
  sourceId: String
};

function parseDragMeta(raw) {
  var _refineProps3 = refineProps(raw, DRAG_META_REFINERS),
      refined = _refineProps3.refined,
      extra = _refineProps3.extra;

  return {
    startTime: refined.startTime || null,
    duration: refined.duration || null,
    create: refined.create != null ? refined.create : true,
    sourceId: refined.sourceId,
    leftoverProps: extra
  };
} // Computes a default column header formatting string if `colFormat` is not explicitly defined


function computeFallbackHeaderFormat(datesRepDistinctDays, dayCnt) {
  // if more than one week row, or if there are a lot of columns with not much space,
  // put just the day numbers will be in each cell
  if (!datesRepDistinctDays || dayCnt > 10) {
    return createFormatter({
      weekday: 'short'
    }); // "Sat"
  }

  if (dayCnt > 1) {
    return createFormatter({
      weekday: 'short',
      month: 'numeric',
      day: 'numeric',
      omitCommas: true
    }); // "Sat 11/12"
  }

  return createFormatter({
    weekday: 'long'
  }); // "Saturday"
}

var CLASS_NAME = 'fc-col-header-cell'; // do the cushion too? no

function renderInner$1(renderProps) {
  return renderProps.text;
} // BAD name for this class now. used in the Header


var TableDateCell = /*#__PURE__*/function (_BaseComponent5) {
  _inherits(TableDateCell, _BaseComponent5);

  var _super12 = _createSuper(TableDateCell);

  function TableDateCell() {
    _classCallCheck(this, TableDateCell);

    return _super12.apply(this, arguments);
  }

  _createClass(TableDateCell, [{
    key: "render",
    value: function render() {
      var _this$context = this.context,
          dateEnv = _this$context.dateEnv,
          options = _this$context.options,
          theme = _this$context.theme,
          viewApi = _this$context.viewApi;
      var props = this.props;
      var date = props.date,
          dateProfile = props.dateProfile;
      var dayMeta = getDateMeta(date, props.todayRange, null, dateProfile);
      var classNames = [CLASS_NAME].concat(getDayClassNames(dayMeta, theme));
      var text = dateEnv.format(date, props.dayHeaderFormat); // if colCnt is 1, we are already in a day-view and don't need a navlink

      var navLinkAttrs = !dayMeta.isDisabled && props.colCnt > 1 ? buildNavLinkAttrs(this.context, date) : {};
      var renderProps = Object.assign(Object.assign(Object.assign({
        date: dateEnv.toDate(date),
        view: viewApi
      }, props.extraRenderProps), {
        text: text
      }), dayMeta);
      return createElement(ContentContainer, {
        elTag: "th",
        elClasses: classNames,
        elAttrs: Object.assign({
          role: 'columnheader',
          colSpan: props.colSpan,
          'data-date': !dayMeta.isDisabled ? formatDayString(date) : undefined
        }, props.extraDataAttrs),
        renderProps: renderProps,
        generatorName: "dayHeaderContent",
        customGenerator: options.dayHeaderContent,
        defaultGenerator: renderInner$1,
        classNameGenerator: options.dayHeaderClassNames,
        didMount: options.dayHeaderDidMount,
        willUnmount: options.dayHeaderWillUnmount
      }, function (InnerContainer) {
        return createElement("div", {
          className: "fc-scrollgrid-sync-inner"
        }, !dayMeta.isDisabled && createElement(InnerContainer, {
          elTag: "a",
          elAttrs: navLinkAttrs,
          elClasses: ['fc-col-header-cell-cushion', props.isSticky && 'fc-sticky']
        }));
      });
    }
  }]);

  return TableDateCell;
}(BaseComponent);

var WEEKDAY_FORMAT = createFormatter({
  weekday: 'long'
});

var TableDowCell = /*#__PURE__*/function (_BaseComponent6) {
  _inherits(TableDowCell, _BaseComponent6);

  var _super13 = _createSuper(TableDowCell);

  function TableDowCell() {
    _classCallCheck(this, TableDowCell);

    return _super13.apply(this, arguments);
  }

  _createClass(TableDowCell, [{
    key: "render",
    value: function render() {
      var props = this.props;
      var _this$context2 = this.context,
          dateEnv = _this$context2.dateEnv,
          theme = _this$context2.theme,
          viewApi = _this$context2.viewApi,
          options = _this$context2.options;
      var date = addDays(new Date(259200000), props.dow); // start with Sun, 04 Jan 1970 00:00:00 GMT

      var dateMeta = {
        dow: props.dow,
        isDisabled: false,
        isFuture: false,
        isPast: false,
        isToday: false,
        isOther: false
      };
      var text = dateEnv.format(date, props.dayHeaderFormat);
      var renderProps = Object.assign(Object.assign(Object.assign(Object.assign({
        // TODO: make this public?
        date: date
      }, dateMeta), {
        view: viewApi
      }), props.extraRenderProps), {
        text: text
      });
      return createElement(ContentContainer, {
        elTag: "th",
        elClasses: [CLASS_NAME].concat(_toConsumableArray(getDayClassNames(dateMeta, theme)), _toConsumableArray(props.extraClassNames || [])),
        elAttrs: Object.assign({
          role: 'columnheader',
          colSpan: props.colSpan
        }, props.extraDataAttrs),
        renderProps: renderProps,
        generatorName: "dayHeaderContent",
        customGenerator: options.dayHeaderContent,
        defaultGenerator: renderInner$1,
        classNameGenerator: options.dayHeaderClassNames,
        didMount: options.dayHeaderDidMount,
        willUnmount: options.dayHeaderWillUnmount
      }, function (InnerContent) {
        return createElement("div", {
          className: "fc-scrollgrid-sync-inner"
        }, createElement(InnerContent, {
          elTag: "a",
          elClasses: ['fc-col-header-cell-cushion', props.isSticky && 'fc-sticky'],
          elAttrs: {
            'aria-label': dateEnv.format(date, WEEKDAY_FORMAT)
          }
        }));
      });
    }
  }]);

  return TableDowCell;
}(BaseComponent);

var NowTimer = /*#__PURE__*/function (_Component3) {
  _inherits(NowTimer, _Component3);

  var _super14 = _createSuper(NowTimer);

  function NowTimer(props, context) {
    var _this16;

    _classCallCheck(this, NowTimer);

    _this16 = _super14.call(this, props, context);
    _this16.initialNowDate = getNow(context.options.now, context.dateEnv);
    _this16.initialNowQueriedMs = new Date().valueOf();
    _this16.state = _this16.computeTiming().currentState;
    return _this16;
  }

  _createClass(NowTimer, [{
    key: "render",
    value: function render() {
      var props = this.props,
          state = this.state;
      return props.children(state.nowDate, state.todayRange);
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setTimeout();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.unit !== this.props.unit) {
        this.clearTimeout();
        this.setTimeout();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.clearTimeout();
    }
  }, {
    key: "computeTiming",
    value: function computeTiming() {
      var props = this.props,
          context = this.context;
      var unroundedNow = addMs(this.initialNowDate, new Date().valueOf() - this.initialNowQueriedMs);
      var currentUnitStart = context.dateEnv.startOf(unroundedNow, props.unit);
      var nextUnitStart = context.dateEnv.add(currentUnitStart, createDuration(1, props.unit));
      var waitMs = nextUnitStart.valueOf() - unroundedNow.valueOf(); // there is a max setTimeout ms value (https://stackoverflow.com/a/3468650/96342)
      // ensure no longer than a day

      waitMs = Math.min(1000 * 60 * 60 * 24, waitMs);
      return {
        currentState: {
          nowDate: currentUnitStart,
          todayRange: buildDayRange(currentUnitStart)
        },
        nextState: {
          nowDate: nextUnitStart,
          todayRange: buildDayRange(nextUnitStart)
        },
        waitMs: waitMs
      };
    }
  }, {
    key: "setTimeout",
    value: function (_setTimeout) {
      function setTimeout() {
        return _setTimeout.apply(this, arguments);
      }

      setTimeout.toString = function () {
        return _setTimeout.toString();
      };

      return setTimeout;
    }(function () {
      var _this17 = this;

      var _this$computeTiming = this.computeTiming(),
          nextState = _this$computeTiming.nextState,
          waitMs = _this$computeTiming.waitMs;

      this.timeoutId = setTimeout(function () {
        _this17.setState(nextState, function () {
          _this17.setTimeout();
        });
      }, waitMs);
    })
  }, {
    key: "clearTimeout",
    value: function (_clearTimeout2) {
      function clearTimeout() {
        return _clearTimeout2.apply(this, arguments);
      }

      clearTimeout.toString = function () {
        return _clearTimeout2.toString();
      };

      return clearTimeout;
    }(function () {
      if (this.timeoutId) {
        clearTimeout(this.timeoutId);
      }
    })
  }]);

  return NowTimer;
}(Component);

NowTimer.contextType = ViewContextType;

function buildDayRange(date) {
  var start = startOfDay(date);
  var end = addDays(start, 1);
  return {
    start: start,
    end: end
  };
}

var DayHeader = /*#__PURE__*/function (_BaseComponent7) {
  _inherits(DayHeader, _BaseComponent7);

  var _super15 = _createSuper(DayHeader);

  function DayHeader() {
    var _this18;

    _classCallCheck(this, DayHeader);

    _this18 = _super15.apply(this, arguments);
    _this18.createDayHeaderFormatter = memoize(createDayHeaderFormatter);
    return _this18;
  }

  _createClass(DayHeader, [{
    key: "render",
    value: function render() {
      var context = this.context;
      var _this$props4 = this.props,
          dates = _this$props4.dates,
          dateProfile = _this$props4.dateProfile,
          datesRepDistinctDays = _this$props4.datesRepDistinctDays,
          renderIntro = _this$props4.renderIntro;
      var dayHeaderFormat = this.createDayHeaderFormatter(context.options.dayHeaderFormat, datesRepDistinctDays, dates.length);
      return createElement(NowTimer, {
        unit: "day"
      }, function (nowDate, todayRange) {
        return createElement("tr", {
          role: "row"
        }, renderIntro && renderIntro('day'), dates.map(function (date) {
          return datesRepDistinctDays ? createElement(TableDateCell, {
            key: date.toISOString(),
            date: date,
            dateProfile: dateProfile,
            todayRange: todayRange,
            colCnt: dates.length,
            dayHeaderFormat: dayHeaderFormat
          }) : createElement(TableDowCell, {
            key: date.getUTCDay(),
            dow: date.getUTCDay(),
            dayHeaderFormat: dayHeaderFormat
          });
        }));
      });
    }
  }]);

  return DayHeader;
}(BaseComponent);

function createDayHeaderFormatter(explicitFormat, datesRepDistinctDays, dateCnt) {
  return explicitFormat || computeFallbackHeaderFormat(datesRepDistinctDays, dateCnt);
}

var DaySeriesModel = /*#__PURE__*/function () {
  function DaySeriesModel(range, dateProfileGenerator) {
    _classCallCheck(this, DaySeriesModel);

    var date = range.start;
    var end = range.end;
    var indices = [];
    var dates = [];
    var dayIndex = -1;

    while (date < end) {
      // loop each day from start to end
      if (dateProfileGenerator.isHiddenDay(date)) {
        indices.push(dayIndex + 0.5); // mark that it's between indices
      } else {
        dayIndex += 1;
        indices.push(dayIndex);
        dates.push(date);
      }

      date = addDays(date, 1);
    }

    this.dates = dates;
    this.indices = indices;
    this.cnt = dates.length;
  }

  _createClass(DaySeriesModel, [{
    key: "sliceRange",
    value: function sliceRange(range) {
      var firstIndex = this.getDateDayIndex(range.start); // inclusive first index

      var lastIndex = this.getDateDayIndex(addDays(range.end, -1)); // inclusive last index

      var clippedFirstIndex = Math.max(0, firstIndex);
      var clippedLastIndex = Math.min(this.cnt - 1, lastIndex); // deal with in-between indices

      clippedFirstIndex = Math.ceil(clippedFirstIndex); // in-between starts round to next cell

      clippedLastIndex = Math.floor(clippedLastIndex); // in-between ends round to prev cell

      if (clippedFirstIndex <= clippedLastIndex) {
        return {
          firstIndex: clippedFirstIndex,
          lastIndex: clippedLastIndex,
          isStart: firstIndex === clippedFirstIndex,
          isEnd: lastIndex === clippedLastIndex
        };
      }

      return null;
    } // Given a date, returns its chronolocial cell-index from the first cell of the grid.
    // If the date lies between cells (because of hiddenDays), returns a floating-point value between offsets.
    // If before the first offset, returns a negative number.
    // If after the last offset, returns an offset past the last cell offset.
    // Only works for *start* dates of cells. Will not work for exclusive end dates for cells.

  }, {
    key: "getDateDayIndex",
    value: function getDateDayIndex(date) {
      var indices = this.indices;
      var dayOffset = Math.floor(diffDays(this.dates[0], date));

      if (dayOffset < 0) {
        return indices[0] - 1;
      }

      if (dayOffset >= indices.length) {
        return indices[indices.length - 1] + 1;
      }

      return indices[dayOffset];
    }
  }]);

  return DaySeriesModel;
}();

var DayTableModel = /*#__PURE__*/function () {
  function DayTableModel(daySeries, breakOnWeeks) {
    _classCallCheck(this, DayTableModel);

    var dates = daySeries.dates;
    var daysPerRow;
    var firstDay;
    var rowCnt;

    if (breakOnWeeks) {
      // count columns until the day-of-week repeats
      firstDay = dates[0].getUTCDay();

      for (daysPerRow = 1; daysPerRow < dates.length; daysPerRow += 1) {
        if (dates[daysPerRow].getUTCDay() === firstDay) {
          break;
        }
      }

      rowCnt = Math.ceil(dates.length / daysPerRow);
    } else {
      rowCnt = 1;
      daysPerRow = dates.length;
    }

    this.rowCnt = rowCnt;
    this.colCnt = daysPerRow;
    this.daySeries = daySeries;
    this.cells = this.buildCells();
    this.headerDates = this.buildHeaderDates();
  }

  _createClass(DayTableModel, [{
    key: "buildCells",
    value: function buildCells() {
      var rows = [];

      for (var row = 0; row < this.rowCnt; row += 1) {
        var cells = [];

        for (var col = 0; col < this.colCnt; col += 1) {
          cells.push(this.buildCell(row, col));
        }

        rows.push(cells);
      }

      return rows;
    }
  }, {
    key: "buildCell",
    value: function buildCell(row, col) {
      var date = this.daySeries.dates[row * this.colCnt + col];
      return {
        key: date.toISOString(),
        date: date
      };
    }
  }, {
    key: "buildHeaderDates",
    value: function buildHeaderDates() {
      var dates = [];

      for (var col = 0; col < this.colCnt; col += 1) {
        dates.push(this.cells[0][col].date);
      }

      return dates;
    }
  }, {
    key: "sliceRange",
    value: function sliceRange(range) {
      var colCnt = this.colCnt;
      var seriesSeg = this.daySeries.sliceRange(range);
      var segs = [];

      if (seriesSeg) {
        var firstIndex = seriesSeg.firstIndex,
            lastIndex = seriesSeg.lastIndex;
        var index = firstIndex;

        while (index <= lastIndex) {
          var row = Math.floor(index / colCnt);
          var nextIndex = Math.min((row + 1) * colCnt, lastIndex + 1);
          segs.push({
            row: row,
            firstCol: index % colCnt,
            lastCol: (nextIndex - 1) % colCnt,
            isStart: seriesSeg.isStart && index === firstIndex,
            isEnd: seriesSeg.isEnd && nextIndex - 1 === lastIndex
          });
          index = nextIndex;
        }
      }

      return segs;
    }
  }]);

  return DayTableModel;
}();

var Slicer = /*#__PURE__*/function () {
  function Slicer() {
    _classCallCheck(this, Slicer);

    this.sliceBusinessHours = memoize(this._sliceBusinessHours);
    this.sliceDateSelection = memoize(this._sliceDateSpan);
    this.sliceEventStore = memoize(this._sliceEventStore);
    this.sliceEventDrag = memoize(this._sliceInteraction);
    this.sliceEventResize = memoize(this._sliceInteraction);
    this.forceDayIfListItem = false; // hack
  }

  _createClass(Slicer, [{
    key: "sliceProps",
    value: function sliceProps(props, dateProfile, nextDayThreshold, context) {
      var eventUiBases = props.eventUiBases;

      for (var _len4 = arguments.length, extraArgs = new Array(_len4 > 4 ? _len4 - 4 : 0), _key9 = 4; _key9 < _len4; _key9++) {
        extraArgs[_key9 - 4] = arguments[_key9];
      }

      var eventSegs = this.sliceEventStore.apply(this, [props.eventStore, eventUiBases, dateProfile, nextDayThreshold].concat(extraArgs));
      return {
        dateSelectionSegs: this.sliceDateSelection.apply(this, [props.dateSelection, dateProfile, nextDayThreshold, eventUiBases, context].concat(extraArgs)),
        businessHourSegs: this.sliceBusinessHours.apply(this, [props.businessHours, dateProfile, nextDayThreshold, context].concat(extraArgs)),
        fgEventSegs: eventSegs.fg,
        bgEventSegs: eventSegs.bg,
        eventDrag: this.sliceEventDrag.apply(this, [props.eventDrag, eventUiBases, dateProfile, nextDayThreshold].concat(extraArgs)),
        eventResize: this.sliceEventResize.apply(this, [props.eventResize, eventUiBases, dateProfile, nextDayThreshold].concat(extraArgs)),
        eventSelection: props.eventSelection
      }; // TODO: give interactionSegs?
    }
  }, {
    key: "sliceNowDate",
    value: function sliceNowDate( // does not memoize
    date, dateProfile, nextDayThreshold, context) {
      for (var _len5 = arguments.length, extraArgs = new Array(_len5 > 4 ? _len5 - 4 : 0), _key10 = 4; _key10 < _len5; _key10++) {
        extraArgs[_key10 - 4] = arguments[_key10];
      }

      return this._sliceDateSpan.apply(this, [{
        range: {
          start: date,
          end: addMs(date, 1)
        },
        allDay: false
      }, // add 1 ms, protect against null range
      dateProfile, nextDayThreshold, {}, context].concat(extraArgs));
    }
  }, {
    key: "_sliceBusinessHours",
    value: function _sliceBusinessHours(businessHours, dateProfile, nextDayThreshold, context) {
      if (!businessHours) {
        return [];
      }

      for (var _len6 = arguments.length, extraArgs = new Array(_len6 > 4 ? _len6 - 4 : 0), _key11 = 4; _key11 < _len6; _key11++) {
        extraArgs[_key11 - 4] = arguments[_key11];
      }

      return this._sliceEventStore.apply(this, [expandRecurring(businessHours, computeActiveRange(dateProfile, Boolean(nextDayThreshold)), context), {}, dateProfile, nextDayThreshold].concat(extraArgs)).bg;
    }
  }, {
    key: "_sliceEventStore",
    value: function _sliceEventStore(eventStore, eventUiBases, dateProfile, nextDayThreshold) {
      if (eventStore) {
        var rangeRes = sliceEventStore(eventStore, eventUiBases, computeActiveRange(dateProfile, Boolean(nextDayThreshold)), nextDayThreshold);

        for (var _len7 = arguments.length, extraArgs = new Array(_len7 > 4 ? _len7 - 4 : 0), _key12 = 4; _key12 < _len7; _key12++) {
          extraArgs[_key12 - 4] = arguments[_key12];
        }

        return {
          bg: this.sliceEventRanges(rangeRes.bg, extraArgs),
          fg: this.sliceEventRanges(rangeRes.fg, extraArgs)
        };
      }

      return {
        bg: [],
        fg: []
      };
    }
  }, {
    key: "_sliceInteraction",
    value: function _sliceInteraction(interaction, eventUiBases, dateProfile, nextDayThreshold) {
      if (!interaction) {
        return null;
      }

      var rangeRes = sliceEventStore(interaction.mutatedEvents, eventUiBases, computeActiveRange(dateProfile, Boolean(nextDayThreshold)), nextDayThreshold);

      for (var _len8 = arguments.length, extraArgs = new Array(_len8 > 4 ? _len8 - 4 : 0), _key13 = 4; _key13 < _len8; _key13++) {
        extraArgs[_key13 - 4] = arguments[_key13];
      }

      return {
        segs: this.sliceEventRanges(rangeRes.fg, extraArgs),
        affectedInstances: interaction.affectedEvents.instances,
        isEvent: interaction.isEvent
      };
    }
  }, {
    key: "_sliceDateSpan",
    value: function _sliceDateSpan(dateSpan, dateProfile, nextDayThreshold, eventUiBases, context) {
      if (!dateSpan) {
        return [];
      }

      var activeRange = computeActiveRange(dateProfile, Boolean(nextDayThreshold));
      var activeDateSpanRange = intersectRanges(dateSpan.range, activeRange);

      if (activeDateSpanRange) {
        dateSpan = Object.assign(Object.assign({}, dateSpan), {
          range: activeDateSpanRange
        });
        var eventRange = fabricateEventRange(dateSpan, eventUiBases, context);

        for (var _len9 = arguments.length, extraArgs = new Array(_len9 > 5 ? _len9 - 5 : 0), _key14 = 5; _key14 < _len9; _key14++) {
          extraArgs[_key14 - 5] = arguments[_key14];
        }

        var segs = this.sliceRange.apply(this, [dateSpan.range].concat(extraArgs));

        var _iterator26 = _createForOfIteratorHelper(segs),
            _step26;

        try {
          for (_iterator26.s(); !(_step26 = _iterator26.n()).done;) {
            var seg = _step26.value;
            seg.eventRange = eventRange;
          }
        } catch (err) {
          _iterator26.e(err);
        } finally {
          _iterator26.f();
        }

        return segs;
      }

      return [];
    }
    /*
    "complete" seg means it has component and eventRange
    */

  }, {
    key: "sliceEventRanges",
    value: function sliceEventRanges(eventRanges, extraArgs) {
      var segs = [];

      var _iterator27 = _createForOfIteratorHelper(eventRanges),
          _step27;

      try {
        for (_iterator27.s(); !(_step27 = _iterator27.n()).done;) {
          var eventRange = _step27.value;
          segs.push.apply(segs, _toConsumableArray(this.sliceEventRange(eventRange, extraArgs)));
        }
      } catch (err) {
        _iterator27.e(err);
      } finally {
        _iterator27.f();
      }

      return segs;
    }
    /*
    "complete" seg means it has component and eventRange
    */

  }, {
    key: "sliceEventRange",
    value: function sliceEventRange(eventRange, extraArgs) {
      var dateRange = eventRange.range; // hack to make multi-day events that are being force-displayed as list-items to take up only one day

      if (this.forceDayIfListItem && eventRange.ui.display === 'list-item') {
        dateRange = {
          start: dateRange.start,
          end: addDays(dateRange.start, 1)
        };
      }

      var segs = this.sliceRange.apply(this, [dateRange].concat(_toConsumableArray(extraArgs)));

      var _iterator28 = _createForOfIteratorHelper(segs),
          _step28;

      try {
        for (_iterator28.s(); !(_step28 = _iterator28.n()).done;) {
          var seg = _step28.value;
          seg.eventRange = eventRange;
          seg.isStart = eventRange.isStart && seg.isStart;
          seg.isEnd = eventRange.isEnd && seg.isEnd;
        }
      } catch (err) {
        _iterator28.e(err);
      } finally {
        _iterator28.f();
      }

      return segs;
    }
  }]);

  return Slicer;
}();
/*
for incorporating slotMinTime/slotMaxTime if appropriate
TODO: should be part of DateProfile!
TimelineDateProfile already does this btw
*/


function computeActiveRange(dateProfile, isComponentAllDay) {
  var range = dateProfile.activeRange;

  if (isComponentAllDay) {
    return range;
  }

  return {
    start: addMs(range.start, dateProfile.slotMinTime.milliseconds),
    end: addMs(range.end, dateProfile.slotMaxTime.milliseconds - 864e5) // 864e5 = ms in a day

  };
} // high-level segmenting-aware tester functions
// ------------------------------------------------------------------------------------------------------------------------


function isInteractionValid(interaction, dateProfile, context) {
  var instances = interaction.mutatedEvents.instances;

  for (var instanceId in instances) {
    if (!rangeContainsRange(dateProfile.validRange, instances[instanceId].range)) {
      return false;
    }
  }

  return isNewPropsValid({
    eventDrag: interaction
  }, context); // HACK: the eventDrag props is used for ALL interactions
}

function isDateSelectionValid(dateSelection, dateProfile, context) {
  if (!rangeContainsRange(dateProfile.validRange, dateSelection.range)) {
    return false;
  }

  return isNewPropsValid({
    dateSelection: dateSelection
  }, context);
}

function isNewPropsValid(newProps, context) {
  var calendarState = context.getCurrentData();
  var props = Object.assign({
    businessHours: calendarState.businessHours,
    dateSelection: '',
    eventStore: calendarState.eventStore,
    eventUiBases: calendarState.eventUiBases,
    eventSelection: '',
    eventDrag: null,
    eventResize: null
  }, newProps);
  return (context.pluginHooks.isPropsValid || isPropsValid)(props, context);
}

function isPropsValid(state, context) {
  var dateSpanMeta = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var filterConfig = arguments.length > 3 ? arguments[3] : undefined;

  if (state.eventDrag && !isInteractionPropsValid(state, context, dateSpanMeta, filterConfig)) {
    return false;
  }

  if (state.dateSelection && !isDateSelectionPropsValid(state, context, dateSpanMeta, filterConfig)) {
    return false;
  }

  return true;
} // Moving Event Validation
// ------------------------------------------------------------------------------------------------------------------------


function isInteractionPropsValid(state, context, dateSpanMeta, filterConfig) {
  var currentState = context.getCurrentData();
  var interaction = state.eventDrag; // HACK: the eventDrag props is used for ALL interactions

  var subjectEventStore = interaction.mutatedEvents;
  var subjectDefs = subjectEventStore.defs;
  var subjectInstances = subjectEventStore.instances;
  var subjectConfigs = compileEventUis(subjectDefs, interaction.isEvent ? state.eventUiBases : {
    '': currentState.selectionConfig
  });

  if (filterConfig) {
    subjectConfigs = mapHash(subjectConfigs, filterConfig);
  } // exclude the subject events. TODO: exclude defs too?


  var otherEventStore = excludeInstances(state.eventStore, interaction.affectedEvents.instances);
  var otherDefs = otherEventStore.defs;
  var otherInstances = otherEventStore.instances;
  var otherConfigs = compileEventUis(otherDefs, state.eventUiBases);

  for (var subjectInstanceId in subjectInstances) {
    var subjectInstance = subjectInstances[subjectInstanceId];
    var subjectRange = subjectInstance.range;
    var subjectConfig = subjectConfigs[subjectInstance.defId];
    var subjectDef = subjectDefs[subjectInstance.defId]; // constraint

    if (!allConstraintsPass(subjectConfig.constraints, subjectRange, otherEventStore, state.businessHours, context)) {
      return false;
    } // overlap


    var eventOverlap = context.options.eventOverlap;
    var eventOverlapFunc = typeof eventOverlap === 'function' ? eventOverlap : null;

    for (var otherInstanceId in otherInstances) {
      var otherInstance = otherInstances[otherInstanceId]; // intersect! evaluate

      if (rangesIntersect(subjectRange, otherInstance.range)) {
        var otherOverlap = otherConfigs[otherInstance.defId].overlap; // consider the other event's overlap. only do this if the subject event is a "real" event

        if (otherOverlap === false && interaction.isEvent) {
          return false;
        }

        if (subjectConfig.overlap === false) {
          return false;
        }

        if (eventOverlapFunc && !eventOverlapFunc(new EventImpl(context, otherDefs[otherInstance.defId], otherInstance), // still event
        new EventImpl(context, subjectDef, subjectInstance))) {
          return false;
        }
      }
    } // allow (a function)


    var calendarEventStore = currentState.eventStore; // need global-to-calendar, not local to component (splittable)state

    var _iterator29 = _createForOfIteratorHelper(subjectConfig.allows),
        _step29;

    try {
      for (_iterator29.s(); !(_step29 = _iterator29.n()).done;) {
        var subjectAllow = _step29.value;
        var subjectDateSpan = Object.assign(Object.assign({}, dateSpanMeta), {
          range: subjectInstance.range,
          allDay: subjectDef.allDay
        });
        var origDef = calendarEventStore.defs[subjectDef.defId];
        var origInstance = calendarEventStore.instances[subjectInstanceId];
        var eventApi = void 0;

        if (origDef) {
          // was previously in the calendar
          eventApi = new EventImpl(context, origDef, origInstance);
        } else {
          // was an external event
          eventApi = new EventImpl(context, subjectDef); // no instance, because had no dates
        }

        if (!subjectAllow(buildDateSpanApiWithContext(subjectDateSpan, context), eventApi)) {
          return false;
        }
      }
    } catch (err) {
      _iterator29.e(err);
    } finally {
      _iterator29.f();
    }
  }

  return true;
} // Date Selection Validation
// ------------------------------------------------------------------------------------------------------------------------


function isDateSelectionPropsValid(state, context, dateSpanMeta, filterConfig) {
  var relevantEventStore = state.eventStore;
  var relevantDefs = relevantEventStore.defs;
  var relevantInstances = relevantEventStore.instances;
  var selection = state.dateSelection;
  var selectionRange = selection.range;

  var _context$getCurrentDa2 = context.getCurrentData(),
      selectionConfig = _context$getCurrentDa2.selectionConfig;

  if (filterConfig) {
    selectionConfig = filterConfig(selectionConfig);
  } // constraint


  if (!allConstraintsPass(selectionConfig.constraints, selectionRange, relevantEventStore, state.businessHours, context)) {
    return false;
  } // overlap


  var selectOverlap = context.options.selectOverlap;
  var selectOverlapFunc = typeof selectOverlap === 'function' ? selectOverlap : null;

  for (var relevantInstanceId in relevantInstances) {
    var relevantInstance = relevantInstances[relevantInstanceId]; // intersect! evaluate

    if (rangesIntersect(selectionRange, relevantInstance.range)) {
      if (selectionConfig.overlap === false) {
        return false;
      }

      if (selectOverlapFunc && !selectOverlapFunc(new EventImpl(context, relevantDefs[relevantInstance.defId], relevantInstance), null)) {
        return false;
      }
    }
  } // allow (a function)


  var _iterator30 = _createForOfIteratorHelper(selectionConfig.allows),
      _step30;

  try {
    for (_iterator30.s(); !(_step30 = _iterator30.n()).done;) {
      var selectionAllow = _step30.value;
      var fullDateSpan = Object.assign(Object.assign({}, dateSpanMeta), selection);

      if (!selectionAllow(buildDateSpanApiWithContext(fullDateSpan, context), null)) {
        return false;
      }
    }
  } catch (err) {
    _iterator30.e(err);
  } finally {
    _iterator30.f();
  }

  return true;
} // Constraint Utils
// ------------------------------------------------------------------------------------------------------------------------


function allConstraintsPass(constraints, subjectRange, otherEventStore, businessHoursUnexpanded, context) {
  var _iterator31 = _createForOfIteratorHelper(constraints),
      _step31;

  try {
    for (_iterator31.s(); !(_step31 = _iterator31.n()).done;) {
      var constraint = _step31.value;

      if (!anyRangesContainRange(constraintToRanges(constraint, subjectRange, otherEventStore, businessHoursUnexpanded, context), subjectRange)) {
        return false;
      }
    }
  } catch (err) {
    _iterator31.e(err);
  } finally {
    _iterator31.f();
  }

  return true;
}

function constraintToRanges(constraint, subjectRange, // for expanding a recurring constraint, or expanding business hours
otherEventStore, // for if constraint is an even group ID
businessHoursUnexpanded, // for if constraint is 'businessHours'
context) {
  if (constraint === 'businessHours') {
    return eventStoreToRanges(expandRecurring(businessHoursUnexpanded, subjectRange, context));
  }

  if (typeof constraint === 'string') {
    // an group ID
    return eventStoreToRanges(filterEventStoreDefs(otherEventStore, function (eventDef) {
      return eventDef.groupId === constraint;
    }));
  }

  if (_typeof(constraint) === 'object' && constraint) {
    // non-null object
    return eventStoreToRanges(expandRecurring(constraint, subjectRange, context));
  }

  return []; // if it's false
} // TODO: move to event-store file?


function eventStoreToRanges(eventStore) {
  var instances = eventStore.instances;
  var ranges = [];

  for (var instanceId in instances) {
    ranges.push(instances[instanceId].range);
  }

  return ranges;
} // TODO: move to geom file?


function anyRangesContainRange(outerRanges, innerRange) {
  var _iterator32 = _createForOfIteratorHelper(outerRanges),
      _step32;

  try {
    for (_iterator32.s(); !(_step32 = _iterator32.n()).done;) {
      var outerRange = _step32.value;

      if (rangeContainsRange(outerRange, innerRange)) {
        return true;
      }
    }
  } catch (err) {
    _iterator32.e(err);
  } finally {
    _iterator32.f();
  }

  return false;
}

var VISIBLE_HIDDEN_RE = /^(visible|hidden)$/;

var Scroller = /*#__PURE__*/function (_BaseComponent8) {
  _inherits(Scroller, _BaseComponent8);

  var _super16 = _createSuper(Scroller);

  function Scroller() {
    var _this19;

    _classCallCheck(this, Scroller);

    _this19 = _super16.apply(this, arguments);

    _this19.handleEl = function (el) {
      _this19.el = el;
      setRef(_this19.props.elRef, el);
    };

    return _this19;
  }

  _createClass(Scroller, [{
    key: "render",
    value: function render() {
      var props = this.props;
      var liquid = props.liquid,
          liquidIsAbsolute = props.liquidIsAbsolute;
      var isAbsolute = liquid && liquidIsAbsolute;
      var className = ['fc-scroller'];

      if (liquid) {
        if (liquidIsAbsolute) {
          className.push('fc-scroller-liquid-absolute');
        } else {
          className.push('fc-scroller-liquid');
        }
      }

      return createElement("div", {
        ref: this.handleEl,
        className: className.join(' '),
        style: {
          overflowX: props.overflowX,
          overflowY: props.overflowY,
          left: isAbsolute && -(props.overcomeLeft || 0) || '',
          right: isAbsolute && -(props.overcomeRight || 0) || '',
          bottom: isAbsolute && -(props.overcomeBottom || 0) || '',
          marginLeft: !isAbsolute && -(props.overcomeLeft || 0) || '',
          marginRight: !isAbsolute && -(props.overcomeRight || 0) || '',
          marginBottom: !isAbsolute && -(props.overcomeBottom || 0) || '',
          maxHeight: props.maxHeight || ''
        }
      }, props.children);
    }
  }, {
    key: "needsXScrolling",
    value: function needsXScrolling() {
      if (VISIBLE_HIDDEN_RE.test(this.props.overflowX)) {
        return false;
      } // testing scrollWidth>clientWidth is unreliable cross-browser when pixel heights aren't integers.
      // much more reliable to see if children are taller than the scroller, even tho doesn't account for
      // inner-child margins and absolute positioning


      var el = this.el;
      var realClientWidth = this.el.getBoundingClientRect().width - this.getYScrollbarWidth();
      var children = el.children;

      for (var i = 0; i < children.length; i += 1) {
        var childEl = children[i];

        if (childEl.getBoundingClientRect().width > realClientWidth) {
          return true;
        }
      }

      return false;
    }
  }, {
    key: "needsYScrolling",
    value: function needsYScrolling() {
      if (VISIBLE_HIDDEN_RE.test(this.props.overflowY)) {
        return false;
      } // testing scrollHeight>clientHeight is unreliable cross-browser when pixel heights aren't integers.
      // much more reliable to see if children are taller than the scroller, even tho doesn't account for
      // inner-child margins and absolute positioning


      var el = this.el;
      var realClientHeight = this.el.getBoundingClientRect().height - this.getXScrollbarWidth();
      var children = el.children;

      for (var i = 0; i < children.length; i += 1) {
        var childEl = children[i];

        if (childEl.getBoundingClientRect().height > realClientHeight) {
          return true;
        }
      }

      return false;
    }
  }, {
    key: "getXScrollbarWidth",
    value: function getXScrollbarWidth() {
      if (VISIBLE_HIDDEN_RE.test(this.props.overflowX)) {
        return 0;
      }

      return this.el.offsetHeight - this.el.clientHeight; // only works because we guarantee no borders. TODO: add to CSS with important?
    }
  }, {
    key: "getYScrollbarWidth",
    value: function getYScrollbarWidth() {
      if (VISIBLE_HIDDEN_RE.test(this.props.overflowY)) {
        return 0;
      }

      return this.el.offsetWidth - this.el.clientWidth; // only works because we guarantee no borders. TODO: add to CSS with important?
    }
  }]);

  return Scroller;
}(BaseComponent);
/*
TODO: somehow infer OtherArgs from masterCallback?
TODO: infer RefType from masterCallback if provided
*/


var RefMap = /*#__PURE__*/function () {
  function RefMap(masterCallback) {
    var _this20 = this;

    _classCallCheck(this, RefMap);

    this.masterCallback = masterCallback;
    this.currentMap = {};
    this.depths = {};
    this.callbackMap = {};

    this.handleValue = function (val, key) {
      var depths = _this20.depths,
          currentMap = _this20.currentMap;
      var removed = false;
      var added = false;

      if (val !== null) {
        // for bug... ACTUALLY: can probably do away with this now that callers don't share numeric indices anymore
        removed = key in currentMap;
        currentMap[key] = val;
        depths[key] = (depths[key] || 0) + 1;
        added = true;
      } else {
        depths[key] -= 1;

        if (!depths[key]) {
          delete currentMap[key];
          delete _this20.callbackMap[key];
          removed = true;
        }
      }

      if (_this20.masterCallback) {
        if (removed) {
          _this20.masterCallback(null, String(key));
        }

        if (added) {
          _this20.masterCallback(val, String(key));
        }
      }
    };
  }

  _createClass(RefMap, [{
    key: "createRef",
    value: function createRef(key) {
      var _this21 = this;

      var refCallback = this.callbackMap[key];

      if (!refCallback) {
        refCallback = this.callbackMap[key] = function (val) {
          _this21.handleValue(val, String(key));
        };
      }

      return refCallback;
    } // TODO: check callers that don't care about order. should use getAll instead
    // NOTE: this method has become less valuable now that we are encouraged to map order by some other index
    // TODO: provide ONE array-export function, buildArray, which fails on non-numeric indexes. caller can manipulate and "collect"

  }, {
    key: "collect",
    value: function collect(startIndex, endIndex, step) {
      return collectFromHash(this.currentMap, startIndex, endIndex, step);
    }
  }, {
    key: "getAll",
    value: function getAll() {
      return hashValuesToArray(this.currentMap);
    }
  }]);

  return RefMap;
}();

function _computeShrinkWidth(chunkEls) {
  var shrinkCells = findElements(chunkEls, '.fc-scrollgrid-shrink');
  var largestWidth = 0;

  var _iterator33 = _createForOfIteratorHelper(shrinkCells),
      _step33;

  try {
    for (_iterator33.s(); !(_step33 = _iterator33.n()).done;) {
      var shrinkCell = _step33.value;
      largestWidth = Math.max(largestWidth, computeSmallestCellWidth(shrinkCell));
    }
  } catch (err) {
    _iterator33.e(err);
  } finally {
    _iterator33.f();
  }

  return Math.ceil(largestWidth); // <table> elements work best with integers. round up to ensure contents fits
}

function getSectionHasLiquidHeight(props, sectionConfig) {
  return props.liquid && sectionConfig.liquid; // does the section do liquid-height? (need to have whole scrollgrid liquid-height as well)
}

function getAllowYScrolling(props, sectionConfig) {
  return sectionConfig.maxHeight != null || // if its possible for the height to max out, we might need scrollbars
  getSectionHasLiquidHeight(props, sectionConfig); // if the section is liquid height, it might condense enough to require scrollbars
} // TODO: ONLY use `arg`. force out internal function to use same API


function renderChunkContent(sectionConfig, chunkConfig, arg, isHeader) {
  var expandRows = arg.expandRows;
  var content = typeof chunkConfig.content === 'function' ? chunkConfig.content(arg) : createElement('table', {
    role: 'presentation',
    className: [chunkConfig.tableClassName, sectionConfig.syncRowHeights ? 'fc-scrollgrid-sync-table' : ''].join(' '),
    style: {
      minWidth: arg.tableMinWidth,
      width: arg.clientWidth,
      height: expandRows ? arg.clientHeight : '' // css `height` on a <table> serves as a min-height

    }
  }, arg.tableColGroupNode, createElement(isHeader ? 'thead' : 'tbody', {
    role: 'presentation'
  }, typeof chunkConfig.rowContent === 'function' ? chunkConfig.rowContent(arg) : chunkConfig.rowContent));
  return content;
}

function isColPropsEqual(cols0, cols1) {
  return isArraysEqual(cols0, cols1, isPropsEqual);
}

function renderMicroColGroup(cols, shrinkWidth) {
  var colNodes = [];
  /*
  for ColProps with spans, it would have been great to make a single <col span="">
  HOWEVER, Chrome was getting messing up distributing the width to <td>/<th> elements with colspans.
  SOLUTION: making individual <col> elements makes Chrome behave.
  */

  var _iterator34 = _createForOfIteratorHelper(cols),
      _step34;

  try {
    for (_iterator34.s(); !(_step34 = _iterator34.n()).done;) {
      var colProps = _step34.value;
      var span = colProps.span || 1;

      for (var i = 0; i < span; i += 1) {
        colNodes.push(createElement("col", {
          style: {
            width: colProps.width === 'shrink' ? sanitizeShrinkWidth(shrinkWidth) : colProps.width || '',
            minWidth: colProps.minWidth || ''
          }
        }));
      }
    }
  } catch (err) {
    _iterator34.e(err);
  } finally {
    _iterator34.f();
  }

  return createElement.apply(void 0, ['colgroup', {}].concat(colNodes));
}

function sanitizeShrinkWidth(shrinkWidth) {
  /* why 4? if we do 0, it will kill any border, which are needed for computeSmallestCellWidth
  4 accounts for 2 2-pixel borders. TODO: better solution? */
  return shrinkWidth == null ? 4 : shrinkWidth;
}

function hasShrinkWidth(cols) {
  var _iterator35 = _createForOfIteratorHelper(cols),
      _step35;

  try {
    for (_iterator35.s(); !(_step35 = _iterator35.n()).done;) {
      var col = _step35.value;

      if (col.width === 'shrink') {
        return true;
      }
    }
  } catch (err) {
    _iterator35.e(err);
  } finally {
    _iterator35.f();
  }

  return false;
}

function getScrollGridClassNames(liquid, context) {
  var classNames = ['fc-scrollgrid', context.theme.getClass('table')];

  if (liquid) {
    classNames.push('fc-scrollgrid-liquid');
  }

  return classNames;
}

function getSectionClassNames(sectionConfig, wholeTableVGrow) {
  var classNames = ['fc-scrollgrid-section', "fc-scrollgrid-section-".concat(sectionConfig.type), sectionConfig.className // used?
  ];

  if (wholeTableVGrow && sectionConfig.liquid && sectionConfig.maxHeight == null) {
    classNames.push('fc-scrollgrid-section-liquid');
  }

  if (sectionConfig.isSticky) {
    classNames.push('fc-scrollgrid-section-sticky');
  }

  return classNames;
}

function renderScrollShim(arg) {
  return createElement("div", {
    className: "fc-scrollgrid-sticky-shim",
    style: {
      width: arg.clientWidth,
      minWidth: arg.tableMinWidth
    }
  });
}

function getStickyHeaderDates(options) {
  var stickyHeaderDates = options.stickyHeaderDates;

  if (stickyHeaderDates == null || stickyHeaderDates === 'auto') {
    stickyHeaderDates = options.height === 'auto' || options.viewHeight === 'auto';
  }

  return stickyHeaderDates;
}

function getStickyFooterScrollbar(options) {
  var stickyFooterScrollbar = options.stickyFooterScrollbar;

  if (stickyFooterScrollbar == null || stickyFooterScrollbar === 'auto') {
    stickyFooterScrollbar = options.height === 'auto' || options.viewHeight === 'auto';
  }

  return stickyFooterScrollbar;
}

var SimpleScrollGrid = /*#__PURE__*/function (_BaseComponent9) {
  _inherits(SimpleScrollGrid, _BaseComponent9);

  var _super17 = _createSuper(SimpleScrollGrid);

  function SimpleScrollGrid() {
    var _this22;

    _classCallCheck(this, SimpleScrollGrid);

    _this22 = _super17.apply(this, arguments);
    _this22.processCols = memoize(function (a) {
      return a;
    }, isColPropsEqual); // so we get same `cols` props every time
    // yucky to memoize VNodes, but much more efficient for consumers

    _this22.renderMicroColGroup = memoize(renderMicroColGroup);
    _this22.scrollerRefs = new RefMap();
    _this22.scrollerElRefs = new RefMap(_this22._handleScrollerEl.bind(_assertThisInitialized(_this22)));
    _this22.state = {
      shrinkWidth: null,
      forceYScrollbars: false,
      scrollerClientWidths: {},
      scrollerClientHeights: {}
    }; // TODO: can do a really simple print-view. dont need to join rows

    _this22.handleSizing = function () {
      _this22.safeSetState(Object.assign({
        shrinkWidth: _this22.computeShrinkWidth()
      }, _this22.computeScrollerDims()));
    };

    return _this22;
  }

  _createClass(SimpleScrollGrid, [{
    key: "render",
    value: function render() {
      var props = this.props,
          state = this.state,
          context = this.context;
      var sectionConfigs = props.sections || [];
      var cols = this.processCols(props.cols);
      var microColGroupNode = this.renderMicroColGroup(cols, state.shrinkWidth);
      var classNames = getScrollGridClassNames(props.liquid, context);

      if (props.collapsibleWidth) {
        classNames.push('fc-scrollgrid-collapsible');
      } // TODO: make DRY


      var configCnt = sectionConfigs.length;
      var configI = 0;
      var currentConfig;
      var headSectionNodes = [];
      var bodySectionNodes = [];
      var footSectionNodes = [];

      while (configI < configCnt && (currentConfig = sectionConfigs[configI]).type === 'header') {
        headSectionNodes.push(this.renderSection(currentConfig, microColGroupNode, true));
        configI += 1;
      }

      while (configI < configCnt && (currentConfig = sectionConfigs[configI]).type === 'body') {
        bodySectionNodes.push(this.renderSection(currentConfig, microColGroupNode, false));
        configI += 1;
      }

      while (configI < configCnt && (currentConfig = sectionConfigs[configI]).type === 'footer') {
        footSectionNodes.push(this.renderSection(currentConfig, microColGroupNode, true));
        configI += 1;
      } // firefox bug: when setting height on table and there is a thead or tfoot,
      // the necessary height:100% on the liquid-height body section forces the *whole* table to be taller. (bug #5524)
      // use getCanVGrowWithinCell as a way to detect table-stupid firefox.
      // if so, use a simpler dom structure, jam everything into a lone tbody.


      var isBuggy = !getCanVGrowWithinCell();
      var roleAttrs = {
        role: 'rowgroup'
      };
      return createElement('table', {
        role: 'grid',
        className: classNames.join(' '),
        style: {
          height: props.height
        }
      }, Boolean(!isBuggy && headSectionNodes.length) && createElement.apply(void 0, ['thead', roleAttrs].concat(headSectionNodes)), Boolean(!isBuggy && bodySectionNodes.length) && createElement.apply(void 0, ['tbody', roleAttrs].concat(bodySectionNodes)), Boolean(!isBuggy && footSectionNodes.length) && createElement.apply(void 0, ['tfoot', roleAttrs].concat(footSectionNodes)), isBuggy && createElement.apply(void 0, ['tbody', roleAttrs].concat(headSectionNodes, bodySectionNodes, footSectionNodes)));
    }
  }, {
    key: "renderSection",
    value: function renderSection(sectionConfig, microColGroupNode, isHeader) {
      if ('outerContent' in sectionConfig) {
        return createElement(Fragment, {
          key: sectionConfig.key
        }, sectionConfig.outerContent);
      }

      return createElement("tr", {
        key: sectionConfig.key,
        role: "presentation",
        className: getSectionClassNames(sectionConfig, this.props.liquid).join(' ')
      }, this.renderChunkTd(sectionConfig, microColGroupNode, sectionConfig.chunk, isHeader));
    }
  }, {
    key: "renderChunkTd",
    value: function renderChunkTd(sectionConfig, microColGroupNode, chunkConfig, isHeader) {
      if ('outerContent' in chunkConfig) {
        return chunkConfig.outerContent;
      }

      var props = this.props;
      var _this$state = this.state,
          forceYScrollbars = _this$state.forceYScrollbars,
          scrollerClientWidths = _this$state.scrollerClientWidths,
          scrollerClientHeights = _this$state.scrollerClientHeights;
      var needsYScrolling = getAllowYScrolling(props, sectionConfig); // TODO: do lazily. do in section config?

      var isLiquid = getSectionHasLiquidHeight(props, sectionConfig); // for `!props.liquid` - is WHOLE scrollgrid natural height?
      // TODO: do same thing in advanced scrollgrid? prolly not b/c always has horizontal scrollbars

      var overflowY = !props.liquid ? 'visible' : forceYScrollbars ? 'scroll' : !needsYScrolling ? 'hidden' : 'auto';
      var sectionKey = sectionConfig.key;
      var content = renderChunkContent(sectionConfig, chunkConfig, {
        tableColGroupNode: microColGroupNode,
        tableMinWidth: '',
        clientWidth: !props.collapsibleWidth && scrollerClientWidths[sectionKey] !== undefined ? scrollerClientWidths[sectionKey] : null,
        clientHeight: scrollerClientHeights[sectionKey] !== undefined ? scrollerClientHeights[sectionKey] : null,
        expandRows: sectionConfig.expandRows,
        syncRowHeights: false,
        rowSyncHeights: [],
        reportRowHeightChange: function reportRowHeightChange() {}
      }, isHeader);
      return createElement(isHeader ? 'th' : 'td', {
        ref: chunkConfig.elRef,
        role: 'presentation'
      }, createElement("div", {
        className: "fc-scroller-harness".concat(isLiquid ? ' fc-scroller-harness-liquid' : '')
      }, createElement(Scroller, {
        ref: this.scrollerRefs.createRef(sectionKey),
        elRef: this.scrollerElRefs.createRef(sectionKey),
        overflowY: overflowY,
        overflowX: !props.liquid ? 'visible' : 'hidden'
        /* natural height? */
        ,
        maxHeight: sectionConfig.maxHeight,
        liquid: isLiquid,
        liquidIsAbsolute // because its within a harness
        : true
      }, content)));
    }
  }, {
    key: "_handleScrollerEl",
    value: function _handleScrollerEl(scrollerEl, key) {
      var section = getSectionByKey(this.props.sections, key);

      if (section) {
        setRef(section.chunk.scrollerElRef, scrollerEl);
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.handleSizing();
      this.context.addResizeHandler(this.handleSizing);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      // TODO: need better solution when state contains non-sizing things
      this.handleSizing();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.context.removeResizeHandler(this.handleSizing);
    }
  }, {
    key: "computeShrinkWidth",
    value: function computeShrinkWidth() {
      return hasShrinkWidth(this.props.cols) ? _computeShrinkWidth(this.scrollerElRefs.getAll()) : 0;
    }
  }, {
    key: "computeScrollerDims",
    value: function computeScrollerDims() {
      var scrollbarWidth = getScrollbarWidths();
      var scrollerRefs = this.scrollerRefs,
          scrollerElRefs = this.scrollerElRefs;
      var forceYScrollbars = false;
      var scrollerClientWidths = {};
      var scrollerClientHeights = {};

      for (var sectionKey in scrollerRefs.currentMap) {
        var scroller = scrollerRefs.currentMap[sectionKey];

        if (scroller && scroller.needsYScrolling()) {
          forceYScrollbars = true;
          break;
        }
      }

      var _iterator36 = _createForOfIteratorHelper(this.props.sections),
          _step36;

      try {
        for (_iterator36.s(); !(_step36 = _iterator36.n()).done;) {
          var section = _step36.value;
          var _sectionKey = section.key;
          var scrollerEl = scrollerElRefs.currentMap[_sectionKey];

          if (scrollerEl) {
            var harnessEl = scrollerEl.parentNode; // TODO: weird way to get this. need harness b/c doesn't include table borders

            scrollerClientWidths[_sectionKey] = Math.floor(harnessEl.getBoundingClientRect().width - (forceYScrollbars ? scrollbarWidth.y // use global because scroller might not have scrollbars yet but will need them in future
            : 0));
            scrollerClientHeights[_sectionKey] = Math.floor(harnessEl.getBoundingClientRect().height);
          }
        }
      } catch (err) {
        _iterator36.e(err);
      } finally {
        _iterator36.f();
      }

      return {
        forceYScrollbars: forceYScrollbars,
        scrollerClientWidths: scrollerClientWidths,
        scrollerClientHeights: scrollerClientHeights
      };
    }
  }]);

  return SimpleScrollGrid;
}(BaseComponent);

SimpleScrollGrid.addStateEquality({
  scrollerClientWidths: isPropsEqual,
  scrollerClientHeights: isPropsEqual
});

function getSectionByKey(sections, key) {
  var _iterator37 = _createForOfIteratorHelper(sections),
      _step37;

  try {
    for (_iterator37.s(); !(_step37 = _iterator37.n()).done;) {
      var section = _step37.value;

      if (section.key === key) {
        return section;
      }
    }
  } catch (err) {
    _iterator37.e(err);
  } finally {
    _iterator37.f();
  }

  return null;
}

var EventContainer = /*#__PURE__*/function (_BaseComponent10) {
  _inherits(EventContainer, _BaseComponent10);

  var _super18 = _createSuper(EventContainer);

  function EventContainer() {
    var _this23;

    _classCallCheck(this, EventContainer);

    _this23 = _super18.apply(this, arguments);

    _this23.handleEl = function (el) {
      _this23.el = el;

      if (el) {
        setElSeg(el, _this23.props.seg);
      }
    };

    return _this23;
  }

  _createClass(EventContainer, [{
    key: "render",
    value: function render() {
      var props = this.props,
          context = this.context;
      var options = context.options;
      var seg = props.seg;
      var eventRange = seg.eventRange;
      var ui = eventRange.ui;
      var renderProps = {
        event: new EventImpl(context, eventRange.def, eventRange.instance),
        view: context.viewApi,
        timeText: props.timeText,
        textColor: ui.textColor,
        backgroundColor: ui.backgroundColor,
        borderColor: ui.borderColor,
        isDraggable: !props.disableDragging && computeSegDraggable(seg, context),
        isStartResizable: !props.disableResizing && computeSegStartResizable(seg, context),
        isEndResizable: !props.disableResizing && computeSegEndResizable(seg),
        isMirror: Boolean(props.isDragging || props.isResizing || props.isDateSelecting),
        isStart: Boolean(seg.isStart),
        isEnd: Boolean(seg.isEnd),
        isPast: Boolean(props.isPast),
        isFuture: Boolean(props.isFuture),
        isToday: Boolean(props.isToday),
        isSelected: Boolean(props.isSelected),
        isDragging: Boolean(props.isDragging),
        isResizing: Boolean(props.isResizing)
      };
      return createElement(ContentContainer, Object.assign({}, props
      /* contains children */
      , {
        elRef: this.handleEl,
        elClasses: [].concat(_toConsumableArray(getEventClassNames(renderProps)), _toConsumableArray(seg.eventRange.ui.classNames), _toConsumableArray(props.elClasses || [])),
        renderProps: renderProps,
        generatorName: "eventContent",
        customGenerator: options.eventContent,
        defaultGenerator: props.defaultGenerator,
        classNameGenerator: options.eventClassNames,
        didMount: options.eventDidMount,
        willUnmount: options.eventWillUnmount
      }));
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.el && this.props.seg !== prevProps.seg) {
        setElSeg(this.el, this.props.seg);
      }
    }
  }]);

  return EventContainer;
}(BaseComponent); // should not be a purecomponent


var StandardEvent = /*#__PURE__*/function (_BaseComponent11) {
  _inherits(StandardEvent, _BaseComponent11);

  var _super19 = _createSuper(StandardEvent);

  function StandardEvent() {
    _classCallCheck(this, StandardEvent);

    return _super19.apply(this, arguments);
  }

  _createClass(StandardEvent, [{
    key: "render",
    value: function render() {
      var props = this.props,
          context = this.context;
      var options = context.options;
      var seg = props.seg;
      var ui = seg.eventRange.ui;
      var timeFormat = options.eventTimeFormat || props.defaultTimeFormat;
      var timeText = buildSegTimeText(seg, timeFormat, context, props.defaultDisplayEventTime, props.defaultDisplayEventEnd);
      return createElement(EventContainer, Object.assign({}, props
      /* includes elRef */
      , {
        elTag: "a",
        elStyle: {
          borderColor: ui.borderColor,
          backgroundColor: ui.backgroundColor
        },
        elAttrs: getSegAnchorAttrs(seg, context),
        defaultGenerator: renderInnerContent$1,
        timeText: timeText
      }), function (InnerContent, eventContentArg) {
        return createElement(Fragment, null, createElement(InnerContent, {
          elTag: "div",
          elClasses: ['fc-event-main'],
          elStyle: {
            color: eventContentArg.textColor
          }
        }), Boolean(eventContentArg.isStartResizable) && createElement("div", {
          className: "fc-event-resizer fc-event-resizer-start"
        }), Boolean(eventContentArg.isEndResizable) && createElement("div", {
          className: "fc-event-resizer fc-event-resizer-end"
        }));
      });
    }
  }]);

  return StandardEvent;
}(BaseComponent);

function renderInnerContent$1(innerProps) {
  return createElement("div", {
    className: "fc-event-main-frame"
  }, innerProps.timeText && createElement("div", {
    className: "fc-event-time"
  }, innerProps.timeText), createElement("div", {
    className: "fc-event-title-container"
  }, createElement("div", {
    className: "fc-event-title fc-sticky"
  }, innerProps.event.title || createElement(Fragment, null, "\xA0"))));
}

var NowIndicatorContainer = function NowIndicatorContainer(props) {
  return createElement(ViewContextType.Consumer, null, function (context) {
    var options = context.options;
    var renderProps = {
      isAxis: props.isAxis,
      date: context.dateEnv.toDate(props.date),
      view: context.viewApi
    };
    return createElement(ContentContainer, Object.assign({}, props
    /* includes children */
    , {
      elTag: props.elTag || 'div',
      renderProps: renderProps,
      generatorName: "nowIndicatorContent",
      customGenerator: options.nowIndicatorContent,
      classNameGenerator: options.nowIndicatorClassNames,
      didMount: options.nowIndicatorDidMount,
      willUnmount: options.nowIndicatorWillUnmount
    }));
  });
};

var DAY_NUM_FORMAT = createFormatter({
  day: 'numeric'
});

var DayCellContainer = /*#__PURE__*/function (_BaseComponent12) {
  _inherits(DayCellContainer, _BaseComponent12);

  var _super20 = _createSuper(DayCellContainer);

  function DayCellContainer() {
    var _this24;

    _classCallCheck(this, DayCellContainer);

    _this24 = _super20.apply(this, arguments);
    _this24.refineRenderProps = memoizeObjArg(refineRenderProps);
    return _this24;
  }

  _createClass(DayCellContainer, [{
    key: "render",
    value: function render() {
      var props = this.props,
          context = this.context;
      var options = context.options;
      var renderProps = this.refineRenderProps({
        date: props.date,
        dateProfile: props.dateProfile,
        todayRange: props.todayRange,
        isMonthStart: props.isMonthStart || false,
        showDayNumber: props.showDayNumber,
        extraRenderProps: props.extraRenderProps,
        viewApi: context.viewApi,
        dateEnv: context.dateEnv,
        monthStartFormat: options.monthStartFormat
      });
      return createElement(ContentContainer, Object.assign({}, props
      /* includes children */
      , {
        elClasses: [].concat(_toConsumableArray(getDayClassNames(renderProps, context.theme)), _toConsumableArray(props.elClasses || [])),
        elAttrs: Object.assign(Object.assign({}, props.elAttrs), renderProps.isDisabled ? {} : {
          'data-date': formatDayString(props.date)
        }),
        renderProps: renderProps,
        generatorName: "dayCellContent",
        customGenerator: options.dayCellContent,
        defaultGenerator: props.defaultGenerator,
        classNameGenerator: // don't use custom classNames if disabled
        renderProps.isDisabled ? undefined : options.dayCellClassNames,
        didMount: options.dayCellDidMount,
        willUnmount: options.dayCellWillUnmount
      }));
    }
  }]);

  return DayCellContainer;
}(BaseComponent);

function hasCustomDayCellContent(options) {
  return Boolean(options.dayCellContent || hasCustomRenderingHandler('dayCellContent', options));
}

function refineRenderProps(raw) {
  var date = raw.date,
      dateEnv = raw.dateEnv,
      dateProfile = raw.dateProfile,
      isMonthStart = raw.isMonthStart;
  var dayMeta = getDateMeta(date, raw.todayRange, null, dateProfile);
  var dayNumberText = raw.showDayNumber ? dateEnv.format(date, isMonthStart ? raw.monthStartFormat : DAY_NUM_FORMAT) : '';
  return Object.assign(Object.assign(Object.assign({
    date: dateEnv.toDate(date),
    view: raw.viewApi
  }, dayMeta), {
    isMonthStart: isMonthStart,
    dayNumberText: dayNumberText
  }), raw.extraRenderProps);
}

var BgEvent = /*#__PURE__*/function (_BaseComponent13) {
  _inherits(BgEvent, _BaseComponent13);

  var _super21 = _createSuper(BgEvent);

  function BgEvent() {
    _classCallCheck(this, BgEvent);

    return _super21.apply(this, arguments);
  }

  _createClass(BgEvent, [{
    key: "render",
    value: function render() {
      var props = this.props;
      var seg = props.seg;
      return createElement(EventContainer, {
        elTag: "div",
        elClasses: ['fc-bg-event'],
        elStyle: {
          backgroundColor: seg.eventRange.ui.backgroundColor
        },
        defaultGenerator: renderInnerContent,
        seg: seg,
        timeText: "",
        isDragging: false,
        isResizing: false,
        isDateSelecting: false,
        isSelected: false,
        isPast: props.isPast,
        isFuture: props.isFuture,
        isToday: props.isToday,
        disableDragging: true,
        disableResizing: true
      });
    }
  }]);

  return BgEvent;
}(BaseComponent);

function renderInnerContent(props) {
  var title = props.event.title;
  return title && createElement("div", {
    className: "fc-event-title"
  }, props.event.title);
}

function renderFill(fillType) {
  return createElement("div", {
    className: "fc-".concat(fillType)
  });
}

var WeekNumberContainer = function WeekNumberContainer(props) {
  return createElement(ViewContextType.Consumer, null, function (context) {
    var dateEnv = context.dateEnv,
        options = context.options;
    var date = props.date;
    var format = options.weekNumberFormat || props.defaultFormat;
    var num = dateEnv.computeWeekNumber(date); // TODO: somehow use for formatting as well?

    var text = dateEnv.format(date, format);
    var renderProps = {
      num: num,
      text: text,
      date: date
    };
    return createElement(ContentContainer // why isn't WeekNumberContentArg being auto-detected?
    , Object.assign({}, props
    /* includes children */
    , {
      renderProps: renderProps,
      generatorName: "weekNumberContent",
      customGenerator: options.weekNumberContent,
      defaultGenerator: renderInner,
      classNameGenerator: options.weekNumberClassNames,
      didMount: options.weekNumberDidMount,
      willUnmount: options.weekNumberWillUnmount
    }));
  });
};

function renderInner(innerProps) {
  return innerProps.text;
}

var PADDING_FROM_VIEWPORT = 10;

var Popover = /*#__PURE__*/function (_BaseComponent14) {
  _inherits(Popover, _BaseComponent14);

  var _super22 = _createSuper(Popover);

  function Popover() {
    var _this25;

    _classCallCheck(this, Popover);

    _this25 = _super22.apply(this, arguments);
    _this25.state = {
      titleId: getUniqueDomId()
    };

    _this25.handleRootEl = function (el) {
      _this25.rootEl = el;

      if (_this25.props.elRef) {
        setRef(_this25.props.elRef, el);
      }
    }; // Triggered when the user clicks *anywhere* in the document, for the autoHide feature


    _this25.handleDocumentMouseDown = function (ev) {
      // only hide the popover if the click happened outside the popover
      var target = getEventTargetViaRoot(ev);

      if (!_this25.rootEl.contains(target)) {
        _this25.handleCloseClick();
      }
    };

    _this25.handleDocumentKeyDown = function (ev) {
      if (ev.key === 'Escape') {
        _this25.handleCloseClick();
      }
    };

    _this25.handleCloseClick = function () {
      var onClose = _this25.props.onClose;

      if (onClose) {
        onClose();
      }
    };

    return _this25;
  }

  _createClass(Popover, [{
    key: "render",
    value: function render() {
      var _this$context3 = this.context,
          theme = _this$context3.theme,
          options = _this$context3.options;
      var props = this.props,
          state = this.state;
      var classNames = ['fc-popover', theme.getClass('popover')].concat(props.extraClassNames || []);
      return createPortal(createElement("div", Object.assign({}, props.extraAttrs, {
        id: props.id,
        className: classNames.join(' '),
        "aria-labelledby": state.titleId,
        ref: this.handleRootEl
      }), createElement("div", {
        className: 'fc-popover-header ' + theme.getClass('popoverHeader')
      }, createElement("span", {
        className: "fc-popover-title",
        id: state.titleId
      }, props.title), createElement("span", {
        className: 'fc-popover-close ' + theme.getIconClass('close'),
        title: options.closeHint,
        onClick: this.handleCloseClick
      })), createElement("div", {
        className: 'fc-popover-body ' + theme.getClass('popoverContent')
      }, props.children)), props.parentEl);
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener('mousedown', this.handleDocumentMouseDown);
      document.addEventListener('keydown', this.handleDocumentKeyDown);
      this.updateSize();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('mousedown', this.handleDocumentMouseDown);
      document.removeEventListener('keydown', this.handleDocumentKeyDown);
    }
  }, {
    key: "updateSize",
    value: function updateSize() {
      var isRtl = this.context.isRtl;
      var _this$props5 = this.props,
          alignmentEl = _this$props5.alignmentEl,
          alignGridTop = _this$props5.alignGridTop;
      var rootEl = this.rootEl;
      var alignmentRect = computeClippedClientRect(alignmentEl);

      if (alignmentRect) {
        var popoverDims = rootEl.getBoundingClientRect(); // position relative to viewport

        var popoverTop = alignGridTop ? elementClosest(alignmentEl, '.fc-scrollgrid').getBoundingClientRect().top : alignmentRect.top;
        var popoverLeft = isRtl ? alignmentRect.right - popoverDims.width : alignmentRect.left; // constrain

        popoverTop = Math.max(popoverTop, PADDING_FROM_VIEWPORT);
        popoverLeft = Math.min(popoverLeft, document.documentElement.clientWidth - PADDING_FROM_VIEWPORT - popoverDims.width);
        popoverLeft = Math.max(popoverLeft, PADDING_FROM_VIEWPORT);
        var origin = rootEl.offsetParent.getBoundingClientRect();
        applyStyle(rootEl, {
          top: popoverTop - origin.top,
          left: popoverLeft - origin.left
        });
      }
    }
  }]);

  return Popover;
}(BaseComponent);

var MorePopover = /*#__PURE__*/function (_DateComponent) {
  _inherits(MorePopover, _DateComponent);

  var _super23 = _createSuper(MorePopover);

  function MorePopover() {
    var _this26;

    _classCallCheck(this, MorePopover);

    _this26 = _super23.apply(this, arguments);

    _this26.handleRootEl = function (rootEl) {
      _this26.rootEl = rootEl;

      if (rootEl) {
        _this26.context.registerInteractiveComponent(_assertThisInitialized(_this26), {
          el: rootEl,
          useEventCenter: false
        });
      } else {
        _this26.context.unregisterInteractiveComponent(_assertThisInitialized(_this26));
      }
    };

    return _this26;
  }

  _createClass(MorePopover, [{
    key: "render",
    value: function render() {
      var _this$context4 = this.context,
          options = _this$context4.options,
          dateEnv = _this$context4.dateEnv;
      var props = this.props;
      var startDate = props.startDate,
          todayRange = props.todayRange,
          dateProfile = props.dateProfile;
      var title = dateEnv.format(startDate, options.dayPopoverFormat);
      return createElement(DayCellContainer, {
        elRef: this.handleRootEl,
        date: startDate,
        dateProfile: dateProfile,
        todayRange: todayRange
      }, function (InnerContent, renderProps, elAttrs) {
        return createElement(Popover, {
          elRef: elAttrs.ref,
          id: props.id,
          title: title,
          extraClassNames: ['fc-more-popover'].concat(elAttrs.className || []),
          extraAttrs: elAttrs
          /* TODO: make these time-based when not whole-day? */
          ,
          parentEl: props.parentEl,
          alignmentEl: props.alignmentEl,
          alignGridTop: props.alignGridTop,
          onClose: props.onClose
        }, hasCustomDayCellContent(options) && createElement(InnerContent, {
          elTag: "div",
          elClasses: ['fc-more-popover-misc']
        }), props.children);
      });
    }
  }, {
    key: "queryHit",
    value: function queryHit(positionLeft, positionTop, elWidth, elHeight) {
      var rootEl = this.rootEl,
          props = this.props;

      if (positionLeft >= 0 && positionLeft < elWidth && positionTop >= 0 && positionTop < elHeight) {
        return {
          dateProfile: props.dateProfile,
          dateSpan: Object.assign({
            allDay: !props.forceTimed,
            range: {
              start: props.startDate,
              end: props.endDate
            }
          }, props.extraDateSpan),
          dayEl: rootEl,
          rect: {
            left: 0,
            top: 0,
            right: elWidth,
            bottom: elHeight
          },
          layer: 1 // important when comparing with hits from other components

        };
      }

      return null;
    }
  }]);

  return MorePopover;
}(DateComponent);

var MoreLinkContainer = /*#__PURE__*/function (_BaseComponent15) {
  _inherits(MoreLinkContainer, _BaseComponent15);

  var _super24 = _createSuper(MoreLinkContainer);

  function MoreLinkContainer() {
    var _this27;

    _classCallCheck(this, MoreLinkContainer);

    _this27 = _super24.apply(this, arguments);
    _this27.state = {
      isPopoverOpen: false,
      popoverId: getUniqueDomId()
    };

    _this27.handleLinkEl = function (linkEl) {
      _this27.linkEl = linkEl;

      if (_this27.props.elRef) {
        setRef(_this27.props.elRef, linkEl);
      }
    };

    _this27.handleClick = function (ev) {
      var _assertThisInitialize = _assertThisInitialized(_this27),
          props = _assertThisInitialize.props,
          context = _assertThisInitialize.context;

      var moreLinkClick = context.options.moreLinkClick;
      var date = computeRange(props).start;

      function buildPublicSeg(seg) {
        var _seg$eventRange3 = seg.eventRange,
            def = _seg$eventRange3.def,
            instance = _seg$eventRange3.instance,
            range = _seg$eventRange3.range;
        return {
          event: new EventImpl(context, def, instance),
          start: context.dateEnv.toDate(range.start),
          end: context.dateEnv.toDate(range.end),
          isStart: seg.isStart,
          isEnd: seg.isEnd
        };
      }

      if (typeof moreLinkClick === 'function') {
        moreLinkClick = moreLinkClick({
          date: date,
          allDay: Boolean(props.allDayDate),
          allSegs: props.allSegs.map(buildPublicSeg),
          hiddenSegs: props.hiddenSegs.map(buildPublicSeg),
          jsEvent: ev,
          view: context.viewApi
        });
      }

      if (!moreLinkClick || moreLinkClick === 'popover') {
        _this27.setState({
          isPopoverOpen: true
        });
      } else if (typeof moreLinkClick === 'string') {
        // a view name
        context.calendarApi.zoomTo(date, moreLinkClick);
      }
    };

    _this27.handlePopoverClose = function () {
      _this27.setState({
        isPopoverOpen: false
      });
    };

    return _this27;
  }

  _createClass(MoreLinkContainer, [{
    key: "render",
    value: function render() {
      var _this28 = this;

      var props = this.props,
          state = this.state;
      return createElement(ViewContextType.Consumer, null, function (context) {
        var viewApi = context.viewApi,
            options = context.options,
            calendarApi = context.calendarApi;
        var moreLinkText = options.moreLinkText;
        var moreCnt = props.moreCnt;
        var range = computeRange(props);
        var text = typeof moreLinkText === 'function' // TODO: eventually use formatWithOrdinals
        ? moreLinkText.call(calendarApi, moreCnt) : "+".concat(moreCnt, " ").concat(moreLinkText);
        var hint = formatWithOrdinals(options.moreLinkHint, [moreCnt], text);
        var renderProps = {
          num: moreCnt,
          shortText: "+".concat(moreCnt),
          text: text,
          view: viewApi
        };
        return createElement(Fragment, null, Boolean(props.moreCnt) && createElement(ContentContainer, {
          elTag: props.elTag || 'a',
          elRef: _this28.handleLinkEl,
          elClasses: [].concat(_toConsumableArray(props.elClasses || []), ['fc-more-link']),
          elStyle: props.elStyle,
          elAttrs: Object.assign(Object.assign(Object.assign({}, props.elAttrs), createAriaClickAttrs(_this28.handleClick)), {
            title: hint,
            'aria-expanded': state.isPopoverOpen,
            'aria-controls': state.isPopoverOpen ? state.popoverId : ''
          }),
          renderProps: renderProps,
          generatorName: "moreLinkContent",
          customGenerator: options.moreLinkContent,
          defaultGenerator: props.defaultGenerator || renderMoreLinkInner,
          classNameGenerator: options.moreLinkClassNames,
          didMount: options.moreLinkDidMount,
          willUnmount: options.moreLinkWillUnmount
        }, props.children), state.isPopoverOpen && createElement(MorePopover, {
          id: state.popoverId,
          startDate: range.start,
          endDate: range.end,
          dateProfile: props.dateProfile,
          todayRange: props.todayRange,
          extraDateSpan: props.extraDateSpan,
          parentEl: _this28.parentEl,
          alignmentEl: props.alignmentElRef ? props.alignmentElRef.current : _this28.linkEl,
          alignGridTop: props.alignGridTop,
          forceTimed: props.forceTimed,
          onClose: _this28.handlePopoverClose
        }, props.popoverContent()));
      });
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.updateParentEl();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.updateParentEl();
    }
  }, {
    key: "updateParentEl",
    value: function updateParentEl() {
      if (this.linkEl) {
        this.parentEl = elementClosest(this.linkEl, '.fc-view-harness');
      }
    }
  }]);

  return MoreLinkContainer;
}(BaseComponent);

function renderMoreLinkInner(props) {
  return props.text;
}

function computeRange(props) {
  if (props.allDayDate) {
    return {
      start: props.allDayDate,
      end: addDays(props.allDayDate, 1)
    };
  }

  var hiddenSegs = props.hiddenSegs;
  return {
    start: computeEarliestSegStart(hiddenSegs),
    end: computeLatestSegEnd(hiddenSegs)
  };
}

function computeEarliestSegStart(segs) {
  return segs.reduce(pickEarliestStart).eventRange.range.start;
}

function pickEarliestStart(seg0, seg1) {
  return seg0.eventRange.range.start < seg1.eventRange.range.start ? seg0 : seg1;
}

function computeLatestSegEnd(segs) {
  return segs.reduce(pickLatestEnd).eventRange.range.end;
}

function pickLatestEnd(seg0, seg1) {
  return seg0.eventRange.range.end > seg1.eventRange.range.end ? seg0 : seg1;
}

var Store = /*#__PURE__*/function () {
  function Store() {
    _classCallCheck(this, Store);

    this.handlers = [];
  }

  _createClass(Store, [{
    key: "set",
    value: function set(value) {
      this.currentValue = value;

      var _iterator38 = _createForOfIteratorHelper(this.handlers),
          _step38;

      try {
        for (_iterator38.s(); !(_step38 = _iterator38.n()).done;) {
          var handler = _step38.value;
          handler(value);
        }
      } catch (err) {
        _iterator38.e(err);
      } finally {
        _iterator38.f();
      }
    }
  }, {
    key: "subscribe",
    value: function subscribe(handler) {
      this.handlers.push(handler);

      if (this.currentValue !== undefined) {
        handler(this.currentValue);
      }
    }
  }]);

  return Store;
}();
/*
Subscribers will get a LIST of CustomRenderings
*/


var CustomRenderingStore = /*#__PURE__*/function (_Store) {
  _inherits(CustomRenderingStore, _Store);

  var _super25 = _createSuper(CustomRenderingStore);

  function CustomRenderingStore() {
    var _this29;

    _classCallCheck(this, CustomRenderingStore);

    _this29 = _super25.apply(this, arguments);
    _this29.map = new Map();
    return _this29;
  } // for consistent order


  _createClass(CustomRenderingStore, [{
    key: "handle",
    value: function handle(customRendering) {
      var map = this.map;
      var updated = false;

      if (customRendering.isActive) {
        map.set(customRendering.id, customRendering);
        updated = true;
      } else if (map.has(customRendering.id)) {
        map["delete"](customRendering.id);
        updated = true;
      }

      if (updated) {
        this.set(map);
      }
    }
  }]);

  return CustomRenderingStore;
}(Store);

export { elementClosest as $, memoizeObjArg as A, BaseComponent as B, ContentContainer as C, DelayedRunner as D, isPropsEqual as E, Emitter as F, getInitialDate as G, rangeContainsMarker as H, createEmptyEventStore as I, reduceCurrentDate as J, reduceEventStore as K, rezoneEventStoreDates as L, mergeRawOptions as M, BASE_OPTION_REFINERS as N, CALENDAR_LISTENER_REFINERS as O, CALENDAR_OPTION_REFINERS as P, COMPLEX_OPTION_COMPARATORS as Q, VIEW_OPTION_REFINERS as R, DateEnv as S, Theme as T, DateProfileGenerator as U, ViewContextType as V, createEventUi as W, parseBusinessHours as X, setRef as Y, Interaction as Z, getElSeg as _, mapHash as a, getSlotClassNames as a$, EventImpl as a0, listenBySelector as a1, listenToHoverBySelector as a2, PureComponent as a3, buildViewContext as a4, getUniqueDomId as a5, parseInteractionSettings as a6, interactionSettingsStore as a7, getNow as a8, CalendarImpl as a9, diffDates as aA, removeExact as aB, memoizeArraylike as aC, memoizeHashlike as aD, intersectRects as aE, pointInsideRect as aF, constrainPoint as aG, getRectCenter as aH, diffPoints as aI, translateRect as aJ, compareObjs as aK, collectFromHash as aL, findElements as aM, findDirectChildren as aN, removeElement as aO, applyStyle as aP, elementMatches as aQ, getEventTargetViaRoot as aR, parseClassNames as aS, getCanVGrowWithinCell as aT, mergeEventStores as aU, getRelevantEvents as aV, eventTupleToStore as aW, combineEventUis as aX, Splitter as aY, getDayClassNames as aZ, getDateMeta as a_, flushSync as aa, CalendarRoot as ab, RenderId as ac, ensureElHasStyles as ad, applyStyleProp as ae, sliceEventStore as af, JsonRequestError as ag, createContext as ah, refineProps as ai, createEventInstance as aj, parseEventDef as ak, refineEventDef as al, padStart as am, isInt as an, parseFieldSpecs as ao, compareByFieldSpecs as ap, flexibleCompare as aq, preventSelection as ar, allowSelection as as, preventContextMenu as at, allowContextMenu as au, compareNumbers as av, enableCursor as aw, disableCursor as ax, computeVisibleDayRange as ay, isMultiDayRange as az, buildViewClassNames as b, SimpleScrollGrid as b$, buildNavLinkAttrs as b0, preventDefault as b1, whenTransitionDone as b2, computeInnerRect as b3, computeEdges as b4, getClippingParents as b5, computeRect as b6, rangesEqual as b7, rangesIntersect as b8, rangeContainsRange as b9, SegHierarchy as bA, buildEntryKey as bB, getEntrySpanEnd as bC, binarySearch as bD, groupIntersectingEntries as bE, intersectSpans as bF, interactionSettingsToStore as bG, ElementDragging as bH, config as bI, parseDragMeta as bJ, DayHeader as bK, computeFallbackHeaderFormat as bL, TableDateCell as bM, TableDowCell as bN, DaySeriesModel as bO, hasBgRendering as bP, buildSegTimeText as bQ, sortEventSegs as bR, getSegMeta as bS, buildEventRangeKey as bT, getSegAnchorAttrs as bU, DayTableModel as bV, Slicer as bW, applyMutationToEventStore as bX, isPropsValid as bY, isInteractionValid as bZ, isDateSelectionValid as b_, PositionCache as ba, ScrollController as bb, ElementScrollController as bc, WindowScrollController as bd, DateComponent as be, isDateSpansEqual as bf, addMs as bg, addWeeks as bh, diffWeeks as bi, diffWholeWeeks as bj, diffDayAndTime as bk, diffDays as bl, isValidDate as bm, asCleanDays as bn, multiplyDuration as bo, addDurations as bp, asRoughMinutes as bq, asRoughSeconds as br, asRoughMs as bs, wholeDivideDurations as bt, formatIsoTimeString as bu, formatDayString as bv, buildIsoString as bw, formatIsoMonthStr as bx, NamedTimeZoneImpl as by, _parse as bz, greatestDurationDenominator as c, hasShrinkWidth as c0, renderMicroColGroup as c1, getScrollGridClassNames as c2, getSectionClassNames as c3, getSectionHasLiquidHeight as c4, getAllowYScrolling as c5, renderChunkContent as c6, _computeShrinkWidth as c7, sanitizeShrinkWidth as c8, isColPropsEqual as c9, renderScrollShim as ca, getStickyFooterScrollbar as cb, getStickyHeaderDates as cc, Scroller as cd, getScrollbarWidths as ce, RefMap as cf, getIsRtlScrollbarOnLeft as cg, NowTimer as ch, ScrollResponder as ci, StandardEvent as cj, NowIndicatorContainer as ck, DayCellContainer as cl, hasCustomDayCellContent as cm, EventContainer as cn, renderFill as co, BgEvent as cp, WeekNumberContainer as cq, MoreLinkContainer as cr, computeEarliestSegStart as cs, ViewContainer as ct, triggerDateSelect as cu, getDefaultEventEnd as cv, injectStyles as cw, buildElAttrs as cx, CustomRenderingStore as cy, createDuration as d, BASE_OPTION_DEFAULTS as e, arrayToHash as f, guid as g, filterHash as h, isArraysEqual as i, buildEventSourceRefiners as j, formatWithOrdinals as k, buildRangeApiWithTimeZone as l, mergeProps as m, identity as n, intersectRanges as o, parseEventSource as p, startOfDay as q, requestJson as r, subtractDurations as s, addDays as t, unpromisify as u, hashValuesToArray as v, buildEventApis as w, createFormatter as x, diffWholeDays as y, memoize as z };